import {
  FaWallet,
  FaRegClock,
  FaRegUser,
  FaFileInvoiceDollar,
} from "react-icons/fa";
import { BiWalletAlt, BiTransfer } from "react-icons/bi";
import { AiOutlineDollarCircle } from "react-icons/ai";
import { CgKeyhole } from "react-icons/cg";
import { TbTransferIn } from "react-icons/tb";
import { IoMdSettings } from "react-icons/io";
import { MdOutlineAccountBalance, MdOutlineWhatsapp } from "react-icons/md";
import HomeIcon from "../assets/images/home.png";
import casinoIcon from "../assets/images/casino.png";
import sportIcon from "../assets/images/sports.png";
import leadgeIcon from "../assets/images/leadge.png";
import betsIcon from "../assets/images/mybets.png";
import gameImage from "../assets/images/game1.png";
import gameImage1 from "../assets/images/game2.png";
import gameImage2 from "../assets/images/game3.png";
import gameImage3 from "../assets/images/game4.png";
import gameImage4 from "../assets/images/game5.png";

import banner1 from "../assets/images/banner-3.webp";
import banner2 from "../assets/images/kv-casino.webp";
import banner3 from "../assets/images/kv-netent.webp";
import banner4 from "../assets/images/kv-spribe.webp";
import banner5 from "../assets/images/kv-JDB-e-game.webp";
import banner6 from "../assets/images/kv-hotroad.webp";
import banner7 from "../assets/images/kv-smartsoft.webp";

// hotgame Image
import jilifortunegems500 from "../assets/images/hot-casino/provider-jilifortunegems500.png";
import jililuckytiger from "../assets/images/hot-casino/provider-jililuckytiger.png";
import jilisuperace from "../assets/images/hot-casino/provider-jilisuperace.png";
import crashaviatorheyvip from "../assets/images/hot-casino/provider-crashaviatorheyvip.png";
import superelementsfc from "../assets/images/hot-casino/provider-superelementsfc.png";
import jiliboxingking from "../assets/images/hot-casino/provider-jiliboxingking.png";
import aviator2 from "../assets/images/hot-casino/provider-aviator2.png";
import wmatchodds from "../assets/images/hot-casino/provider-9wmatchodds.png";
import jilisuperacedeluxe from "../assets/images/hot-casino/provider-jilisuperacedeluxe.png";
import jilifortunegems2 from "../assets/images/hot-casino/provider-jilifortunegems2.png";
import jilimoneycoming from "../assets/images/hot-casino/provider-jilimoneycoming.png";
import evocrazytime from "../assets/images/hot-casino/provider-evocrazytime.png";
import jilifortunegems3 from "../assets/images/hot-casino/provider-jilifortunegems3.png";
import pgwildbountry from "../assets/images/hot-casino/provider-pgwildbountry.png";
import jilifortunegems from "../assets/images/hot-casino/provider-jilifortunegems.png";
import jili7up7down from "../assets/images/hot-casino/provider-jili7up7down.png";
import magicacewildlock from "../assets/images/hot-casino/provider-magicacewildlock.png";
import ybcrazymoney from "../assets/images/hot-casino/provider-ybcrazymoney.png";
import r88moneyrolling from "../assets/images/hot-casino/provider-r88moneyrolling.png";
import jilimegaace from "../assets/images/hot-casino/provider-jilimegaace.png";
import jilimoneycomingEB from "../assets/images/hot-casino/provider-jilimoneycomingEB.png";
import jilicrazy777 from "../assets/images/hot-casino/provider-jilicrazy777.png";
import jiliwildace from "../assets/images/hot-casino/provider-jiliwildace.png";
import jdbpiggybank from "../assets/images/hot-casino/provider-jdbpiggybank.png";
import jilichargebuffalo from "../assets/images/hot-casino/provider-jilichargebuffalo.png";
import jdbmagicace from "../assets/images/hot-casino/provicer-jdbmagicace.png";
import ybroyalae from "../assets/images/hot-casino/provider-ybroyalae.png";
import ybrolling7 from "../assets/images/hot-casino/provider-ybrolling7.png";
import r88luckace from "../assets/images/hot-casino/provider-r88luckace.png";
import r88777 from "../assets/images/hot-casino/provider-r88777.png";
export const sidebarData = [
  {
    firstLevel: [
      {
        id: 1,
        menu: "Deposit",
        icon: <i class="icon icon-funds"></i>,
        link: "/deposit",
      },
      {
        id: 2,
        menu: "Payment Transfer log",
        icon: <i class="icon icon-payment-transfer-log"></i>,
        link: "/p2p-transfer-log",
      },
    ],

    secondLevel: [
      {
        id: 1,
        menu: "Upline Whatsapp Number",
        icon: <i class="icon icon-whatsapp-line"></i>,
        link: "/upline-whatsapp-number",
      },
      {
        id: 2,
        menu: "Balance Overview",
        icon: <i class="icon icon-wallet"></i>,
        link: "/balance-overview",
      },
      {
        id: 3,
        menu: "Account Statement",
        icon: <MdOutlineAccountBalance />,
        link: "/account-statement",
      },
      {
        id: 4,
        menu: "Current Bets",
        icon: <i class="icon icon-list"></i>,

        link: "/current-bets",
      },
      {
        id: 5,
        menu: "Bets History",
        icon: <i class="icon icon-history"></i>,
        link: "/bets-history",
      },
      {
        id: 6,
        menu: "Profit & Loss",
        icon: <i class="icon icon-profit-loss"></i>,
        link: "/profit-and-loss",
      },
      {
        id: 7,
        menu: "Active Log",
        icon: <i class="icon icon-active-log"></i>,
        link: "/active-log",
      },
      {
        id: 8,
        menu: "My Profile",
        icon: <i class="icon icon-profile"></i>,
        link: "/my-profile",
      },
    ],
  },

  {
    thirdLevel: [
      {
        id: 8,
        menu: "P2P Transfer",
        icon: <i class="icon icon-transfer"></i>,
        link: "/p2p-transfer",
      },
      {
        id: 9,
        menu: "P2P Transfer log",
        icon: <i class="icon icon-transfer-log"></i>,
        link: "/p2p-transfer-log",
      },
    ],
  },

  {
    fourthLevel: [
       {
        id: 10,
        menu: "Spin Report",
        icon: <i class="icon icon-catalog"></i>,
        link: "/spin-report",
      },
        {
        id: 11,
        menu: "Referral",
        icon: <i class="icon icon-pdf"></i>,
        link: "/referral",
      },
      {
        id: 12,
        menu: "Setting",
        icon: <i class="icon icon-setting"></i>,
        link: "/setting",
      },
    ],
  },
];

export const bottomNavigation = [
  {
    id: "1",
    menu: "Home",
    icon: HomeIcon,
    link: "/",
  },
  {
    id: "2",
    menu: "Casino",
    icon: casinoIcon,
    link: "/casino",
  },
  {
    id: "3",
    menu: "Sports",
    icon: sportIcon,
    link: "/sports",
  },
  {
    id: "4",
    menu: "Leagues",
    icon: leadgeIcon,
    link: "/leagues",
  },
  {
    id: "5",
    menu: "My Bets",
    icon: betsIcon,
  },
];

export const gamesLiveArray = [

  {
    img: "../assets/images/game-shows/GAME-SHOW-5.webp",
    name: "Crazy Time",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-006",
    cateogry: "HOT",
    type: "HOT",
    isPopular: true,
  },
  {
    img: "../assets/images/game-shows/GAME-SHOW-11.webp",
    name: "Monopoly Live",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-007",
    cateogry: "HOT",
    type: "HOT",
    isPopular: true,
  },
  {
    img: "../assets/images/game-shows/GAME-SHOW-3.webp",
    name: "Funky Time",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-183",
    cateogry: "HOT",
    type: "HOT",
    isPopular: true,
  },
     {
    img: "../assets/images/game-shows/EVOLUTION-LIVE-204.webp",
    name: "Andar Bahar",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-204",
    cateogry: "HOT",
    type: "HOT",
    isPopular: true,
  },
   {
    img: "../assets/images/Egame/JDB-EGAME-011.webp",
    name: "Jogo Do Bicho",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-013",
    cateogry: "HOT",
    type: "HOT",
    isPopular: true,
  },
  {
    img: "../assets/images/Egame/JDB-EGAME-010.webp",
    name: "Beer Tycoon",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-014",
    cateogry: "HOT",
     type: "HOT",
    isPopular: true,
  },

  {
    img: "../assets/images/Egame/JDB-EGAME-002.webp",
    name: "Lucky Color Game",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-009",
    cateogry: "HOT",
     type: "HOT",
    isPopular: true,
  },
  {
    img: "../assets/images/Egame/JDB-EGAME-006.webp",
    name: "King Of Football",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-010",
    cateogry: "HOT",
     type: "HOT",
    isPopular: true,
  },
  {
    img: "../assets/images/Egame/JDB-EGAME-001.webp",
    name: "Crazy King Kong",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-011",
    cateogry: "HOT",
     type: "HOT",
    isPopular: true,
  },

  {
    img: "../assets/images/Egame/JDB-EGAME-007.webp",
    name: "Super Super Fruit",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-012",
    cateogry: "HOT",
    type: "HOT",
    isPopular: true,
  },

{
    img: "../assets/images/JILI/JILI-TABLE-041.png",
    name: "Plinko",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-041",
    cateogry: "HOT",
   type: "HOT",
    isPopular: true,
  },

{
    img: "../assets/images/JILI/JILI-TABLE-032.webp",
    name: "HILO",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-032",
    cateogry: "HOT",
   type: "HOT",
    isPopular: true,
  },
 {
    img: "../assets/images/slot/JILI-SLOT-029.webp",
    name: "Money Coming",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-029",
    cateogry: "HOT",
    type: "HOT",
    isPopular: true,
  },
{
    img: "../assets/images/slot/JILI-SLOT-017.webp",
    name: "Crazy FaFaFa",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-017",
    cateogry: "HOT",
    type: "HOT",
    isPopular: true,
  },
{
    img: "../assets/images/JILI/JILI-TABLE-005.webp",
    name: "NumberKing",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-005",
    cateogry: "JIHOTLI",
    type: "HOT",
    isPopular: true,
  },
{
    img: "../assets/images/slot/JILI-SLOT-027.webp",
    name: "Super Ace",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-027",
    cateogry: "HOT",
    type: "HOT",
    isPopular: true,
  },

 {
    img: "../assets/images/Table/KM-TABLE-021.webp",
    name: "Number Matka",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-021",
    cateogry: "KINGMAKER",
     type: "HOT",
    isPopular: true,
  },
  {
    img: "../assets/images/Table/KM-TABLE-032.webp",
    name: "Andar Bahar",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-032",
    cateogry: "KINGMAKER",
     type: "HOT",
    isPopular: true,
  },

  {
    img: "../assets/images/Table/TABLE-6.webp",
    name: "Coin Toss",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-036",
    cateogry: "KINGMAKER",
     type: "HOT",
    isPopular: true,
  },

 {
    img: "../assets/images/Egame/PP-EGAME-007.webp",
    name: "Darts",
    platForm: "PP",
    gameType: "EGAME",
    casinoType: "PP-EGAME-007",
    cateogry: "HOT",
     type: "HOT",
    isPopular: true,
  },
 {
    img: "../assets/images/Egame/PP-EGAME-006.webp",
    name: "Force 1",
    platForm: "PP",
    gameType: "EGAME",
    casinoType: "PP-EGAME-006",
    cateogry: "HOT",
     type: "HOT",
    isPopular: true,
  },
{
    img: "../assets/images/Egame/PP-EGAME-005.webp",
    name: "Greyhound Racing",
    platForm: "PP",
    gameType: "EGAME",
    casinoType: "PP-EGAME-005",
    cateogry: "HOT",
     type: "HOT",
    isPopular: true,
  },
{
    img: "../assets/images/Egame/PP-EGAME-004.webp",
    name: "Fantastic League",
    platForm: "PP",
    gameType: "EGAME",
    casinoType: "PP-EGAME-004",
    cateogry: "HOT",
     type: "HOT",
    isPopular: true,
  },
{
    img: "../assets/images/Egame/PP-EGAME-003.webp",
    name: "Horse Racing",
    platForm: "PP",
    gameType: "EGAME",
    casinoType: "PP-EGAME-002",
    cateogry: "HOT",
     type: "HOT",
    isPopular: true,
  },
{
    img: "../assets/images/Egame/PP-EGAME-002.webp",
    name: "Penalty Shootout",
    platForm: "PP",
    gameType: "EGAME",
    casinoType: "PP-EGAME-002",
    cateogry: "HOT",
     type: "HOT",
    isPopular: true,
  },

{
    img: "../assets/images/Egame/PP-LIVE-025.webp",
    name: "Mega Sic Bo",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-025",
    cateogry: "HOT",
     type: "HOT",
    isPopular: true,
  },
  {
    img: "../assets/images/Egame/PP-LIVE-038.webp",
    name: "Mega WHeel",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-038",
    cateogry: "PP",
     type: "HOT",
    isPopular: true,
  },

{
    img: "../assets/images/Baccarat/BACCARAT-7.webp",
    name: "Baccarat Classic",
    table: "1",
    platForm: "SEXYBCRT",
    gameType: "LIVE",
    casinoType: "MX-LIVE-001",
    cateogry: "SEXY",
    type: "HOT",
    isPopular: true,
  },
{
    img: "../assets/images/Egame/22004.png",
    name: "Plinko",
    platForm: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-004",
    cateogry: "SPRIBE",
    type: "HOT",
    isPopular: true,
  },
{
    img: "../assets/images/Egame/22008.png",
    name: "Mini Roulette",
    platForm: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-008",
     cateogry: "SPRIBE",
   type: "HOT",
    isPopular: true,
  },
  {
    img: "../assets/images/Egame/22005.png",
    name: "Mines",
    platForm: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-005",
     cateogry: "SPRIBE",
   type: "HOT",
    isPopular: true,
  },
  {
    img: "../assets/images/Egame/22006.png",
    name: "Spribe Hilo",
    platForm: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-006",
     cateogry: "SPRIBE",
   type: "HOT",
    isPopular: true,
  },
  
 {
    img: "../assets/images/Egame/22001.png",
    name: "Aviator",
    platForm: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-001",
    cateogry: "SPRIBE",
   type: "HOT",
    isPopular: true,
  },


      //----------------------BNG GAME START----------------//
         {
        id:1,
        img: '../assets/images/BNG/BNG087.webp',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },

     {
        id:2,
        img: '../assets/images/BNG/BNG074.webp',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: '../assets/images/BNG/BNG075.webp',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: '../assets/images/BNG/BNG071.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },

        {
        id:2,
        img: '../assets/images/BNG/BNG098.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
    {
        id:2,
        img: '../assets/images/BNG/BNG084.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },

{
        id:2,
        img: '../assets/images/BNG/BNG105.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },

{
        id:2,
        img: '../assets/images/BNG/BNG086.webp',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
{
        id:2,
        img: '../assets/images/BNG/BNG066.webp',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
{
        id:2,
        img: '../assets/images/BNG/BNG107.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },

      {
        id:2,
        img: '../assets/images/BNG/BNG094.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: '../assets/images/BNG/BNG092.webp',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },

         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG068.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },

          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG093.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG115.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
           {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG070.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
             {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG055.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
              {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG032.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
               {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG126.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG082.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },

        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG175.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG174.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG173.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG172.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG171.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG170.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG169.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG168.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG167.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG166.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG165.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG164.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG163.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG162.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG161.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG160.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG159.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG158.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG157.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG156.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG155.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG154.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG153.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG152.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG151.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG150.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG149.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG148.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG147.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG146.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG145.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG144.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG143.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG142.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG141.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG140.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG139.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG138.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG137.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG136.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG135.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG134.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG133.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG132.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG131.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG130.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG129.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG128.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG127.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG126.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG125.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG124.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG123.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
  {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG122.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG121.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG120.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG119.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG118.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG117.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG116.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG115.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG114.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG113.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG112.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG111.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG110.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG109.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG108.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG107.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG106.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG105.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG104.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG103.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG102.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG101.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG096.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG095.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG090.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG089.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG088.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG085.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG083.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG080.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG079.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG078.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG077.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG076.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG073.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG072.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG067.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG064.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG063.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG062.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG061.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG060.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG059.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG057.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG056.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG054.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG051.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG049.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG047.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG042.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG041.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG040.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG039.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG038.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },

      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG036.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG035.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG033.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG029.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG028.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG027.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG026.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG025.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },

{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG023.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG021.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
     {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG019.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
 {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG018.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
 {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG016.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
 {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG015.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG013.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG011.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG010.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG009.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG008.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },

{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG007.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },

{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG004.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },

{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BNG/EN/BNG002.png',
        name: "777",
        cateogry: "BNG",
        type: "BNG",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },

      //bng game end----------------//
    

      
// -------------------CRASH SPRIBE START-----------------];



{
  img: "../assets/images/crash/spribe/SPRIBE-EGAME-001.png",
  name: "Aviator",
  cateogry:"SPRIBE",
  type:"CRASH",
  platForm: "SPRIBE",
  gameType: "EGAME",
  casinoType: "SPRIBE-EGAME-001",
},

// -------------------CRASH SPRIBE END-----------------];


// -------------------CRASH JILI START-----------------];
{
  img: "../assets/images/crash/jili/JILI-TABLE-047.png",
  name: "Crash Bonus",
  cateogry:"JILI",
  type:"CRASH",
  platForm: "JILI",
  gameType: "TABLE",
  casinoType: "JILI-TABLE-047",
},
{
  img: "../assets/images/crash/jili/JILI-TABLE-058.png",
  name: "Crash Cricket",
  cateogry:"JILI",
  type:"CRASH",
  platForm: "JILI",
  gameType: "TABLE",
  casinoType: "JILI-TABLE-058",
},
{
  img: "../assets/images/crash/jili/JILI-TABLE-030.png",
  name: "Go Rush",
  cateogry:"JILI",
  type:"CRASH",
  platForm: "JILI",
  gameType: "TABLE",
  casinoType: "JILI-TABLE-030",
},
{
  img: "../assets/images/crash/jili/JILI-TABLE-035.png",
  name: "Limbo",
  cateogry:"JILI",
  type:"CRASH",
  platForm: "JILI",
  gameType: "TABLE",
  casinoType: "JILI-TABLE-035",
},
{
  img: "../assets/images/crash/jili/JILI-TABLE-055.png",
  name: "Crash Goal",
  cateogry:"JILI",
  type:"CRASH",
  platForm: "JILI",
  gameType: "TABLE",
  casinoType: "JILI-TABLE-055",
},
// -------------------CRASH JILI END-----------------];

// -------------------CRASH PP START-----------------];

{
  img: "../assets/images/crash/pp/PP-EGAME-008.png",
  name: "High Flyer ",
  cateogry:"PP",
  type:"CRASH",
  platForm: "PP",
  gameType: "EGAME",
  casinoType: "PP-EGAME-008",
},
{
  img: "../assets/images/crash/pp/PP-EGAME-001.png",
  name: "Spaceman",
  cateogry:"PP",
  type:"CRASH",
  platForm: "PP",
  gameType: "EGAME",
  casinoType: "PP-EGAME-001",
},
{
  img: "../assets/images/crash/pp/PP-EGAME-009.png",
  name: "Big Bass Crash",
  cateogry:"PP",
  type:"CRASH",
  platForm: "PP",
  gameType: "EGAME",
  casinoType: "PP-EGAME-009",
},
// -------------------CRASH PP END-----------------];

// -------------------CRASH KINGMAKER START-----------------];

{
  img: "../assets/images/crash/kingmaker/KM-TABLE-041.png",
  name: "Cash Rocket",
  cateogry:"KINGMAKER",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-041",
},
{
  img: "../assets/images/crash/kingmaker/KM-TABLE-069.png",
  name: "Elite Aviator Club",
  cateogry:"KINGMAKER",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-069",
},
{
  img: "../assets/images/crash/kingmaker/KM-TABLE-070.png",
  name: "Interstellar Run",
  cateogry:"KINGMAKER",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-070",
},
{
  img: "../assets/images/crash/kingmaker/KM-TABLE-075.png",
  name: "Iron Dome",
  cateogry:"KINGMAKER",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-075",
},
{
  img: "../assets/images/crash/kingmaker/KM-TABLE-076.png",
  name: "TOON CRASH",
  cateogry:"KINGMAKER",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},
// -------------------CRASH KINGMAKER END-----------------];
// -------------------CRASH GEMINI START-----------------];
{
  img: "../assets/images/crash/gemini/GM0052.webp",
  name: "TOON CRASH",
  cateogry:"GEMINI",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},
{
  img: "../assets/images/crash/gemini/GM0033.webp",
  name: "TOON CRASH",
  cateogry:"GEMINI",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},
{
  img: "../assets/images/crash/gemini/GM0027.webp",
  name: "TOON CRASH",
  cateogry:"GEMINI",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},
{
  img: "../assets/images/crash/gemini/GM0020.webp",
  name: "TOON CRASH",
  cateogry:"GEMINI",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},
{
  img: "../assets/images/crash/gemini/GM0015.webp",
  name: "TOON CRASH",
  cateogry:"GEMINI",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},
// -------------------CRASH GEMINI END-----------------];


// -------------------CRASH PASCAL START-----------------];
{
  img: "../assets/images/crash/pascal/PAS092.webp",
  name: "TOON CRASH",
  cateogry:"PASCAL",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},
{
  img: "../assets/images/crash/pascal/PAS067.webp",
  name: "TOON CRASH",
  cateogry:"PASCAL",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},
{
  img: "../assets/images/crash/pascal/PAS014.webp",
  name: "TOON CRASH",
  cateogry:"PASCAL",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},
{
  img: "../assets/images/crash/pascal/PAS013.webp",
  name: "TOON CRASH",
  cateogry:"PASCAL",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},

// -------------------CRASH PASCAL END-----------------];

// -------------------CRASH EG START-----------------];
{
  img: "../assets/images/crash/easygaming/EZG021.webp",
  name: "TOON CRASH",
  cateogry:"EG",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},



// -------------------CRASH EG END-----------------];
// -------------------CRASH MG START-----------------];
{
  img: "../assets/images/crash/mg/MG0436.webp",
  name: "TOON CRASH",
  cateogry:"MG",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},
{
  img: "../assets/images/crash/mg/MG0508.webp",
  name: "TOON CRASH",
  cateogry:"MG",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},



// -------------------CRASH MG END-----------------];
// -------------------CRASH MG START-----------------];
{
  img: "../assets/images/crash/SMARTSOFT/SS0059.webp",
  name: "TOON CRASH",
  cateogry:"SMARTSOFT",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},
{
  img: "../assets/images/crash/SMARTSOFT/SS0054.webp",
  name: "TOON CRASH",
  cateogry:"SMARTSOFT",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},
{
  img: "../assets/images/crash/SMARTSOFT/SS0012.webp",
  name: "TOON CRASH",
  cateogry:"SMARTSOFT",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},

{
  img: "../assets/images/crash/SMARTSOFT/SS0011.webp",
  name: "TOON CRASH",
  cateogry:"SMARTSOFT",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},

{
  img: "../assets/images/crash/SMARTSOFT/SS0007.webp",
  name: "TOON CRASH",
  cateogry:"SMARTSOFT",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},

{
  img: "../assets/images/crash/SMARTSOFT/SS0002.webp",
  name: "TOON CRASH",
  cateogry:"SMARTSOFT",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},
{
  img: "../assets/images/crash/SMARTSOFT/SS0014.webp",
  name: "TOON CRASH",
  cateogry:"SMARTSOFT",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},
// -------------------CRASH MG END-----------------];


// -------------------CRASH BGAMING START-----------------];
{
  img: "../assets/images/crash/BGAMING/BGA163.webp",
  name: "TOON CRASH",
  cateogry:"BGAMING",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},
{
  img: "../assets/images/crash/BGAMING/BGA077.webp",
  name: "TOON CRASH",
  cateogry:"BGAMING",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},

{
  img: "../assets/images/crash/BGAMING/BGA015.webp",
  name: "TOON CRASH",
  cateogry:"BGAMING",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},
{
  img: "../assets/images/crash/BGAMING/BGA014.webp",
  name: "TOON CRASH",
  cateogry:"BGAMING",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},
{
  img: "../assets/images/crash/BGAMING/BGA013.webp",
  name: "TOON CRASH",
  cateogry:"BGAMING",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},

// -------------------CRASH BGAMING END-----------------];


// -------------------CRASH YL START-----------------];
{
  img: "../assets/images/crash/YL/YL0023.webp",
  name: "TOON CRASH",
  cateogry:"BGAMING",
  type:"CRASH",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},


// -------------------CRASH YL END-----------------];

//----------BGAMING--------------------

{
        id:1,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA165.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      // {
      //   id:2,
      //   img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA163.png',
      //   name: "Infinity Pull",
      //   cateogry: "BGAMING",
      //   type: "ROYAL",
      //   gameTypeCheck: "platForm",
      //   platForm: "JDB",
      //   gameType: "SLOT",
      //   casinoType: "JDB-SLOT-041",
      // },

       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA162.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
 {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA161.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
 {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA160.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
 {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA159.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
 {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA158.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA155.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA154.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA153.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA152.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA151.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA150.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA149.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA148.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA146.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA145.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA144.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA143.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA140.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA138.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA135.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA134.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA125.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA124.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA123.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA122.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA116.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA115.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA114.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA113.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA112.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA111.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA110.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA109.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA108.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA106.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA105.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA104.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA104.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA103.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA102.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA101.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA100.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA099.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA098.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA097.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },

        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA096.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA095.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA094.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA093.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA092.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA091.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA090.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA089.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA088.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA087.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA086.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA085.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA084.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA083.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA082.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA081.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA080.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA079.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA078.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA077.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA076.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA075.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA074.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA073.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA072.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA071.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA070.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA069.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA069.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA068.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA067.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA066.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA065.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA064.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA063.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA062.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA061.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA060.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA059.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA058.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA057.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA056.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA055.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA054.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA053.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA052.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA051.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA050.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA049.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA048.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA047.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA046.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA045.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA044.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA043.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA042.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA041.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA040.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA039.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA038.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA037.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA036.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA035.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
    {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA034.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },    {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA033.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA032.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA031.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA030.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA029.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA028.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA027.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA026.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA025.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA024.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA023.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA022.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA021.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA020.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA019.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA018.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA017.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA016.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA015.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA014.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA013.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA012.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA011.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA010.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA009.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA008.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA007.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA006.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA005.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA004.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA003.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/BGA/EN/BGA002.png',
        name: "Infinity Pull",
        cateogry: "BGAMING",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
//--------------BGAMING----------------//
//--------------EVOPLAY----------------//

  {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0229.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0228.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0227.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0226.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0225.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0224.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0223.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0222.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0221.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0220.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0219.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0218.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0217.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0216.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0215.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0214.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0213.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0212.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0211.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0210.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0209.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0208.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0207.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0206.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0205.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0204.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0203.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0202.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0201.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0200.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0199.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0198.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
           {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0197.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
           {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0196.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
           {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0195.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
           {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0194.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
           {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0193.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
           {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0192.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
           {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0191.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
           {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0190.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0189.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0188.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0187.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0186.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0185.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0184.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0183.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0182.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0181.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
 {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0180.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      }, {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0179.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      }, {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0178.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0177.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0176.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0175.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0174.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0173.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0172.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0171.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0170.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0169.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0168.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0167.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0166.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0165.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0164.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
   {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0163.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },   {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0162.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },   {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0161.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0160.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
 {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0159.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0158.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0157.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0156.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0155.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0154.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0153.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0152.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0151.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0150.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
  {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0149.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },  {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0148.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },  {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0147.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },  {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0146.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },  {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0145.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },  {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0144.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },  {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0143.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },  {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0142.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },  {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0141.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },  {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0140.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0139.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },

      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0138.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0137.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0136.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0135.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0134.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0133.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0132.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0131.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0130.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0129.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0128.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },   {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0127.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },   {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0126.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },   {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0125.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },   {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0124.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },   {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0123.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },   {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0122.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },   {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0121.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },   {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0120.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },   {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0119.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },   {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0118.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },   {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0117.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0116.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0115.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0114.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0113.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0112.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0111.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0110.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0109.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0108.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0107.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0106.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0105.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0104.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0103.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0102.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0101.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
          {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0100.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0099.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0098.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0097.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0096.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0095.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0094.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0093.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0092.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0091.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0090.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0089.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0088.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0087.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0086.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0085.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0084.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0083.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0082.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0081.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0080.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0079.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0078.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0077.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
  {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0076.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },  {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0075.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },  {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0074.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },  {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0073.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },  {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0072.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },  {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0071.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },  {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0070.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0069.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0068.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0067.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0066.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0065.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0064.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0063.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0062.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0061.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0060.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
    {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0059.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0058.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0057.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0056.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0055.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
 {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0054.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
 {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0053.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
 {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0052.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
 {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0051.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
{
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0050.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0049.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0048.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0047.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0046.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0045.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0044.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0043.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0042.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0041.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0040.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0039.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0038.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0037.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0036.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0035.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0034.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0033.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0032.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0031.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0030.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0029.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0028.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0027.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0026.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0025.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0024.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
  {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0023.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0022.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0021.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0020.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0019.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },

        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0018.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
           {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0017.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
           {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0016.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
           {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0015.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
           {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0014.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
           {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0013.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
           {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0012.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0011.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
           {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0010.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
           {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0007.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
           {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0006.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
           {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0004.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
           {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/EP/EN/EP0003.png',
        name: "Infinity Pull",
        cateogry: "EVOPLAY",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
           
//--------------EVOPLAY----------------//
//--------------SMARTSOFT----------------//
     {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0059.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
             {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0060.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0054.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0059.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0049.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0048.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0047.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0046.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0045.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0044.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0040.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0034.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0029.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0028.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0027.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0026.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0025.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0023.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0018.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0017.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
      {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0016.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
           {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0015.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
           {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0014.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
           {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0012.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
         {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0011.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0009.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
        {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0008.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0007.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0004.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
       {
        id:2,
        img: 'https://images.6492394993.com/TCG_GAME_ICONS/SS/EN/SS0002.png',
        name: "Infinity Pull",
        cateogry: "SMARTSOFT",
        type: "ROYAL",
        gameTypeCheck: "platForm",
        platForm: "JDB",
        gameType: "SLOT",
        casinoType: "JDB-SLOT-041",
      },
//--------------SMARTSOFT----------------//
 {
    img: "../assets/images/CardGames/EVOLUTION-LIVE-012.webp",
    name: "Infinite Black Jack",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-012",
    cateogry: "EVO",
   type: "GAME-SHOWS",
  },
  {
    img: "../assets/images/CardGames/EVOLUTION-LIVE-181.webp",
    name: "Lightning Black Jack",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-181",
    cateogry: "EVO",
    type: "GAME-SHOWS",
  },
//    {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-037.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/freebet.webp",
//     name: "Infinite Free Bet Blackjack",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-037",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//   },
//  {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-016.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/powerblackjack.webp",
//     name: "Power Blackjack",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-016",
//     cateogry: "EVO",
//     type: "GAME-SHOWS",
//   },
  
//  {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-173.jpg",
//     thumbnail:"",
//     name: "Speed VIP Blackjack H",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-173",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//   },

//  {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-412.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/infinitebetstackerblackjack.webp",
//     name: "Infinite Bet Stacker Blackjack",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-412",
//     cateogry: "EVO",
//     type: "GAME-SHOWS",
//   },

// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-413.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/easyblackjack.webp",
//     name: "Easy Blackjack",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-413",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//   },
// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-042.jpg",
//     thumbnail:"",
//     name: "Blackjack Party",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-042",
//     cateogry: "EVO",
//     type: "GAME-SHOWS",
//   },

// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-215.jpg",
//     thumbnail:"",
//     name: "Salon Privé Blackjack A",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-215",
//     cateogry: "EVO",
//     type: "GAME-SHOWS",
//   },

  {
    img: "../assets/images/CardGames/EVOLUTION-LIVE-208.webp",
    name: "Lightning BlackJack First Person",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-208",
    cateogry: "EVO",
    type: "GAME-SHOWS",
  },

{
    img: "../assets/images/Roulette/ROULETTE-7.webp",
    name: "Amercian Roulette Live",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-020",
    cateogry: "EVO",
   type: "GAME-SHOWS",
    isPopular: true,
  },

//   {
//       img: "../assets/images/live/evo/EVOLUTION-LIVE-040.jpg",
//       thumbnail:"https://bshots.egcvi.com/thumbnail/lightning_roulette.webp",
//       name: "Lightning Roulette",
//       platForm: "EVOLUTION",
//       gameType: "LIVE",
//       casinoType: "EVOLUTION-LIVE-040",
//       cateogry: "EVO",
//       type: "GAME-SHOWS",
//       isPopular: true,
//     },

// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-205.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/xxxtreme_roulette.webp",
//     name: "XXXtreme Lightning roulette",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-205",
//     cateogry: "EVO",
//     type: "GAME-SHOWS",
//     isPopular: true,
//   },
 {
    img: "../assets/images/Roulette/EVOLUTION-LIVE-180.png",
    name: "Immersive Roulette",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-180",
    cateogry: "EVO",
    type: "GAME-SHOWS",
  },

//  {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-043.jpg",
//     name: "Double Ball Roulette",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-043",
//     cateogry: "EVO",
//     type: "GAME-SHOWS",
//   },

{
    img: "../assets/images/Roulette/ROULETTE-3.webp",
    name: "Speed Roulette",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-078",
    cateogry: "EVO",
    type: "GAME-SHOWS",
    isPopular: true,
  },
  {
    img: "../assets/images/Roulette/ROULETTE-5.webp",
    name: "Instant Roulette",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-008",
    cateogry: "EVO",
type: "GAME-SHOWS",
    isPopular: true,
  },
// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-212.jpg",
//     name: "Speed Auto Roulette",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-212",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },
// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-257.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/reddoorroulette.webp",
//     name: "Red Door Roulette",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-257",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },
//   {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-228.jpg",
//     thumbnail:"",
//     name: "Gold Vault Roulette",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-228",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },

  {
    img: "../assets/images/Roulette/EVOLUTION-LIVE-081.png",
    name: "Salon Privé Roulette",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-081",
    cateogry: "EVO",
    type: "GAME-SHOWS",
  },

{
    img: "../assets/images/Roulette/ROULETTE-1.webp",
    name: "Roulette Live",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-001",
    cateogry: "EVO",
   type: "GAME-SHOWS",
    isPopular: true,
  },
{
    img: "../assets/images/Roulette/ROULETTE-4.webp",
    name: "Roulette VIP",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-079",
    cateogry: "EVO",
    type: "GAME-SHOWS",
    isPopular: true,
  },

 {
    img: "../assets/images/Baccarat/EVOLUTION-LIVE-017.png",
    name: "Classic Live Baccarat",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-017",
    cateogry: "EVO",
    type: "GAME-SHOWS",
  },

{
    img: "../assets/images/game-shows/GAME-SHOW-8.webp",
    name: "Lightning Baccarat",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-133",
    cateogry: "EVO",
    type: "GAME-SHOWS",
    isPopular: true,
  },
{
    img: "../assets/images/live/evo/EVOLUTION-LIVE-256.jpg",
    name: "XXXtreme lightning Baccarat",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-256",
    cateogry: "EVO",
   type: "GAME-SHOWS",
    isPopular: true,
  },

{
    img: "../assets/images/Baccarat/BACCARAT-2.webp",
    name: "Baccarat no commission",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-038",
    cateogry: "EVO",
    type: "GAME-SHOWS",
    isPopular: true,
  },
   {
    img: "../assets/images/Baccarat/EVOLUTION-LIVE-036.png",
    name: "Baccarat Squeeze",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-036",
    cateogry: "EVO",
    type: "GAME-SHOWS",
  },
  {
    img: "../assets/images/Baccarat/EVOLUTION-LIVE-041.png",
    name: "Control Squeeze Baccara",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-041",
    cateogry: "EVO",
    type: "GAME-SHOWS",
  },

  {
    img: "../assets/images/Baccarat/EVOLUTION-LIVE-182.png",
    name: "Peek Baccarat",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-182",
    cateogry: "EVO",
type: "GAME-SHOWS",
  },

{
    img: "../assets/images/Baccarat/BACCARAT-1.webp",
    name: "Golden Wealth Baccarat",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-179",
    cateogry: "EVO",
type: "GAME-SHOWS",
    isPopular: true,
  },

//  {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-172.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/bacbo.webp",
//     name: "Bac Bo",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-172",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },

 {
    img: "../assets/images/TraditionalGames/TRADINATIONAL-4.webp",
    name: "Dragon Tiger",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-004",
    cateogry: "EVO",
    type: "GAME-SHOWS",
    isPopular: true,
  },
  {
    img: "../assets/images/TraditionalGames/TRADINATIONAL-2.webp",
    name: "Fan Tan",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-178",
    cateogry: "EVO",
   type: "GAME-SHOWS",
    isPopular: true,
  },
//  {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-410.jpg",
//     name: "Always 8 Baccarat",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-410",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },
 {
    img: "../assets/images/Baccarat/EVOLUTION-LIVE-245.png",
    name: "Prosperity Tree Baccarat ",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-245",
    cateogry: "EVO",
    type: "GAME-SHOWS",
    isPopular: true,
  },
//  {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-398.jpg",
//     name: "Super speed Baccarat ",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-398",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },

//  {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-015.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/poker_holdem.webp",
//     name: "Casino Hold'em ",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-015",
//     cateogry: "EVO",
//   type: "GAME-SHOWS",
//     isPopular: true,
//   },

// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-024.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/poker_csp.webp",
//     name: "Caribbean Stud Poker",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-024",
//     cateogry: "EVO",
//     type: "GAME-SHOWS",
//     isPopular: true,
//   },
// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-027.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/poker_thb.webp",
//     name: "Texas Hold'em Bonus Poker",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-027",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },
// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-021.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/poker_dhp.webp",
//     name: "2 Hand Casino Hold'em",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-021",
//     cateogry: "EVO",
//     type: "GAME-SHOWS",
//     isPopular: true,
//   },
// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-026.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/poker_teenpatti.webp",
//     name: "Teen Patti",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-026",
//     cateogry: "EVO",
//     type: "GAME-SHOWS",
//     isPopular: true,
//   },
  {
    img: "../assets/images/TraditionalGames/TRADINATIONAL-1.webp",
    name: "Super Andhar Bahar",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-204",
    cateogry: "EVO",
    type: "GAME-SHOWS",
    isPopular: true,
  },

// {
//     img: "../assets/images/Dice/DICE-3.webp",
//     name: "Craps Live",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-003",
//     cateogry: "EVO",
//   type: "GAME-SHOWS",
//     isPopular: true,
//   },

{
    img: "../assets/images/Dice/DICE-2.webp",
    name: "Super Sic Bo",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-005",
    cateogry: "EVO",
   type: "GAME-SHOWS",
    isPopular: true,
  },

// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-011.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/lightning_dice.webp",
//     name: "Lightning Dice",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-011",
//     cateogry: "EVO",
//     type: "GAME-SHOWS",
//     isPopular: true,
//   },
// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-044.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/topdice.webp",
//     name: "Football Studio Dice",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-044",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },
//   {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-006.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/crazytime.webp",
//     name: "Crazy Time",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-006",
//     cateogry: "EVO",
//  type: "GAME-SHOWS",
//     isPopular: true,
//   },
// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-169.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/imperialquest.webp",
//     name: "Imperial Quest",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-169",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },
// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-007.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/monopoly.webp",
//     name: "Monopoly Live",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-007",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },
// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-025.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/dealnodeallivespins.webp",
//     name: "Deal or No Deal",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-025",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },

// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-035.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/dreamcatcher.webp",
//     name: "Dream Catcher",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-035",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },
// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-010.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/megaball.webp",
//     name: "Mega Ball",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-010",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },

//  {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-183.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/funkytime.webp",
//     name: "Funky Time",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-183",
//     cateogry: "EVO",
//     type: "GAME-SHOWS",
//     isPopular: true,
//   },
// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-014.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/crazycoinflip.webp",
//     name: "Crazy Coin Flip",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-014",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },

// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-409.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/crazyballs.webp",
//     name: "Crazy Balls",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-409",
//     cateogry: "EVO",
//     type: "GAME-SHOWS",
//     isPopular: true,
//   },
// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-018.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/monopolybigballer.webp",
//     name: "MONOPOLY Big Baller",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-018",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },
  
// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-261.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/crazypachinko.webp",
//     name: "Crazy Pachinko",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-261",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },
//   {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-168.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/extrachilliepicspins.webp",
//     name: "Extra Chilli Epic Spins",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-168",
//     cateogry: "EVO",
//     type: "GAME-SHOWS",
//     isPopular: true,
//   },
//  {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-175.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/cashorcrash.webp",
//     name: "Cash or Crash",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-175",
//     cateogry: "EVO",
//     type: "GAME-SHOWS",
//     isPopular: true,
//   },
  {
    img: "../assets/images/game-shows/GAME-SHOW-4.webp",
    name: "Dead or Alive Saloon",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-176",
    cateogry: "EVO",
   type: "GAME-SHOWS",
    isPopular: true,
  },
// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-045.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/topcard.webp",
//     name: "Football Studio",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-045",
//     cateogry: "EVO",
//     type: "GAME-SHOWS",
//     isPopular: true,
//   },
// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-369.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/lightningstorm.webp",
//     name: "Lightning Storm",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-369",
//     cateogry: "EVO",
//     type: "GAME-SHOWS",
//     isPopular: true,
//   },
// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-435.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/supercolorgame.webp",
//     name: "Super Color Game",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-435",
//     cateogry: "EVO",
//     type: "GAME-SHOWS",
//     isPopular: true,
//   },
// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-434.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/marblerace.webp",
//     name: "Marble Race",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-434",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },

// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-363.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/balloonrace.webp",
//     name: "Balloon Race",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-363",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },
{
    img: "../assets/images/live/evo/EVOLUTION-LIVE-291.jpg",
    thumbnail:"",
    name: "Stock Market",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-291",
    cateogry: "EVO",
   type: "GAME-SHOWS",
    isPopular: true,
  },
  {
    img: "../assets/images/game-shows/EVOLUTION-LIVE-023.png",
    name: "First Person Dream Catcher",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-023",
    cateogry: "EVO",
   type: "GAME-SHOWS",
  },
{
    img: "../assets/images/game-shows/EVOLUTION-LIVE-034.png",
    name: "First Person Mega Ball",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-034",
    cateogry: "EVO",
   type: "GAME-SHOWS",
  },
{
    img: "../assets/images/Dice/EVOLUTION-LIVE-031.png",
    name: "First Person Craps",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-031",
    cateogry: "EVO",
  type: "GAME-SHOWS",
  },

 {
    img: "../assets/images/TraditionalGames/EVOLUTION-LIVE-033.png",
    name: "First Person Dragon Tiger",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-033",
    cateogry: "EVO",
   type: "GAME-SHOWS",
  },

 {
    img: "../assets/images/Baccarat/EVOLUTION-LIVE-046.png",
    name: "First Person Golden Wealth Baccarat",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-046",
    cateogry: "EVO",
   type: "GAME-SHOWS",
  },
{
    img: "../assets/images/Dice/DICE-1.webp",
    name: "Bac Bo Live",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-172",
    cateogry: "EVO",
  type: "GAME-SHOWS",
    isPopular: true,
  },
  
  {
    img: "../assets/images/Dice/EVOLUTION-LIVE-259.png",
    name: "First Person Super Sic Bo",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-259",
    cateogry: "EVO",
  type: "GAME-SHOWS",
    isPopular: true,
  },

{
    img: "../assets/images/live/evo/EVOLUTION-LIVE-225.jpg",
    name: "First Person Deal or No Deal",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-225",
    cateogry: "EVO",
  type: "GAME-SHOWS",
    isPopular: true,
  },

{
    img: "../assets/images/Baccarat/EVOLUTION-LIVE-244.png",
    name: "First Person Prosperity Tree Baccarat",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-244",
    cateogry: "EVO",
   type: "GAME-SHOWS",
    isPopular: true,
  },
  {
    img: "../assets/images/live/evo/EVOLUTION-LIVE-364.jpg",
    name: "First Person HiLo",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-364",
    cateogry: "EVO",
  type: "GAME-SHOWS",
    isPopular: true,
  },

//  {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-118.jpg",
//     name: "Blackjack Diamond VIP",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-118",
//     cateogry: "EVO",
//   type: "GAME-SHOWS",
//     isPopular: true,
//   },
//    {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-117.jpg",
//     name: "Blackjack Platinum VIP",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-117",
//     cateogry: "EVO",
//   type: "GAME-SHOWS",
//     isPopular: true,
//   },

//   {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-449.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/icefishing.webp",
//     name: "Ice Fishing",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-449",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },



  
//   {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-114.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/crazytime.webp",
//     name: "Crazy Time A",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-114",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },


// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-436.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/fireballroulette.webp",
//     name: "Fireball Roulette",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-436",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },

// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-376.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/lightningball.webp",
//     name: "Lightning Ball",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-376",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },


//   {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-431.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/war.webp",
//     name: "War",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-431",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },

//   {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-176.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/deadoralivesaloon.webp",
//     name: "Dead or Alive: Saloon",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-176",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },
  
//  {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-246.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/gonzotreasuremap.webp",
//     name: "Gonzo's Treasure Map",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-246",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },



//    {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-230.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/bacbo.webp",
//     name: "Emperor Bac Bo",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-230",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },
//  {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-178.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/fantan.webp",
//     name: "Fan Tan",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-178",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },
//  {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-414.jpg",
//     thumbnail:"https://bshots.egcvi.com/thumbnail/goldenwealth_baccarat.webp",
//     name: "Emperor Golden Wealth Baccarat",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-414",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },

//  {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-150.jpg",
//     thumbnail:"",
//     name: "Emperor Speed Baccarat A",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-150",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },
//  {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-147.jpg",
//     thumbnail:"",
//     name: "Emperor Speed Baccarat B",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-147",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },
// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-153.jpg",
//     thumbnail:"",
//     name: "Emperor Speed Baccarat C",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-153",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },

// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-210.jpg",
//     thumbnail:"",
//     name: "Emperor Speed Baccarat D",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-210",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },

// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-229.jpg",
//     thumbnail:"",
//     name: "Hindi Speed Baccarat A",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-229",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },

// {
//     img: "../assets/images/live/evo/EVOLUTION-LIVE-277.jpg",
//     thumbnail:"",
//     name: "Hindi Speed Baccarat B",
//     platForm: "EVOLUTION",
//     gameType: "LIVE",
//     casinoType: "EVOLUTION-LIVE-277",
//     cateogry: "EVO",
//    type: "GAME-SHOWS",
//     isPopular: true,
//   },
  {
    img: "../assets/images/game-shows/GAME-SHOW-1.webp",
    name: "XXXtreme Lightning roulette",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-205",
    cateogry: "EVO",
    type: "GAME-SHOWS",
    isPopular: true,
  },
  {
    img: "../assets/images/game-shows/EVOLUTION-LIVE-291.webp",
    name: "Stock Market",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-291",
    cateogry: "EVO",
    type: "GAME-SHOWS",
    isPopular: true,
  },

  {
    img: "../assets/images/game-shows/GAME-SHOW-2.webp",
    name: "Cash or Crash",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-175",
    cateogry: "EVO",
    type: "GAME-SHOWS",
    isPopular: false,
  },
  {
    img: "../assets/images/game-shows/GAME-SHOW-3.webp",
    name: "Funky Time",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-183",
    cateogry: "EVO",
    type: "GAME-SHOWS",
    isPopular: true,
  },
  {
    img: "../assets/images/game-shows/GAME-SHOW-4.webp",
    name: "Dead or Alive Saloon",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-176",
    cateogry: "EVO",
    type: "GAME-SHOWS",
    isPopular: true,
  },
  {
    img: "../assets/images/game-shows/GAME-SHOW-5.webp",
    name: "Crazy Time",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-006",
    cateogry: "EVO",
    type: "GAME-SHOWS",
    isPopular: true,
  },
  // {
  //   img: "../assets/images/game-shows/EVOLUTION-LIVE-114.png",
  //   name: "Crazy Time",
  //   platForm: "EVOLUTION",
  //   gameType: "LIVE",
  //   casinoType: "EVOLUTION-LIVE-114",
  //   cateogry: "EVO",
  //   type: "GAME-SHOWS",

  // },

  {
    img: "../assets/images/game-shows/GAME-SHOW-6.webp",
    name: "Lightning Dice",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-011",
    cateogry: "EVO",
    type: "GAME-SHOWS",
    isPopular: true,
  },

  {
    img: "../assets/images/game-shows/GAME-SHOW-7.webp",
    name: "Lightning Roulette",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-040",
    cateogry: "EVO",
    type: "GAME-SHOWS",
    isPopular: true,
  },
  {
    img: "../assets/images/game-shows/GAME-SHOW-8.webp",
    name: "Lightning Fever",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-133",
    cateogry: "EVO",
    type: "GAME-SHOWS",
    isPopular: true,
  },
  {
    img: "../assets/images/game-shows/GAME-SHOW-9.webp",
    name: "Extra Chilli",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-168",
    cateogry: "EVO",
    type: "GAME-SHOWS",
    isPopular: true,
  },
  {
    img: "../assets/images/game-shows/GAME-SHOW-10.webp",
    name: "Imperial Quest",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-169",
    cateogry: "EVO",
    type: "GAME-SHOWS",
    isPopular: true,
  },
  {
    img: "../assets/images/game-shows/GAME-SHOW-11.webp",
    name: "Monopoly Live",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-007",
    cateogry: "EVO",
    type: "GAME-SHOWS",
    isPopular: true,
  },
  {
    img: "../assets/images/game-shows/GAME-SHOW-12.webp",
    name: "Monopoly Big Baller",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-018",
    cateogry: "EVO",
    type: "GAME-SHOWS",
    isPopular: true,
  },
  {
    img: "../assets/images/game-shows/GAME-SHOW-13.webp",
    name: "Crazy Coin Flip",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-014",
    cateogry: "EVO",
    type: "GAME-SHOWS",
    isPopular: true,
  },
  {
    img: "../assets/images/game-shows/GAME-SHOW-14.webp",
    name: "Mega Ball",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-010",
    cateogry: "EVO",
    type: "GAME-SHOWS",
    isPopular: true,
  },
  {
    img: "../assets/images/game-shows/GAME-SHOW-15.webp",
    name: "Deal or Nodeal",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-025",
    cateogry: "EVO",
    type: "GAME-SHOWS",
    isPopular: true,
  },
  {
    img: "../assets/images/game-shows/EVOLUTION-LIVE-292.webp",
    name: "Stock Market",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-292",
    cateogry: "EVO",
    type: "GAME-SHOWS",
    isPopular: true,
  },
  {
    img: "../assets/images/game-shows/EVOLUTION-LIVE-246.png",
    name: "Gonzo's Treasure Map",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-246",
    cateogry: "EVO",
    type: "GAME-SHOWS",
    isPopular: true,
  },

  {
    img: "../assets/images/game-shows/EVOLUTION-LIVE-023.png",
    name: "First Person Dream Catcher",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-023",
    cateogry: "EVO",
    type: "GAME-SHOWS",
  },
  {
    img: "../assets/images/game-shows/EVOLUTION-LIVE-028.png",
    name: "First Person Dream Catcher",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-028",
    cateogry: "EVO",
    type: "GAME-SHOWS",
  },
  {
    img: "../assets/images/game-shows/EVOLUTION-LIVE-034.png",
    name: "First Person Dream Catcher",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-034",
    cateogry: "EVO",
    type: "GAME-SHOWS",
  },
  {
    img: "../assets/images/game-shows/EVOLUTION-LIVE-035.png",
    name: "First Person Dream Catcher",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-035",
    cateogry: "EVO",
    type: "GAME-SHOWS",
  },
  {
    img: "../assets/images/game-shows/EVOLUTION-LIVE-044.png",
    name: "First Person Dream Catcher",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-044",
    cateogry: "EVO",
    type: "GAME-SHOWS",
  },
  {
    img: "../assets/images/game-shows/EVOLUTION-LIVE-045.png",
    name: "First Person Dream Catcher",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-045",
    cateogry: "EVO",
    type: "GAME-SHOWS",
  },
  {
    img: "../assets/images/game-shows/EVOLUTION-LIVE-369.png",
    name: "lighting storm",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-369",
    cateogry: "EVO",
    type: "GAME-SHOWS",
  },

  {
    img: "../assets/images/game-shows/PP-LIVE-075.webp",
    name: "Auto Mega Roulette",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-075",
    cateogry: "PP",
    type: "GAME-SHOWS",
    isPopular: true,
  },

  {
    img: "../assets/images/game-shows/GAME-SHOW-16.webp",
    name: "Wounderland",
    platForm: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-011",
    cateogry: "PT",
    type: "GAME-SHOWS",
    isPopular: true,
  },
  {
    img: "../assets/images/game-shows/GAME-SHOW-17.webp",
    name: "Shweet Bonanza Candy Land",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-044",
    cateogry: "PP",
    type: "GAME-SHOWS",
    isPopular: true,
  },
  {
    img: "../assets/images/game-shows/GAME-SHOW-18.webp",
    name: "Spin a Win Wild live",
    platForm: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-015",
    cateogry: "PT",
    type: "GAME-SHOWS",
    isPopular: true,
  },
  {
    img: "../assets/images/game-shows/GAME-SHOW-19.webp",
    name: "Spin and Win Wild B X2",
    platForm: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-088",
    cateogry: "PT",
    type: "GAME-SHOWS",
    isPopular: true,
  },
  {
    img: "../assets/images/game-shows/GAME-SHOW-20.webp",
    name: "The Greatest Cards Show",
    platForm: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-086",
    cateogry: "PT",
    type: "GAME-SHOWS",
    isPopular: true,
  },
  {
    img: "../assets/images/game-shows/GAME-SHOW-21.webp",
    name: "Mega Wheel",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-038",
    cateogry: "PP",
    type: "GAME-SHOWS",
    isPopular: true,
  },
  {
    img: "../assets/images/game-shows/GAME-SHOW-22.webp",
    name: "Mega Fire Blaze Roulette",
    platForm: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-028",
    cateogry: "PT",
    type: "GAME-SHOWS",
    isPopular: true,
  },
  {
    img: "../assets/images/game-shows/GAME-SHOW-23.webp",
    name: "Mega Roulette 500x",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-039",
    cateogry: "PP",
    type: "GAME-SHOWS",
    isPopular: true,
  },
  {
    img: "../assets/images/game-shows/GAME-SHOW-24.webp",
    name: "Mega Baccarat",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-061",
    cateogry: "PP",
    type: "GAME-SHOWS",
    isPopular: true,
  },
  {
    img: "../assets/images/game-shows/GAME-SHOW-25.webp",
    name: "Quantum Auto Roulette",
    platForm: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-026",
    cateogry: "PT",
    type: "GAME-SHOWS",
    isPopular: true,
  },
  {
    img: "../assets/images/game-shows/GAME-SHOW-26.webp",
    name: "Power Roulette",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-055",
    cateogry: "PP",
    type: "GAME-SHOWS",
    isPopular: true,
  },

  {
    img: "../assets/images/game-shows/GAME-SHOW-27.webp",
    name: "Sicbo Delux",
    gameType: "LIVE",
    platForm: "PT",
    casinoType: "PT-LIVE-003",
    cateogry: "PT",
    type: "GAME-SHOWS",
    isPopular: true,
  },

  {
    img: "../assets/images/game-shows/PP-LIVE-062.png",
    name: "Mega Sicbo",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-062",
    cateogry: "PP",
    type: "GAME-SHOWS",
  },
  {
    img: "../assets/images/game-shows/GAME-SHOW-28.webp",
    name: "Mega Sicbo",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-025",
    cateogry: "PP",
    type: "GAME-SHOWS",
    isPopular: true,
  },
  {
    img: "../assets/images/game-shows/GAME-SHOW-29.webp",
    name: "Bet on Dragon Tiger",
    platForm: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-030",
    cateogry: "PT",
    type: "GAME-SHOWS",
    isPopular: true,
  },
  {
    img: "../assets/images/game-shows/GAME-SHOW-30.webp",
    name: "Hi-lo Club",
    platForm: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-014",
    cateogry: "PT",
    type: "GAME-SHOWS",
    isPopular: true,
  },
  {
    img: "../assets/images/game-shows/PP-LIVE-077.webp",
    name: "Lucky 6 Roulette",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-077",
    cateogry: "PP",
    type: "GAME-SHOWS",
    isPopular: true,
  },
  {
    img: "../assets/images/game-shows/GAME-SHOW-32.webp",
    name: "Italian Cashback Blackjack",
    platForm: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-031",
    cateogry: "PT",
    type: "GAME-SHOWS",
    isPopular: false,
  },
  {
    img: "../assets/images/game-shows/PT-LIVE-116.webp",
    name: "K-Pop Roulette Live",
    platForm: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-116",
    cateogry: "PT",
    type: "GAME-SHOWS",
    isPopular: true,
  },

  {
    img: "../assets/images/game-shows/PT-LIVE-090.png",
    name: "Italian Cashback Blackjack",
    platForm: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-090",
    cateogry: "PT",
    type: "GAME-SHOWS",
  },
  {
    img: "../assets/images/game-shows/PT-LIVE-090.png",
    name: "Italian Cashback Blackjack",
    platForm: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-090",
    cateogry: "PT",
    type: "GAME-SHOWS",
  },
  {
    img: "../assets/images/game-shows/PT-LIVE-108.png",
    name: "Italian Cashback Blackjack",
    platForm: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-108",
    cateogry: "PT",
    type: "GAME-SHOWS",
  },
  {
    img: "../assets/images/game-shows/PP-LIVE-076.webp",
    name: "Lucky 6 Roulette",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-076",
    cateogry: "PP",
    type: "GAME-SHOWS",
    isPopular: true,
  },

  // {
  //   img: "../assets/images/game-shows/GAME-SHOW-31.webp",
  //   name: "Quantum BlackJack Plus",
  //   platForm: "PT",
  //   gameType: "LIVE",
  //   casinoType: "PT-LIVE-029",
  //   cateogry: "PT",
  //   type: "GAME-SHOWS",
  // },
  {
    img: "../assets/images/Baccarat/HOTROAD-LIVE-001.webp",
    name: "HOTROAD-LIVE-001",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-001",
    cateogry: "HOTROAD",
    type: "BACCARAT",
    table: "1",
    isPopular: true,
  },
  {
    img: "../assets/images/Baccarat/HOTROAD-LIVE-001.webp",
    name: "HOTROAD-LIVE-001",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-001",
    cateogry: "HOTROAD",
    type: "BACCARAT",
    table: "2",
    isPopular: true,
  },
  {
    img: "../assets/images/Baccarat/HOTROAD-LIVE-001.webp",
    name: "HOTROAD-LIVE-001",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-001",
    cateogry: "HOTROAD",
    type: "BACCARAT",
    table: "3",
  },
  {
    img: "../assets/images/Baccarat/HOTROAD-LIVE-001.webp",
    name: "HOTROAD-LIVE-001",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-001",
    cateogry: "HOTROAD",
    type: "BACCARAT",
    table: "4",
  },
  {
    img: "../assets/images/Baccarat/HOTROAD-LIVE-001.webp",
    name: "HOTROAD-LIVE-001",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-001",
    cateogry: "HOTROAD",
    type: "BACCARAT",
    table: "5",
  },
  {
    img: "../assets/images/Baccarat/HOTROAD-LIVE-001.webp",
    name: "HOTROAD-LIVE-001",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-001",
    cateogry: "HOTROAD",
    type: "BACCARAT",
    table: "6",
  },
  {
    img: "../assets/images/Baccarat/HOTROAD-LIVE-007.webp",
    name: "HOTROAD-LIVE-007",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-007",
    cateogry: "HOTROAD",
    type: "BACCARAT",
    table: "6001",
    isPopular: true,
  },
  {
    img: "../assets/images/Baccarat/HOTROAD-LIVE-007.webp",
    name: "HOTROAD-LIVE-007",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-007",
    cateogry: "HOTROAD",
    type: "BACCARAT",
    table: "6002",
    isPopular: true,
  },

  {
    img: "../assets/images/Baccarat/HOTROAD-LIVE-007.webp",
    name: "HOTROAD-LIVE-007",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-007",
    cateogry: "HOTROAD",
    type: "BACCARAT",
    table: "6003",
  },
  {
    img: "../assets/images/Baccarat/HOTROAD-LIVE-007.webp",
    name: "HOTROAD-LIVE-007",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-007",
    cateogry: "HOTROAD",
    type: "BACCARAT",
    table: "6004",
  },
  {
    img: "../assets/images/Baccarat/HOTROAD-LIVE-007.webp",
    name: "HOTROAD-LIVE-007",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-007",
    cateogry: "HOTROAD",
    type: "BACCARAT",
    table: "6005",
  },
  {
    img: "../assets/images/Baccarat/HOTROAD-LIVE-007.webp",
    name: "HOTROAD-LIVE-007",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-007",
    cateogry: "HOTROAD",
    type: "BACCARAT",
    table: "6006",
  },
  {
    img: "../assets/images/Baccarat/BACCARAT-1.webp",
    name: "Golden Wealth Baccarat",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-179",
    cateogry: "EVO",
    type: "BACCARAT",
    isPopular: true,
  },
  {
    img: "../assets/images/Baccarat/BACCARAT-2.webp",
    name: "Baccarat no commission",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-038",
    cateogry: "EVO",
    type: "BACCARAT",
    isPopular: true,
  },
  {
    img: "../assets/images/Baccarat/BACCARAT-3.webp",
    name: "Speed Baccarat",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-159",
    cateogry: "EVO",
    type: "BACCARAT",
    isPopular: true,
  },
  {
    img: "../assets/images/Baccarat/EVOLUTION-LIVE-134.png",
    name: "Baccarat no commission",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-134",
    cateogry: "EVO",
    type: "BACCARAT",
    isPopular: true,
  },

  {
    img: "../assets/images/Baccarat/EVOLUTION-LIVE-255.png",
    name: "Golden Wealth Baccarat",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-255",
    cateogry: "EVO",
    type: "BACCARAT",
    isPopular: true,
  },
  {
    img: "../assets/images/Baccarat/EVOLUTION-LIVE-210.png",
    name: "Speed Baccarat",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-210",
    cateogry: "EVO",
    type: "BACCARAT",
    isPopular: true,
  },
  {
    img: "../assets/images/Baccarat/EVOLUTION-LIVE-245.png",
    name: "Speed Baccarat",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-245",
    cateogry: "EVO",
    type: "BACCARAT",
    isPopular: true,
  },
  {
    img: "../assets/images/Baccarat/EVOLUTION-LIVE-244.png",
    name: "Speed Baccarat",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-244",
    cateogry: "EVO",
    type: "BACCARAT",
    isPopular: true,
  },


 

  {
    img: "../assets/images/Baccarat/BACCARAT-7.webp",
    name: "Baccarat Classic",
    table: "1",
    platForm: "SEXYBCRT",
    gameType: "LIVE",
    casinoType: "MX-LIVE-001",
    cateogry: "SEXY",
    type: "BACCARAT",
    isPopular: true,
  },
  {
    img: "../assets/images/Baccarat/BACCARAT-8.webp",
    name: "Baccarat Classic",
    table: "2",
    platForm: "SEXYBCRT",
    gameType: "LIVE",
    casinoType: "MX-LIVE-001",
    cateogry: "SEXY",
    type: "BACCARAT",
    isPopular: true,
  },
  {
    img: "../assets/images/Baccarat/BACCARAT-9.webp",
    name: "Baccarat Classic",
    table: "3",
    platForm: "SEXYBCRT",
    gameType: "LIVE",
    casinoType: "MX-LIVE-001",
    cateogry: "SEXY",
    type: "BACCARAT",
    isPopular: true,
  },
  {
    img: "../assets/images/Baccarat/BACCARAT-10.webp",
    name: "Baccarat Classic",
    table: "4",
    platForm: "SEXYBCRT",
    gameType: "LIVE",
    casinoType: "MX-LIVE-001",
    cateogry: "SEXY",
    type: "BACCARAT",
    isPopular: true,
  },
  {
    img: "../assets/images/Baccarat/BACCARAT-11.webp",
    name: "Baccarat Classic",
    table: "5",
    platForm: "SEXYBCRT",
    gameType: "LIVE",
    casinoType: "MX-LIVE-001",
    cateogry: "SEXY",
    type: "BACCARAT",
    isPopular: true,
  },
  {
    img: "../assets/images/Baccarat/BACCARAT-12.webp",
    name: "Baccarat Classic",
    table: "6",
    platForm: "SEXYBCRT",
    gameType: "LIVE",
    casinoType: "MX-LIVE-001",
    cateogry: "SEXY",
    type: "BACCARAT",
    isPopular: true,
  },
   //LIVE SEXY START




//LIVE SEXY END

  {
    img: "../assets/images/Baccarat/PT-LIVE-109.png",
    name: "Baccarat Classic",
    platForm: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-109",
    cateogry: "PT",
    type: "BACCARAT",
    isPopular: true,
  },
  {
    img: "../assets/images/Baccarat/PT-LIVE-001.png",
    name: "Baccarat Classic",
    platForm: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-001",
    cateogry: "PT",
    type: "BACCARAT",
    isPopular: true,
  },
  {
    img: "../assets/images/Baccarat/PT-LIVE-005.png",
    name: "Baccarat Classic",
    platForm: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-005",
    cateogry: "PT",
    type: "BACCARAT",
  },
  //LIVE PT START


 {
    img: "../assets/images/live/pt/PT-LIVE-147.webp",
    name: "Super Card Blackjack Live",
    platForm: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-147",
    cateogry: "PT",
    type: "BACCARAT",
    isPopular: true,
  },
 {
    img: "../assets/images/live/pt/PT-LIVE-145.webp",
    name: "Speed Baccarat 2",
    platForm: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-145",
    cateogry: "PT",
    type: "BACCARAT",
    isPopular: true,
  },
 {
    img: "../assets/images/live/pt/PT-LIVE-145.webp",
    name: "Speed Baccarat 1",
    platForm: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-144",
    cateogry: "PT",
    type: "BACCARAT",
    isPopular: true,
  },
 {
    img: "../assets/images/live/pt/PT-LIVE-146.webp",
    name: "Super Speed Baccarat",
    platForm: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-146",
    cateogry: "PT",
    type: "BACCARAT",
    isPopular: true,
  },

{
    img: "../assets/images/live/pt/PT-LIVE-143.webp",
    name: "Quantum Baccarat Live",
    platForm: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-143",
    cateogry: "PT",
    type: "BACCARAT",
    isPopular: true,
  },


{
    img: "../assets/images/live/pt/PT-LIVE-096.webp",
    name: "Speed Baccarat Korean 2",
    platForm: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-096",
    cateogry: "PT",
    type: "BACCARAT",
    isPopular: true,
  },
  {
    img: "../assets/images/Baccarat/PP-LIVE-001.png",
    name: "Baccarat Classic",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-001",
    cateogry: "PP",
    type: "BACCARAT",
    isPopular: true,
  },
  {
    img: "../assets/images/Baccarat/PP-LIVE-010.png",
    name: "Baccarat Classic",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-010",
    cateogry: "PP",
    type: "BACCARAT",
    isPopular: true,
  },
  {
    img: "../assets/images/Baccarat/BACCARAT-24.webp",
    name: "Speed Baccarat 1",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-013",
    cateogry: "PP",
    type: "BACCARAT",
    isPopular: true,
  },
  {
    img: "../assets/images/Baccarat/BACCARAT-25.webp",
    name: "Super 8 Baccarat",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-045",
    cateogry: "PP",
    type: "BACCARAT",
    isPopular: true,
  },
  {
    img: "../assets/images/Baccarat/PP-LIVE-050.png",
    name: "Super 8 Baccarat",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-050",
    cateogry: "PP",
    type: "BACCARAT",
  },
  {
    img: "../assets/images/Baccarat/PP-LIVE-051.png",
    name: "Super 8 Baccarat",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-051",
    cateogry: "PP",
    type: "BACCARAT",
  },
  {
    img: "../assets/images/Baccarat/PP-LIVE-052.png",
    name: "Super 8 Baccarat",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-052",
    cateogry: "PP",
    type: "BACCARAT",
  },
  {
    img: "../assets/images/Baccarat/EVOLUTION-LIVE-256.png",
    name: "Golden Wealth Baccarat",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-256",
    cateogry: "EVO",
    type: "BACCARAT",
  },

  {
    img: "../assets/images/Baccarat/EVOLUTION-LIVE-182.png",
    name: "Golden Wealth Baccarat",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-182",
    cateogry: "EVO",
    type: "BACCARAT",
  },

  {
    img: "../assets/images/Baccarat/EVOLUTION-LIVE-135.png",
    name: "Baccarat no commission",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-135",
    cateogry: "EVO",
    type: "BACCARAT",
  },
  {
    img: "../assets/images/Baccarat/EVOLUTION-LIVE-136.png",
    name: "Baccarat no commission",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-136",
    cateogry: "EVO",
    type: "BACCARAT",
  },

  {
    img: "../assets/images/Baccarat/EVOLUTION-LIVE-160.png",
    name: "Speed Baccarat",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-160",
    cateogry: "EVO",
    type: "BACCARAT",
  },

  {
    img: "../assets/images/Baccarat/EVOLUTION-LIVE-161.png",
    name: "Speed Baccarat",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-161",
    cateogry: "EVO",
    type: "BACCARAT",
  },
  {
    img: "../assets/images/Baccarat/EVOLUTION-LIVE-253.png",
    name: "Speed Baccarat",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-253",
    cateogry: "EVO",
    type: "BACCARAT",
  },

  {
    img: "../assets/images/Baccarat/EVOLUTION-LIVE-254.png",
    name: "Speed Baccarat",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-254",
    cateogry: "EVO",
    type: "BACCARAT",
  },

  {
    img: "../assets/images/Baccarat/EVOLUTION-LIVE-153.png",
    name: "Speed Baccarat",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-153",
    cateogry: "EVO",
    type: "BACCARAT",
  },
  {
    img: "../assets/images/Baccarat/EVOLUTION-LIVE-017.png",
    name: "Speed Baccarat",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-017",
    cateogry: "EVO",
    type: "BACCARAT",
  },

  {
    img: "../assets/images/Baccarat/BACCARAT-5.webp",
    name: "Lightning Baccarat First Person",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-255",
    cateogry: "EVO",
    type: "BACCARAT",
  },
  {
    img: "../assets/images/Baccarat/EVOLUTION-LIVE-036.png",
    name: "Speed Baccarat",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-036",
    cateogry: "EVO",
    type: "BACCARAT",
  },
  {
    img: "../assets/images/Baccarat/EVOLUTION-LIVE-041.png",
    name: "Speed Baccarat",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-041",
    cateogry: "EVO",
    type: "BACCARAT",
  },
  {
    img: "../assets/images/Baccarat/EVOLUTION-LIVE-046.png",
    name: "Speed Baccarat",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-046",
    cateogry: "EVO",
    type: "BACCARAT",
  },

  // {
  //   img: "../assets/images/Baccarat/BACCARAT-17.webp",
  //   name: "Baccarat Classic",
  //   platForm: "VENUS",
  //   gameType: "LIVE",
  //   casinoType: "VN-LIVE-001",
  //   cateogry: "VENUS",
  //   type: "BACCARAT",
  // },
  // {
  //   img: "../assets/images/Baccarat/BACCARAT-18.webp",
  //   name: "Baccarat Classic",
  //   platForm: "VENUS",
  //   gameType: "LIVE",
  //   casinoType: "VN-LIVE-001",
  //   cateogry: "VENUS",
  //   type: "BACCARAT",
  // },
  // {
  //   img: "../assets/images/Baccarat/BACCARAT-19.webp",
  //   name: "Baccarat Classic",
  //   platForm: "VENUS",
  //   gameType: "LIVE",
  //   casinoType: "VN-LIVE-001",
  //   cateogry: "VENUS",
  //   type: "BACCARAT",
  // },
  // {
  //   img: "../assets/images/Baccarat/BACCARAT-20.webp",
  //   name: "Baccarat Classic",
  //   platForm: "VENUS",
  //   gameType: "LIVE",
  //   casinoType: "VN-LIVE-001",
  //   cateogry: "VENUS",
  //   type: "BACCARAT",
  // },
  // {
  //   img: "../assets/images/Baccarat/BACCARAT-21.webp",
  //   name: "Baccarat Classic",
  //   platForm: "VENUS",
  //   gameType: "LIVE",
  //   casinoType: "VN-LIVE-001",
  //   cateogry: "VENUS",
  //   type: "BACCARAT",
  // },
  // {
  //   img: "../assets/images/Baccarat/BACCARAT-22.webp",
  //   name: "Baccarat Classic",
  //   platForm: "VENUS",
  //   gameType: "LIVE",
  //   casinoType: "VN-LIVE-001",
  //   cateogry: "VENUS",
  //   type: "BACCARAT",
  // },

  // {
  //   img: "../assets/images/Baccarat/BACCARAT-26.webp",
  //   name: "Speed Baccarat",
  //   platForm: "VENUS",
  //   gameType: "LIVE",
  //   casinoType: "VN-LIVE-002",
  //   cateogry: "VENUS",
  //   type: "BACCARAT",
  // },
  // {
  //   img: "../assets/images/Baccarat/BACCARAT-27.webp",
  //   name: "Baccarat Insurance",
  //   platForm: "SEXY",
  //   gameType: "LIVE",
  //   casinoType: "MX-LIVE-002",
  //   cateogry: "SEXY",
  //   type: "BACCARAT",
  // },
  // {
  //   img: "../assets/images/Baccarat/BACCARAT-28.webp",
  //   name: "Baccarat Insurance",
  //   platForm: "VENUS",
  //   gameType: "LIVE",
  //   casinoType: "VN-LIVE-003",
  //   cateogry: "VENUS",
  //   type: "BACCARAT",
  // },
  // Baccarat End

  // Roulette Start
  {
    img: "../assets/images/Roulette/HOTROAD-LIVE-002.webp",
    name: "HOTROAD-LIVE-002",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-002",
    cateogry: "HOTROAD",
    type: "ROULETTE",
    table: "1001",
    isPopular: true,
  },
  {
    img: "../assets/images/Roulette/HOTROAD-LIVE-002.webp",
    name: "HOTROAD-LIVE-002",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-002",
    cateogry: "HOTROAD",
    type: "ROULETTE",
    table: "1002",
    isPopular: true,
  },
  {
    img: "../assets/images/Roulette/HOTROAD-LIVE-002.webp",
    name: "HOTROAD-LIVE-002",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-002",
    cateogry: "HOTROAD",
    type: "ROULETTE",
    table: "1003",
  },
  {
    img: "../assets/images/Roulette/HOTROAD-LIVE-002.webp",
    name: "HOTROAD-LIVE-002",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-002",
    cateogry: "HOTROAD",
    type: "ROULETTE",
    table: "1004",
  },
  {
    img: "../assets/images/Roulette/HOTROAD-LIVE-002.webp",
    name: "HOTROAD-LIVE-002",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-002",
    cateogry: "HOTROAD",
    type: "ROULETTE",
    table: "1005",
  },
  {
    img: "../assets/images/Roulette/HOTROAD-LIVE-002.webp",
    name: "HOTROAD-LIVE-002",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-002",
    cateogry: "HOTROAD",
    type: "ROULETTE",
    table: "1006",
  },
  {
    img: "../assets/images/Roulette/HOTROAD-LIVE-004.webp",
    name: "HOTROAD-LIVE-004",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-004",
    cateogry: "HOTROAD",
    type: "ROULETTE",
    table: "5001",
    isPopular: true,
  },
  {
    img: "../assets/images/Roulette/HOTROAD-LIVE-004.webp",
    name: "HOTROAD-LIVE-004",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-004",
    cateogry: "HOTROAD",
    type: "ROULETTE",
    table: "5002",
    isPopular: true,
  },
  {
    img: "../assets/images/Roulette/HOTROAD-LIVE-004.webp",
    name: "HOTROAD-LIVE-004",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-004",
    cateogry: "HOTROAD",
    type: "ROULETTE",
    table: "5003",
  },
  {
    img: "../assets/images/Roulette/HOTROAD-LIVE-004.webp",
    name: "HOTROAD-LIVE-004",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-004",
    cateogry: "HOTROAD",
    type: "ROULETTE",
    table: "5004",
  },
  {
    img: "../assets/images/Roulette/HOTROAD-LIVE-004.webp",
    name: "HOTROAD-LIVE-004",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-004",
    cateogry: "HOTROAD",
    type: "ROULETTE",
    table: "5005",
  },
  {
    img: "../assets/images/Roulette/HOTROAD-LIVE-004.webp",
    name: "HOTROAD-LIVE-004",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-004",
    cateogry: "HOTROAD",
    type: "ROULETTE",
    table: "5006",
  },
  {
    img: "../assets/images/Roulette/ROULETTE-1.webp",
    name: "Roulette Live",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-001",
    cateogry: "EVO",
    type: "ROULETTE",
    isPopular: true,
  },
  {
    img: "../assets/images/Roulette/ROULETTE-2.webp",
    name: "Roulette Live",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-080",
    cateogry: "EVO",
    type: "ROULETTE",
    isPopular: true,
  },
  {
    img: "../assets/images/Roulette/ROULETTE-3.webp",
    name: "Roulette Live",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-078",
    cateogry: "EVO",
    type: "ROULETTE",
    isPopular: true,
  },
  {
    img: "../assets/images/Roulette/ROULETTE-4.webp",
    name: "Roulette Live",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-079",
    cateogry: "EVO",
    type: "ROULETTE",
    isPopular: true,
  },
  {
    img: "../assets/images/Roulette/ROULETTE-5.webp",
    name: "Instant Roulette",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-008",
    cateogry: "EVO",
    type: "ROULETTE",
    isPopular: true,
  },
  {
    img: "../assets/images/Roulette/ROULETTE-6.webp",
    name: "Roulette First Person",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-013",
    cateogry: "EVO",
    type: "ROULETTE",
    isPopular: true,
  },
  {
    img: "../assets/images/Roulette/ROULETTE-7.webp",
    name: "Amercian Roulette Live",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-020",
    cateogry: "EVO",
    type: "ROULETTE",
    isPopular: true,
  },


  {
    img: "../assets/images/Roulette/ROULETTE-9.webp",
    name: "Roulette",
    table: "71",
    platForm: "SEXYBCRT",
    gameType: "LIVE",
    casinoType: "MX-LIVE-009",
    cateogry: "SEXY",
    type: "ROULETTE",
    isPopular: true,
  },

  {
    img: "../assets/images/live/sexy/MX-LIVE-009.webp",
    name: "Roulette",
    platForm: "SEXYBCRT",
    gameType: "LIVE",
    casinoType: "MX-LIVE-009",
    cateogry: "SEXY",
    type: "ROULETTE",
    isPopular: true,
  },


  {
    img: "../assets/images/Roulette/ROULETTE-10.webp",
    name: "Roulette",
    platForm: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-029",
    cateogry: "PP",
    type: "ROULETTE",
    isPopular: true,
  },
  {
    img: "../assets/images/Roulette/ROULETTE-11.webp",
    name: "Auto Roulette",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-026",
    cateogry: "PP",
    type: "ROULETTE",
    isPopular: true,
  },
  {
    img: "../assets/images/Roulette/ROULETTE-12.webp",
    name: "Speed Auto Roulette",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-060",
    cateogry: "PP",
    type: "ROULETTE",
    isPopular: true,
  },
  {
    img: "../assets/images/Roulette/PT-LIVE-102.png",
    name: "Speed Roulette 2",
    platForm: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-067",
    cateogry: "PP",
    type: "ROULETTE",
    isPopular: true,
  },
  // {
  //   img: "../assets/images/Roulette/ROULETTE-13.webp",
  //   name: "Roulette",
  //   platForm: "VENUS",
  //   gameType: "LIVE",
  //   casinoType: "VN-LIVE-009",
  //   cateogry: "VENUS",
  //   type: "ROULETTE",
  // },
  {
    img: "../assets/images/Roulette/ROULETTE-14.webp",
    name: "Speed Roulette",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-027",
    cateogry: "PP",
    type: "ROULETTE",
    isPopular: true,
  },
  {
    img: "../assets/images/Roulette/ROULETTE-15.webp",
    name: "Azure Roulette",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-028",
    cateogry: "PP",
    type: "ROULETTE",
    isPopular: true,
  },
  {
    img: "../assets/images/Roulette/PT-LIVE-100.png",
    name: "Speed Roulette 2",
    platForm: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-100",
    cateogry: "PT",
    type: "ROULETTE",
  },
  {
    img: "../assets/images/Roulette/PT-LIVE-102.png",
    name: "Speed Roulette 2",
    platForm: "PT",
    gameType: "LIVE",
    casinoType: "PP-LIVE-102",
    cateogry: "PT",
    type: "ROULETTE",
  },

  {
    img: "../assets/images/Roulette/ROULETTE-16.webp",
    name: "American Roulette Live",
    platForm: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-021",
    cateogry: "PT",
    type: "ROULETTE",
    isPopular: true,
  },
  {
    img: "../assets/images/Roulette/ROULETTE-17.webp",
    name: "Deutsches Roulette Live",
    platForm: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-022",
    cateogry: "PT",
    type: "ROULETTE",
    isPopular: true,
  },
  {
    img: "../assets/images/Roulette/ROULETTE-18.webp",
    name: "Roulette Live",
    platForm: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-025",
    cateogry: "PT",
    type: "ROULETTE",
    isPopular: true,
  },
  {
    img: "../assets/images/Roulette/ROULETTE-19.webp",
    name: "Football French Roulette",
    platForm: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-023",
    cateogry: "PT",
    type: "ROULETTE",
    isPopular: true,
  },
  {
    img: "../assets/images/Roulette/ROULETTE-20.webp",
    name: "Football Roulette",
    platForm: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-024",
    cateogry: "PT",
    type: "ROULETTE",
    isPopular: true,
  },
  {
    img: "../assets/images/Roulette/ROULETTE-21.webp",
    name: "Spread Bets Roulette",
    platForm: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-027",
    cateogry: "PT",
    type: "ROULETTE",
    isPopular: true,
  },
  {
    img: "../assets/images/Roulette/EVOLUTION-LIVE-170.png",
    name: "Roulette Live",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-170",
    cateogry: "EVO",
    type: "ROULETTE",
  },
  {
    img: "../assets/images/Roulette/EVOLUTION-LIVE-171.png",
    name: "Roulette Live",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-171",
    cateogry: "EVO",
    type: "ROULETTE",
  },
  {
    img: "../assets/images/Roulette/EVOLUTION-LIVE-180.png",
    name: "Roulette Live",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-180",
    cateogry: "EVO",
    type: "ROULETTE",
  },

  {
    img: "../assets/images/Roulette/EVOLUTION-LIVE-257.png",
    name: "Roulette Live",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-257",
    cateogry: "EVO",
    type: "ROULETTE",
  },

  {
    img: "../assets/images/Roulette/EVOLUTION-LIVE-209.png",
    name: "Roulette Live",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-209",
    cateogry: "EVO",
    type: "ROULETTE",
  },

  {
    img: "../assets/images/Roulette/EVOLUTION-LIVE-206.png",
    name: "Roulette Live",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-206",
    cateogry: "EVO",
    type: "ROULETTE",
  },

  {
    img: "../assets/images/Roulette/EVOLUTION-LIVE-081.png",
    name: "Roulette Live",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-081",
    cateogry: "EVO",
    type: "ROULETTE",
  },

  // {
  //   img: "../assets/images/Roulette/HOTROAD-LIVE-004.webp",
  //   name: "HOTROAD-LIVE-004",
  //   platForm: "HOTROAD",
  //   gameType: "LIVE",
  //   casinoType: "HOTROAD-LIVE-004",
  //   cateogry: "HOTROAD",
  //   type: "ROULETTE",
  //   table: "5003",
  // },
  // {
  //   img: "../assets/images/Roulette/HOTROAD-LIVE-004.webp",
  //   name: "HOTROAD-LIVE-004",
  //   platForm: "HOTROAD",
  //   gameType: "LIVE",
  //   casinoType: "HOTROAD-LIVE-004",
  //   cateogry: "HOTROAD",
  //   type: "ROULETTE",
  //   table: "5004",
  // },
  // {
  //   img: "../assets/images/Roulette/HOTROAD-LIVE-004.webp",
  //   name: "HOTROAD-LIVE-004",
  //   platForm: "HOTROAD",
  //   gameType: "LIVE",
  //   casinoType: "HOTROAD-LIVE-004",
  //   cateogry: "HOTROAD",
  //   type: "ROULETTE",
  //   table: "5005",
  // },
  // {
  //   img: "../assets/images/Roulette/HOTROAD-LIVE-004.webp",
  //   name: "HOTROAD-LIVE-004",
  //   platForm: "HOTROAD",
  //   gameType: "LIVE",
  //   casinoType: "HOTROAD-LIVE-004",
  //   cateogry: "HOTROAD",
  //   type: "ROULETTE",
  //   table: "5006",
  // },

  // {
  //   img: "../assets/images/Roulette/HOTROAD-LIVE-002.webp",
  //   name: "HOTROAD-LIVE-002",
  //   platForm: "HOTROAD",
  //   gameType: "LIVE",
  //   casinoType: "HOTROAD-LIVE-002",
  //   cateogry: "HOTROAD",
  //   type: "ROULETTE",
  //   table: "1003",
  // },
  // {
  //   img: "../assets/images/Roulette/HOTROAD-LIVE-002.webp",
  //   name: "HOTROAD-LIVE-002",
  //   platForm: "HOTROAD",
  //   gameType: "LIVE",
  //   casinoType: "HOTROAD-LIVE-002",
  //   cateogry: "HOTROAD",
  //   type: "ROULETTE",
  //   table: "1004",
  // },
  // {
  //   img: "../assets/images/Roulette/HOTROAD-LIVE-002.webp",
  //   name: "HOTROAD-LIVE-002",
  //   platForm: "HOTROAD",
  //   gameType: "LIVE",
  //   casinoType: "HOTROAD-LIVE-002",
  //   cateogry: "HOTROAD",
  //   type: "ROULETTE",
  //   table: "1005",
  // },
  // {
  //   img: "../assets/images/Roulette/HOTROAD-LIVE-002.webp",
  //   name: "HOTROAD-LIVE-002",
  //   platForm: "HOTROAD",
  //   gameType: "LIVE",
  //   casinoType: "HOTROAD-LIVE-002",
  //   cateogry: "HOTROAD",
  //   type: "ROULETTE",
  //   table: "1006",
  // },
  {
    img: "../assets/images/Dice/HOTROAD-LIVE-006.webp",
    name: "HOTROAD-LIVE-006",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-006",
    cateogry: "HOTROAD",
    type: "DICE",
    table: "4001",
    isPopular: true,
  },
  {
    img: "../assets/images/Dice/HOTROAD-LIVE-006.webp",
    name: "HOTROAD-LIVE-006",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-006",
    cateogry: "HOTROAD",
    type: "DICE",
    table: "4002",
    isPopular: true,
  },
  {
    img: "../assets/images/Dice/HOTROAD-LIVE-006.webp",
    name: "HOTROAD-LIVE-006",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-006",
    cateogry: "HOTROAD",
    type: "DICE",
    table: "4003",
  },
  {
    img: "../assets/images/Dice/HOTROAD-LIVE-006.webp",
    name: "HOTROAD-LIVE-006",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-006",
    cateogry: "HOTROAD",
    type: "DICE",
    table: "4004",
  },
  {
    img: "../assets/images/Dice/HOTROAD-LIVE-006.webp",
    name: "HOTROAD-LIVE-006",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-006",
    cateogry: "HOTROAD",
    type: "DICE",
    table: "4005",
  },
  {
    img: "../assets/images/Dice/HOTROAD-LIVE-006.webp",
    name: "HOTROAD-LIVE-006",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-006",
    cateogry: "HOTROAD",
    type: "DICE",
    table: "4006",
  },
  {
    img: "../assets/images/Dice/DICE-1.webp",
    name: "Bac Bo Live",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-172",
    cateogry: "EVO",
    type: "DICE",
    isPopular: true,
  },
  {
    img: "../assets/images/Dice/DICE-2.webp",
    name: "Super Sic Bo",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-005",
    cateogry: "EVO",
    type: "DICE",
    isPopular: true,
  },
  {
    img: "../assets/images/Dice/EVOLUTION-LIVE-259.png",
    name: "First Person Super Sic Bo",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-259",
    cateogry: "EVO",
    type: "DICE",
    isPopular: true,
  },
  {
    img: "../assets/images/Dice/EVOLUTION-LIVE-260.png",
    name: "Instant Super Sic Bo",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-260",
    cateogry: "EVO",
    type: "DICE",
    isPopular: true,
  },

  {
    img: "../assets/images/Dice/DICE-3.webp",
    name: "Craps Live",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-003",
    cateogry: "EVO",
    type: "DICE",
    isPopular: true,
  },
  {
    img: "../assets/images/Dice/DICE-4.webp",
    name: "Experor Sic Bo",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-211",
    cateogry: "EVO",
    type: "DICE",
    isPopular: true,
  },

  {
    img: "../assets/images/Dice/DICE-5.webp",
    name: "Extra Sic bo",
    platForm: "SEXYBCRT",
    gameType: "LIVE",
    casinoType: "MX-LIVE-016",
    cateogry: "SEXY",
    type: "DICE",
    table: "131",
    isPopular: true,
  },
  {
    img: "../assets/images/live/sexy/MX-LIVE-014.webp",
    name: "Thai Hi Lo",
    platForm: "SEXYBCRT",
    gameType: "LIVE",
    casinoType: "MX-LIVE-014",
    cateogry: "SEXY",
    type: "DICE",
    isPopular: true,
  },


  {
    img: "../assets/images/Dice/PP-LIVE-079.webp",
    name: "Sic bo",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-079",
    cateogry: "PP",
    type: "DICE",
    isPopular: true,
  },
  {
    img: "../assets/images/Dice/PT-LIVE-099.png",
    name: "Speed SicBo",
    platForm: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-099",
    cateogry: "PT",
    type: "DICE",
    isPopular: true,
  },
  {
    img: "../assets/images/Dice/EVOLUTION-LIVE-031.png",
    name: "Experor Sic Bo",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-031",
    cateogry: "EVO",
    type: "DICE",
  },
  {
    img: "../assets/images/Dice/EVOLUTION-LIVE-047.png",
    name: "Experor Sic Bo",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-047",
    cateogry: "EVO",
    type: "DICE",
  },

  // {
  //   img: "../assets/images/Dice/DICE-6.webp",
  //   name: "Red Blue Duel",
  //   platForm: "SEXYBCRT",
  //   gameType: "LIVE",
  //   casinoType: "MX-LIVE-010",
  //   cateogry: "SEXY",
  //   type: "DICE",
  // },
  // {
  //   img: "../assets/images/Dice/DICE-7.webp",
  //   name: "Sic Bo",
  //   platForm: "VENUS",
  //   gameType: "LIVE",
  //   casinoType: "VN-LIVE-007",
  //   cateogry: "VENUS",
  //   type: "DICE",
  // },

  // {
  //   img: "../assets/images/Dice/HOTROAD-LIVE-006.webp",
  //   name: "HOTROAD-LIVE-006",
  //   platForm: "HOTROAD",
  //   gameType: "LIVE",
  //   casinoType: "HOTROAD-LIVE-006",
  //   cateogry: "HOTROAD",
  //   type: "DICE",
  //   table: "4003",
  // },
  // {
  //   img: "../assets/images/Dice/HOTROAD-LIVE-006.webp",
  //   name: "HOTROAD-LIVE-006",
  //   platForm: "HOTROAD",
  //   gameType: "LIVE",
  //   casinoType: "HOTROAD-LIVE-006",
  //   cateogry: "HOTROAD",
  //   type: "DICE",
  //   table: "4004",
  // },
  // {
  //   img: "../assets/images/Dice/HOTROAD-LIVE-006.webp",
  //   name: "HOTROAD-LIVE-006",
  //   platForm: "HOTROAD",
  //   gameType: "LIVE",
  //   casinoType: "HOTROAD-LIVE-006",
  //   cateogry: "HOTROAD",
  //   type: "DICE",
  //   table: "4005",
  // },
  // Tradiotional Start
  {
    img: "../assets/images/TraditionalGames/HOTROAD-LIVE-003.webp",
    name: "HOTROAD-LIVE-003",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-003",
    cateogry: "HOTROAD",
    type: "TRADITIONAL",
    table: "2001",
    isPopular: true,
  },
  {
    img: "../assets/images/TraditionalGames/HOTROAD-LIVE-003.webp",
    name: "HOTROAD-LIVE-003",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-003",
    cateogry: "HOTROAD",
    type: "TRADITIONAL",
    table: "2002",
    isPopular: true,
  },
  {
    img: "../assets/images/TraditionalGames/HOTROAD-LIVE-003.webp",
    name: "HOTROAD-LIVE-003",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-003",
    cateogry: "HOTROAD",
    type: "TRADITIONAL",
    table: "2003",
  },
  {
    img: "../assets/images/TraditionalGames/HOTROAD-LIVE-003.webp",
    name: "HOTROAD-LIVE-003",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-003",
    cateogry: "HOTROAD",
    type: "TRADITIONAL",
    table: "2004",
  },
  {
    img: "../assets/images/TraditionalGames/HOTROAD-LIVE-003.webp",
    name: "HOTROAD-LIVE-003",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-003",
    cateogry: "HOTROAD",
    type: "TRADITIONAL",
    table: "2005",
  },
  {
    img: "../assets/images/TraditionalGames/HOTROAD-LIVE-003.webp",
    name: "HOTROAD-LIVE-003",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-003",
    cateogry: "HOTROAD",
    type: "TRADITIONAL",
    table: "2006",
  },
  {
    img: "../assets/images/TraditionalGames/HOTROAD-LIVE-008.webp",
    name: "HOTROAD-LIVE-008",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-008",
    cateogry: "HOTROAD",
    type: "TRADITIONAL",
    table: "7001",
    isPopular: true,
  },
  {
    img: "../assets/images/TraditionalGames/HOTROAD-LIVE-008.webp",
    name: "HOTROAD-LIVE-008",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-008",
    cateogry: "HOTROAD",
    type: "TRADITIONAL",
    table: "7002",
    isPopular: true,
  },
  {
    img: "../assets/images/TraditionalGames/HOTROAD-LIVE-008.webp",
    name: "HOTROAD-LIVE-008",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-008",
    cateogry: "HOTROAD",
    type: "TRADITIONAL",
    table: "7003",
  },
  {
    img: "../assets/images/TraditionalGames/TRADINATIONAL-1.webp",
    name: "Super Andhar Bahar",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-204",
    cateogry: "EVO",
    type: "TRADITIONAL",
    isPopular: true,
  },
  {
    img: "../assets/images/TraditionalGames/TRADINATIONAL-2.webp",
    name: "Fan Tan",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-178",
    cateogry: "EVO",
    type: "TRADITIONAL",
    isPopular: true,
  },
  {
    img: "../assets/images/TraditionalGames/TRADINATIONAL-4.webp",
    name: "Dragon Tiger",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-004",
    cateogry: "EVO",
    type: "TRADITIONAL",
    isPopular: true,
  },
  {
    img: "../assets/images/TraditionalGames/TRADINATIONAL-3.webp",
    name: "Dragon Tiger",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-077",
    cateogry: "EVO",
    type: "TRADITIONAL",
    isPopular: true,
  },

  {
    img: "../assets/images/TraditionalGames/TRADINATIONAL-5.webp",
    name: "Teen Patti Live",
    platForm: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-026",
    cateogry: "EVO",
    type: "TRADITIONAL",
    isPopular: true,
  },

  {
    img: "../assets/images/TraditionalGames/TRADINATIONAL-6.webp",
    name: "Dragon Tiger",
    platForm: "SEXYBCRT",
    gameType: "LIVE",
    casinoType: "MX-LIVE-006",
    cateogry: "SEXY",
    table:'31',
    type: "TRADITIONAL",
    isPopular: true,
  },
  {
    img: "../assets/images/TraditionalGames/TRADINATIONAL-7.webp",
    name: "Dragon Tiger",
    platForm: "SEXYBCRT",
    gameType: "LIVE",
    casinoType: "MX-LIVE-006",
    cateogry: "SEXY", table:'32',
    type: "TRADITIONAL",
    isPopular: true,
  },
  {
    img: "../assets/images/TraditionalGames/TRADINATIONAL-10.webp",
    name: "Dragon Tiger",
    platForm: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-002",
    cateogry: "PT",
    type: "TRADITIONAL",
    isPopular: true,
  },
  {
    img: "../assets/images/TraditionalGames/TRADINATIONAL-13.webp",
    name: "Dragon Tiger",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-042",
    cateogry: "PP",
    type: "TRADITIONAL",
    isPopular: true,
  },

  // {
  //   img: "../assets/images/TraditionalGames/TRADINATIONAL-15.webp",
  //   name: "Dragon Tiger",
  //   platForm: "VN",
  //   gameType: "LIVE",
  //   casinoType: "VN-LIVE-006",
  //   cateogry: "VENUS",
  //   type: "TRADITIONAL",
  // },
  // {
  //   img: "../assets/images/TraditionalGames/TRADINATIONAL-16.webp",
  //   name: "Dragon Tiger",
  //   platForm: "VN",
  //   gameType: "LIVE",
  //   casinoType: "VN-LIVE-006",
  //   cateogry: "VENUS",
  //   type: "TRADITIONAL",
  // },
  {
    img: "../assets/images/TraditionalGames/TRADINATIONAL-9.webp",
    name: "Extra Teen Patti",
    platForm: "SEXYBCRT",
    gameType: "LIVE",
    casinoType: "MX-LIVE-012",
    cateogry: "SEXY",
    table:'101',
    type: "TRADITIONAL",
    isPopular: true,
  },
  {
    img: "../assets/images/TraditionalGames/TRADINATIONAL-11.webp",
    name: "Andhar Bahar Live",
    platForm: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-004",
    cateogry: "PT",
    type: "TRADITIONAL",
    isPopular: true,
  },
  {
    img: "../assets/images/TraditionalGames/PT-LIVE-087.png",
    name: "Andhar Bahar Live",
    platForm: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-087",
    cateogry: "PT",
    type: "TRADITIONAL",
  },

  {
    img: "../assets/images/TraditionalGames/TRADINATIONAL-14.webp",
    name: "Andhar Bahar",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-043",
    cateogry: "PP",
    type: "TRADITIONAL",
    isPopular: true,
  },

  {
    img: "../assets/images/TraditionalGames/TRADINATIONAL-8.webp",
    name: "Teen Patti",
    platForm: "SEXYBCRT",
    gameType: "LIVE",
    casinoType: "MX-LIVE-011",
    cateogry: "SEXY",
    table:'81',
    type: "TRADITIONAL",
    isPopular: true,
  },
  {
    img: "../assets/images/Dice/MX-LIVE-017_SEXY.png",
    name: "xocdia",
    platForm: "SEXYBCRT",
    gameType: "LIVE",
    casinoType: "MX-LIVE-017",
    cateogry: "SEXY",
    table: "151",
    type: "TRADITIONAL",
    isPopular: true,
  },
  {
    img: "../assets/images/TraditionalGames/EVOLUTION-LIVE-033.png",
    name: "Teen Patti Live",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-033",
    cateogry: "EVO",
    type: "TRADITIONAL",
  },
  // {
  //   img: "../assets/images/TraditionalGames/HOTROAD-LIVE-003.webp",
  //   name: "HOTROAD-LIVE-003",
  //   platForm: "HOTROAD",
  //   gameType: "LIVE",
  //   casinoType: "HOTROAD-LIVE-003",
  //   cateogry: "HOTROAD",
  //   type: "TRADITIONAL",
  //   table: "2003",
  // },
  // {
  //   img: "../assets/images/TraditionalGames/HOTROAD-LIVE-003.webp",
  //   name: "HOTROAD-LIVE-003",
  //   platForm: "HOTROAD",
  //   gameType: "LIVE",
  //   casinoType: "HOTROAD-LIVE-003",
  //   cateogry: "HOTROAD",
  //   type: "TRADITIONAL",
  //   table: "2004",
  // },
  // {
  //   img: "../assets/images/TraditionalGames/HOTROAD-LIVE-003.webp",
  //   name: "HOTROAD-LIVE-003",
  //   platForm: "HOTROAD",
  //   gameType: "LIVE",
  //   casinoType: "HOTROAD-LIVE-003",
  //   cateogry: "HOTROAD",
  //   type: "TRADITIONAL",
  //   table: "2005",
  // },
  // {
  //   img: "../assets/images/TraditionalGames/HOTROAD-LIVE-003.webp",
  //   name: "HOTROAD-LIVE-003",
  //   platForm: "HOTROAD",
  //   gameType: "LIVE",
  //   casinoType: "HOTROAD-LIVE-003",
  //   cateogry: "HOTROAD",
  //   type: "TRADITIONAL",
  //   table: "2006",
  // },

  // {
  //   img: "../assets/images/TraditionalGames/HOTROAD-LIVE-008.webp",
  //   name: "HOTROAD-LIVE-008",
  //   platForm: "HOTROAD",
  //   gameType: "LIVE",
  //   casinoType: "HOTROAD-LIVE-008",
  //   cateogry: "HOTROAD",
  //   type: "TRADITIONAL",
  //   table: "7003",
  // },
  // {
  //   img: "../assets/images/TraditionalGames/TRADINATIONAL-12.webp",
  //   name: "Teen Patti",
  //   platForm: "EVOLUTION",
  //   gameType: "LIVE",
  //   casinoType: "EVOLUTION-LIVE-026",
  //   cateogry: "PT",
  //   type: "TRADITIONAL",
  // },
  // Tradiotional End

  // {
  //   img: "../assets/images/CardGames/EVOLUTION-LIVE-181.webp",
  //   name: "Lightning Black Jack",
  //   platForm: "EVOLUTION",
  //   gameType: "LIVE",
  //   casinoType: "EVOLUTION-LIVE-181",
  //   cateogry: "EVOLUTION",
  //   type: "GAME-CARD",
  // },
  {
    img: "../assets/images/CardGames/EVOLUTION-LIVE-208.webp",
    name: "Lightning Black Jack First Person",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-208",
    cateogry: "EVOLUTION",
    type: "GAME-CARD",
  },
  {
    img: "../assets/images/CardGames/EVOLUTION-LIVE-227.png",
    name: "Lightning Black Jack First Person",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-227",
    cateogry: "EVOLUTION",
    type: "GAME-CARD",
  },
  {
    img: "../assets/images/CardGames/EVOLUTION-LIVE-009.webp",
    name: "Triple Card Poker",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-009",
    cateogry: "EVOLUTION",
    type: "GAME-CARD",
  },
  {
    img: "../assets/images/CardGames/EVOLUTION-LIVE-012.webp",
    name: "Infinite Black Jack",
    platForm: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-012",
    cateogry: "EVOLUTION",
    type: "GAME-CARD",
  },
  {
    img: "../assets/images/CardGames/PT-LIVE-007.png",
    name: "Alexandrite Blackjack",
    platForm: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-007",
    cateogry: "PT",
    type: "GAME-CARD",
  },
  {
    img: "../assets/images/CardGames/PP-LIVE-040.webp",
    name: "One Blackjack",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-082",
    cateogry: "PP",
    type: "GAME-CARD",
  },
  {
    img: "../assets/images/CardGames/PP-LIVE-041.webp",
    name: "ONE Blackjack 2 - Ruby",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-083",
    cateogry: "PP",
    type: "GAME-CARD",
  },
  {
    img: "../assets/images/CardGames/PT-LIVE-008.webp",
    name: "Majority Rules Speed Blackjack",
    platForm: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-008",
    cateogry: "PT",
    type: "GAME-CARD",
  },
  {
    img: "../assets/images/CardGames/PT-LIVE-009.png",
    name: "Majority Rules Speed Blackjack",
    platForm: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-009",
    cateogry: "PT",
    type: "GAME-CARD",
  },
  // {
  //   img: "../assets/images/CardGames/EVOLUTION-LIVE-002.webp",
  //   name: "Black Jack A",
  //   platForm: "EVOLUTION",
  //   gameType: "LIVE",
  //   casinoType: "EVOLUTION-LIVE-002",
  //   cateogry: "EVOLUTION",
  //   type: "GAME-CARD",
  // },
  // {
  //   img: "../assets/images/CardGames/EVOLUTION-LIVE-015.webp",
  //   name: "Casino Hold'em",
  //   platForm: "EVOLUTION",
  //   gameType: "LIVE",
  //   casinoType: "EVOLUTION-LIVE-015",
  //   cateogry: "EVOLUTION",
  //   type: "GAME-CARD",
  // },

  // {
  //   img: "../assets/images/CardGames/EVOLUTION-LIVE-024.webp",
  //   name: "Caribbean Stud Poker",
  //   platForm: "EVOLUTION",
  //   gameType: "LIVE",
  //   casinoType: "EVOLUTION-LIVE-024",
  //   cateogry: "EVOLUTION",
  //   type: "GAME-CARD",
  // },

  // {
  //   img: "../assets/images/CardGames/PT-LIVE-007.webp",
  //   name: "All bets Blackjack",
  //   platForm: "PT",
  //   gameType: "LIVE",
  //   casinoType: "PT-LIVE-007",
  //   cateogry: "PT",
  //   type: "GAME-CARD",
  // },

  {
    img: "../assets/images/CardGames/PT-LIVE-010.webp",
    name: "Unlimited Blackjack",
    platForm: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-010",
    cateogry: "PT",
    type: "GAME-CARD",
  },

  {
    img: "../assets/images/CardGames/PT-LIVE-016.webp",
    name: "3 Card Brag",
    platForm: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-016",
    cateogry: "PT",
    type: "GAME-CARD",
  },
  {
    img: "../assets/images/CardGames/PT-LIVE-017.webp",
    name: "Casino Hold AEM",
    platForm: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-017",
    cateogry: "PT",
    type: "GAME-CARD",
  },
  {
    img: "../assets/images/CardGames/PT-LIVE-019.webp",
    name: "Bet on Poker Live",
    platForm: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-019",
    cateogry: "PT",
    type: "GAME-CARD",
  },
  // {
  //   img: "../assets/images/CardGames/PT-LIVE-009.webp",
  //   name: "Sette E Mezzo",
  //   platForm: "PT",
  //   gameType: "LIVE",
  //   casinoType: "PT-LIVE-009",
  //   cateogry: "PT",
  //   type: "GAME-CARD",
  // },
  // Table Start  (casino Done) -------
{
    img: "../assets/images/Table/kingmaker/KM-TABLE-086.png",
    name: "CHICKEN CROSSY",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-086",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
{
    img: "../assets/images/Table/kingmaker/KM-TABLE-081.png",
    name: "Egyptian Mines",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-081",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },

{
    img: "../assets/images/Table/kingmaker/KM-TABLE-044.png",
    name: "Dota Hi-Lo",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-044",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
{
    img: "../assets/images/Table/kingmaker/KM-TABLE-047.png",
    name: "Heist",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-047",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
{
    img: "../assets/images/Table/kingmaker/KM-TABLE-087.png",
    name: "COLOR GAME MEGA BONUS",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-087",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },

{
    img: "../assets/images/Table/kingmaker/KM-TABLE-085.png",
    name: "Teen Patti Blitz",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-085",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
{
    img: "../assets/images/Table/kingmaker/KM-TABLE-083.png",
    name: "BURMESE 6 ANIMALS",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-083",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },

{
    img: "../assets/images/Table/kingmaker/KM-TABLE-084.png",
    name: "Speedy Andar Bahar",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-084",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },

{
    img: "../assets/images/Table/kingmaker/KM-TABLE-080.png",
    name: "Jogo de Bozó",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-080",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },

{
    img: "../assets/images/Table/kingmaker/KM-TABLE-082.png",
    name: "Bicho",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-082",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
{
    img: "../assets/images/Table/kingmaker/KM-TABLE-079.png",
    name: "LADDER GAME",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-079",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
{
    img: "../assets/images/Table/kingmaker/KM-TABLE-019.png",
    name: "Thai Fish Prawn Crab",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-019",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
{
    img: "../assets/images/Table/kingmaker/KM-TABLE-017.png",
    name: "taixiu",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-017",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },


{
    img: "../assets/images/Table/kingmaker/KM-TABLE-010.png",
    name: "belangkai 2",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-010",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
{
    img: "../assets/images/Table/kingmaker/KM-TABLE-011.png",
    name: "dragon-tiger2",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-011",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },

{
    img: "../assets/images/Table/kingmaker/KM-TABLE-046.png",
    name: "Teen Patti",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-046",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
{
    img: "../assets/images/Table/kingmaker/KM-TABLE-027.png",
    name: "european roulette",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-027",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
 
{
    img: "../assets/images/Table/kingmaker/KM-TABLE-023.png",
    name: "xocdia2",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-023",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
{
    img: "../assets/images/Table/kingmaker/KM-TABLE-051.png",
    name: "KM Power Ball",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-051",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },

{
    img: "../assets/images/Table/kingmaker/KM-TABLE-034.png",
    name: "KM Pok Deng",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-034",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
{
    img: "../assets/images/Table/kingmaker/KM-TABLE-024.png",
    name: "Fan Tan Classic",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-024",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },

{
    img: "../assets/images/Table/kingmaker/KM-TABLE-052.png",
    name: "BolaTangkas",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-052",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
{
    img: "../assets/images/Table/kingmaker/KM-TABLE-029.png",
    name: "bai buu",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-029",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },

{
    img: "../assets/images/Table/kingmaker/KM-TABLE-065.png",
    name: "Pusoy",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-065",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },

{
    img: "../assets/images/Table/kingmaker/KM-TABLE-025.png",
    name: "Fruit Roulette",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-025",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },

{
    img: "../assets/images/Table/kingmaker/KM-TABLE-020.png",
    name: "Bài Cào",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-020",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/TABLE-2.webp",
    name: "Cash Rocket",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-041",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/KM-TABLE-074.webp",
    name: "Ludo Quick",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-074",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/KM-TABLE-073.webp",
    name: "Video Poker",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-073",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/KM-TABLE-069.webp",
    name: "Elite Aviator Club",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-069",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },

  {
    img: "../assets/images/Table/KM-TABLE-070.webp",
    name: "Interstellar Run",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-070",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },

  {
    img: "../assets/images/Table/KM-TABLE-071.webp",
    name: "Olympus Glory",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-071",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/KM-TABLE-066.webp",
    name: "Coin Pusher",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-066",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/KM-TABLE-067.webp",
    name: "Cockfighting Arena",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-067",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/KM-TABLE-063.webp",
    name: "Tongits",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-063",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },

  {
    img: "../assets/images/Table/TABLE-3.webp",
    name: "Ludo",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-060",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/KM-TABLE-053.webp",
    name: "Marble Knockout",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-053",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/TABLE-16.webp",
    name: "Colour Game",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-050",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/KM-TABLE-048.webp",
    name: "Horse Racing",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-048",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/KM-TABLE-055.webp",
    name: "KM Virtual Greyhound Racing",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-055",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/KM-TABLE-058.webp",
    name: "KM Virtual Treadmill Racing",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-058",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/KM-TABLE-062.webp",
    name: "KM Virtual Treadmill Racing",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-062",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/KM-TABLE-049.webp",
    name: "5 Card Poker",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-049",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/KM-TABLE-040.webp",
    name: "Plinko",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-040",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/TABLE-12.webp",
    name: "Bonus Dice",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-043",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/TABLE-15.webp",
    name: "keno",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-018",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/KM-TABLE-045.webp",
    name: "Monkey King Roulette",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-045",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/TABLE-5.webp",
    name: "sicbo",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-015",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/TABLE-4.webp",
    name: "7 Up 7 Down",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-028",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },

  {
    img: "../assets/images/Table/TABLE-6.webp",
    name: "Coin Toss",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-036",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/TABLE-7.webp",
    name: "Cards Hi Lo",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-037",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/NETENT-TABLE-001.png",
    name: "Classic Blackjack",
    platForm: "NETENT",
    gameType: "TABLE",
    casinoType: "NETENT-TABLE-001",
    cateogry: "NETENT",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/TABLE-9.webp",
    name: "Card Matka",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-022",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/KM-TABLE-021.webp",
    name: "Number Matka",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-021",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/KM-TABLE-032.webp",
    name: "Andar Bahar",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-032",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },

  {
    img: "../assets/images/Table/TABLE-13.webp",
    name: "32 Cards",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-039",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },

  {
    img: "../assets/images/Table/KM-TABLE-038.webp",
    name: "Blackjack",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-038",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/KM-TABLE-042.webp",
    name: "Minesweeper",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-042",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/KM-TABLE-035.webp",
    name: "Bola Golek",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-035",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/KM-TABLE-030.webp",
    name: "jhandimunda",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-030",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },

  // Table End KINGMAKER (casino Done) -------

  // Table Start JILI (casino Done) -------

 {
    img: "../assets/images/Table/jili/JILI-TABLE-077.png",
    name: "Golden Treasure",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-077",
    cateogry: "JILI",
    type: "TABLE",
  },
 {
    img: "../assets/images/Table/jili/JILI-TABLE-061.png",
    name: "Ultimate Texas Hold'em",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-061",
    cateogry: "JILI",
    type: "TABLE",
  },
{
    img: "../assets/images/Table/jili/JILI-TABLE-056.png",
    name: "Jhandi Munda",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-056",
    cateogry: "JILI",
    type: "TABLE",
  },

{
    img: "../assets/images/Table/jili/JILI-TABLE-054.png",
    name: "Speed Baccarat",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-054",
    cateogry: "JILI",
    type: "TABLE",
  },


{
    img: "../assets/images/Table/jili/JILI-TABLE-023.png",
    name: "color game",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-023",
    cateogry: "JILI",
    type: "TABLE",
  },
{
    img: "../assets/images/Table/jili/JILI-TABLE-039.png",
    name: "Color Prediction",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-039",
    cateogry: "JILI",
    type: "TABLE",
  },

{
    img: "../assets/images/Table/jili/JILI-TABLE-052.png",
    name: "Jogo do Bicho",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-052",
    cateogry: "JILI",
    type: "TABLE",
  },


{
    img: "../assets/images/Table/jili/JILI-TABLE-038.png",
    name: "Pusoy Go",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-038",
    cateogry: "JILI",
    type: "TABLE",
  },
{
    img: "../assets/images/Table/jili/JILI-TABLE-025.png",
    name: "Tongits Go",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-025",
    cateogry: "JILI",
    type: "TABLE",
  },
{
    img: "../assets/images/Table/jili/JILI-TABLE-044.png",
    name: "Blackjack",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-044",
    cateogry: "JILI",
    type: "TABLE",
  },
{
    img: "../assets/images/Table/jili/JILI-TABLE-046.png",
    name: "Blackjack Lucky Ladies",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-046",
    cateogry: "JILI",
    type: "TABLE",
  },
{
    img: "../assets/images/Table/jili/JILI-TABLE-049.png",
    name: "Caribbean Stud Poker",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-049",
    cateogry: "JILI",
    type: "TABLE",
  },

{
    img: "../assets/images/Table/jili/JILI-TABLE-053.png",
    name: "European Roulette",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-053",
    cateogry: "JILI",
    type: "TABLE",
  },

{
    img: "../assets/images/Table/jili/JILI-TABLE-050.png",
    name: "Video Poker",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-050",
    cateogry: "JILI",
    type: "TABLE",
  },

{
    img: "../assets/images/Table/jili/JILI-TABLE-078.png",
    name: "Color Game Extreme",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-078",
    cateogry: "JILI",
    type: "TABLE",
  },

{
    img: "../assets/images/Table/jili/JILI-TABLE-073.png",
    name: "Domino Go",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-073",
    cateogry: "JILI",
    type: "TABLE",
  },
{
    img: "../assets/images/Table/jili/JILI-TABLE-071.png",
    name: "Keno Super Chance",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-071",
    cateogry: "JILI",
    type: "TABLE",
  },

{
    img: "../assets/images/Table/jili/JILI-TABLE-040.png",
    name: "Keno",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-040",
    cateogry: "JILI",
    type: "TABLE",
  },


{
    img: "../assets/images/Table/jili/JILI-TABLE-040.png",
    name: "Keno",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-040",
    cateogry: "JILI",
    type: "TABLE",
  },
{
    img: "../assets/images/Table/jili/JILI-TABLE-069.png",
    name: "Cricket War",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-069",
    cateogry: "JILI",
    type: "TABLE",
  },

{
    img: "../assets/images/Table/jili/JILI-TABLE-070.png",
    name: "Crash Touchdown",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-070",
    cateogry: "JILI",
    type: "TABLE",
  },
{
    img: "../assets/images/Table/jili/JILI-TABLE-063.png",
    name: "Thai Hilo",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-063",
    cateogry: "JILI",
    type: "TABLE",
  },

{
  
    img: "../assets/images/Table/jili/JILI-TABLE-064.png",
    name: "Super E-Sabong",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-064",
    cateogry: "JILI",
    type: "TABLE",
  },

{
  
    img: "../assets/images/Table/jili/JILI-TABLE-060.png",
    name: "Cricket Roulette",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-060",
    cateogry: "JILI",
    type: "TABLE",
  },

  {
  
    img: "../assets/images/Table/jili/JILI-TABLE-065.png",
    name: "Keno Bonus Number",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-065",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
  
    img: "../assets/images/Table/jili/JILI-TABLE-041.png",
    name: "Plinko",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-041",
    cateogry: "JILI",
    type: "TABLE",
  },
  

  {
    img: "../assets/images/JILI/JILI-TABLE-055.webp",
    name: "Crash Goal",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-055",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-057.webp",
    name: "Fish Prawn Crab",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-057",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-058.webp",
    name: "Crash Cricket",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-058",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-021.webp",
    name: "Ludo Quick",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-021",
    cateogry: "JILI",
    type: "TABLE",
  },

  {
    img: "../assets/images/JILI/JILI-TABLE-014.webp",
    name: "Baccarat",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-014",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-017.webp",
    name: "Sic Bo",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-017",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-016.webp",
    name: "TeenPatti 20-20",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-016",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/JILI-TABLE-047.png",
    name: "Crash Bonus",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-047",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/JILI-TABLE-048.png",
    name: "Pool Rummy",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-048",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/JILI-TABLE-042.png",
    name: "Mini Flush",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-042",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-018.webp",
    name: "Super Bingo",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-018",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-015.webp",
    name: "Fortune Bingo",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-015",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-011.webp",
    name: "7up7down",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-011",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-013.webp",
    name: "Callbreak Quick",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-013",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-012.webp",
    name: "Dragon & Tiger",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-012",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-010.webp",
    name: "TeenPatti Joker",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-010",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-008.webp",
    name: "iRich Bingo",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-008",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-009.webp",
    name: "Callbreak",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-009",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-003.webp",
    name: "Andar Bahar",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-003",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-004.webp",
    name: "Rummy",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-004",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-005.webp",
    name: "NumberKing",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-005",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-027.webp",
    name: "Golden Land",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-027",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/JILI-TABLE-033.png",
    name: "Mines",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-033",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-006.webp",
    name: "Poker King",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-006",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-007.webp",
    name: "Big small",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-007",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-028.webp",
    name: "PAPPU",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-028",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-035.webp",
    name: "Limbo",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-035",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-036.webp",
    name: "wheel",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-036",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-039.webp",
    name: "Color Prediction",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-039",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-032.webp",
    name: "HILO",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-032",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-030.webp",
    name: "Go Rush",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-030",
    cateogry: "JILI",
    type: "TABLE",
  },

  {
    img: "../assets/images/JILI/JILI-TABLE-002.webp",
    name: "AK47",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-002",
    cateogry: "JILI",
    type: "TABLE",
  },

  {
    img: "../assets/images/Table/JILI-TABLE-031.png",
    name: "Tower",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-031",
    cateogry: "JILI",
    type: "TABLE",
  },

  // Table End JILI (casino Done) -------

  // Other

  {
    img: "../assets/images/Others/MX-LIVE-015_SEXY.webp",
    name: "Thai Fish Prawn Crab",
    casinoType: "MX-LIVE-015",
    platForm: "SEXYBCRT",
    gameType: "LIVE",
    cateogry: "SEXY",
    table: "126",
    type: "OTHERS",
  },
  // {
  //   img: "../assets/images/live/sexy/MX-LIVE-018.webp",
  //   name: "Pok Deng",
  //   platForm: "SEXYBCRT",
  //   gameType: "LIVE",
  //   casinoType: "MX-LIVE-018",
  //   cateogry: "SEXY",
  //   type: "OTHERS",
  //   isPopular: true,
  // },

{
    img: "../assets/images/live/sexy/MX-LIVE-017.webp",
    name: "Sedie",
    platForm: "SEXYBCRT",
    gameType: "LIVE",
    casinoType: "MX-LIVE-017",
    cateogry: "SEXY",
    type: "OTHERS",
    isPopular: true,
  },


{
    img: "../assets/images/live/sexy/MX-LIVE-015.webp",
    name: "Thai Fish Prawn Crab",
    platForm: "SEXYBCRT",
    gameType: "LIVE",
    casinoType: "MX-LIVE-015",
    cateogry: "SEXY",
    type: "OTHERS",
    isPopular: true,
  },





{
    img: "../assets/images/live/sexy/MX-LIVE-001.webp",
    name: "SEXY Game Lobby",
    platForm: "SEXYBCRT",
    gameType: "LIVE",
    casinoType: "MX-LIVE-001",
    cateogry: "SEXY",
    type: "OTHERS",
    isPopular: true,
  },
{
    img: "../assets/images/live/sexy/MX-LIVE-006.webp",
    name: "Dragon Tiger",
    platForm: "SEXYBCRT",
    gameType: "LIVE",
    casinoType: "MX-LIVE-006",
    cateogry: "SEXY",
    type: "OTHERS",
    isPopular: true,
  },
{
    img: "../assets/images/live/sexy/MX-LIVE-002.webp",
    name: "Baccarat",
    platForm: "SEXYBCRT",
    gameType: "LIVE",
    casinoType: "MX-LIVE-002",
    cateogry: "SEXY",
    type: "OTHERS",
    isPopular: true,
  },



  {
    img: "../assets/images/Others/HOTROAD-LIVE-005.webp",
    name: "HOTROAD-LIVE-005",
    platForm: "HOTROAD",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-005",
    cateogry: "HOTROAD",
    type: "OTHERS",
    table: "3001",
  },
  // {
  //   img: "../assets/images/Others/VN-LIVE-008.webp",
  //   name: "Thai Fish Prawn Crab",
  //   casinoType: "VN-LIVE-008",
  //   platForm: "VENUS",
  //   gameType: "LIVE",
  //   cateogry: "VENUS",
  //   type: "OTHERS",
  // },
  // Other
  // Slot Start PP (casino Done) -----

  {
    img: "../assets/images/slot/NETENT-SLOT-008.png",
    name: "Starburst™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-008",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-017.png",
    name: "Starburst™ XXXtreme",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-017",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-009.png",
    name: "Gonzo's Quest™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-009",
    cateogry: "NETENT",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/NETENT-SLOT-014.png",
    name: "Divine Fortune™ Megaways™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-014",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-013.png",
    name: "Divine Fortune™ Megaways™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-013",
    cateogry: "NETENT",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/NETENT-SLOT-010.png",
    name: "Finn's Golden Tavern™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-010",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-018.png",
    name: "Twin Spin™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-018",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-025.png",
    name: "Jimi Hendrix Online Slot™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-025",
    cateogry: "NETENT",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/NETENT-SLOT-006.png",
    name: "Parthenon: Quest for Immortality™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-006",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-027.png",
    name: "Wild Wild West: The Great Train Heist™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-027",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-001.png",
    name: "Reel Rush™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-001",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-002.png",
    name: "Dracula™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-002",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-003.png",
    name: "Riches of Midgard: Land and Expand™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-003",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-004.png",
    name: "Dark King: Forbidden Riches™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-004",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-005.png",
    name: "Dead or Alive 2™ Feature Buy",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-005",
    cateogry: "NETENT",
    type: "SLOT",
  },
  // {
  //   img: "../assets/images/slot/NETENT-SLOT-006.png",
  //   name: "Parthenon: Quest for Immortality™",
  //   platForm: "NETENT",
  //   gameType: "SLOT",
  //   casinoType: "NETENT-SLOT-006",
  //   cateogry: "NETENT",
  //   type: "SLOT",
  // },
  {
    img: "../assets/images/slot/NETENT-SLOT-007.png",
    name: "Jungle Spirit: Call of the Wild™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-007",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-011.png",
    name: "Jungle Spirit: Call of the Wild™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-011",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-012.png",
    name: "Jungle Spirit: Call of the Wild™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-012",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-015.png",
    name: "Jungle Spirit: Call of the Wild™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-015",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-016.png",
    name: "Jungle Spirit: Call of the Wild™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-016",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-019.png",
    name: "Jungle Spirit: Call of the Wild™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-019",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-020.png",
    name: "Jungle Spirit: Call of the Wild™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-020",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-021.png",
    name: "Jungle Spirit: Call of the Wild™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-021",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-022.png",
    name: "Jungle Spirit: Call of the Wild™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-022",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-023.png",
    name: "Jungle Spirit: Call of the Wild™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-023",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-024.png",
    name: "Jungle Spirit: Call of the Wild™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-024",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-026.png",
    name: "Jungle Spirit: Call of the Wild™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-026",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-028.png",
    name: "Jungle Spirit: Call of the Wild™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-028",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-029.png",
    name: "Jungle Spirit: Call of the Wild™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-029",
    cateogry: "NETENT",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/NETENT-SLOT-177.webp",
    name: "101 Candies",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-177",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-178.webp",
    name: "Big Bang Boom",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-178",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-179.webp",
    name: "Crab Trap™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-179",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-180.webp",
    name: "Jack and the Beanstalk Remastered",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-180",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-181.webp",
    name: "Thrill to Grill™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-181",
    cateogry: "NETENT",
    type: "SLOT",
  },
  // {
  //   img: "../assets/images/slot/PT-SLOT-082.webp",
  //   name: "Football Rules",
  //   platForm: "PT",
  //   gameType: "SLOT",
  //   casinoType: "PT-SLOT-082",
  //   cateogry: "PP",
  //   type: "SLOT",
  // },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-003.webp",
    name: "777",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-003",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-004.webp",
    name: "Get Money",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-004",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-012.webp",
    name: "Over Dragon's Gate",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-012",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-002.webp",
    name: "Phoenix",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-002",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-011.webp",
    name: "Diamond Mogul",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-011",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-005.webp",
    name: "Rich Now",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-005",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-008.webp",
    name: "Dracula",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-008",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-020.webp",
    name: "Bust Treasury",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-020",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-448.webp",
    name: "Arowanas Luck",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-448",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-449.webp",
    name: "Arowanas Luck",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-449",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-450.webp",
    name: "Arowanas Luck",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-450",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-002.webp",
    name: "Gates of Olympus",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-002",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-082.webp",
    name: "Sweet Bonanza",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-082",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-189.webp",
    name: "Starlight Princess",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-189",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-183.webp",
    name: "5 Lions Megaways",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-183",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-080.webp",
    name: "5 Lions Gold",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-080",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-049.webp",
    name: "Great Rhino Megaways",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-049",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-069.webp",
    name: "Fire Strike",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-069",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-067.webp",
    name: "Sweet Bonanza Xmas",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-067",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-015.webp",
    name: "Bonanza Gold",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-015",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-176.webp",
    name: "Buffalo King Megaways",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-176",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-181.webp",
    name: "The Magic Cauldron - Enchanted Brew",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-181",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-046.webp",
    name: "Fruit Party",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-046",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-187.webp",
    name: "Pyramid Bonanza",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-187",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-204.webp",
    name: "Candy Village",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-204",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-126.webp",
    name: "3 Kingdoms - Battle of Red Cliffs",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-126",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-104.webp",
    name: "5 Lions",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-104",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-072.webp",
    name: "John Hunter and the Tomb of the Scarab Queen",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-072",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-107.webp",
    name: "Joker's Jewels",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-107",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-025.webp",
    name: "Gems Bonanza",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-025",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-210.webp",
    name: "Santa's Wonderland",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-210",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-233.webp",
    name: "Wild West Gold Megaways",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-233",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-234.webp",
    name: "Spirit of Adventure",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-234",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-235.webp",
    name: "Fire Strike 2",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-235",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-236.webp",
    name: "Barn Festival",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-236",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-237.webp",
    name: "Chicken Chase",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-237",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-238.webp",
    name: "Goblin Heist Powernudge",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-238",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-239.webp",
    name: "Eye of Cleopatra",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-239",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-240.webp",
    name: "The Great Stick-Up",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-240",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-296.webp",
    name: "Aztec Blaze",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-296",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-297.webp",
    name: "Starlight Christmas",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-297",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-298.webp",
    name: "Towering Fortunes",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-298",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-299.webp",
    name: "Firebird Spirit",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-299",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-300.webp",
    name: "Pirate Golden Age",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-300",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-409.webp",
    name: "Pirate Golden Age",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-409",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-410.webp",
    name: "Pirate Golden Age",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-410",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-413.webp",
    name: "Pirate Golden Age",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-413",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-414.webp",
    name: "Pirate Golden Age",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-414",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-415.webp",
    name: "Pirate Golden Age",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-415",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-416.webp",
    name: "Pirate Golden Age",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-416",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-417.webp",
    name: "Pirate Golden Age",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-417",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-418.webp",
    name: "Pirate Golden Age",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-418",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-419.webp",
    name: "Pirate Golden Age",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-419",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-420.webp",
    name: "Pirate Golden Age",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-420",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-421.webp",
    name: "Pirate Golden Age",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-421",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-422.webp",
    name: "Pirate Golden Age",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-422",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-423.webp",
    name: "Pirate Golden Age",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-423",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-424.webp",
    name: "Pirate Golden Age",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-424",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-425.webp",
    name: "Pirate Golden Age",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-425",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-426.webp",
    name: "Pirate Golden Age",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-426",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-427.webp",
    name: "Pirate Golden Age",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-427",
    cateogry: "PP",
    type: "SLOT",
  },
  // Slot End PP (casino Done) -----

  // Slot Start KINGMAKER (casino Done) -----
  
 {
    img: "../assets/images/slot/KM-SLOT-016.webp",
    name: "Hippo Splash",
    platForm: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-016",
    cateogry: "KINGMAKER",
    type: "SLOT",
  },
 {
    img: "../assets/images/slot/KM-SLOT-018.png",
    name: "Rome Gladiator",
    platForm: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-018",
    cateogry: "KINGMAKER",
    type: "SLOT",
  },
 {
    img: "../assets/images/slot/KM-SLOT-017.webp",
    name: "Cupid Archery",
    platForm: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-017",
    cateogry: "KINGMAKER",
    type: "SLOT",
  },

 {
    img: "../assets/images/slot/KM-SLOT-019.png",
    name: "Hunk Cai Shen",
    platForm: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-019",
    cateogry: "KINGMAKER",
    type: "SLOT",
  },

 {
    img: "../assets/images/slot/KM-SLOT-009.png",
    name: "LEPPY LOOT",
    platForm: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-009",
    cateogry: "KINGMAKER",
    type: "SLOT",
  },

 {
    img: "../assets/images/slot/KM-SLOT-015.webp",
    name: "Pirate's Treasure",
    platForm: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-015",
    cateogry: "KINGMAKER",
    type: "SLOT",
  },

{
    img: "../assets/images/slot/KM-SLOT-013.png",
    name: "London Mystery",
    platForm: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-013",
    cateogry: "KINGMAKER",
    type: "SLOT",
  },

{
    img: "../assets/images/slot/KM-SLOT-012.webp",
    name: "Merlin's Saga",
    platForm: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-012",
    cateogry: "KINGMAKER",
    type: "SLOT",
  },


{
    img: "../assets/images/slot/KM-SLOT-011.png",
    name: "Piggy Heist",
    platForm: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-011",
    cateogry: "KINGMAKER",
    type: "SLOT",
  },

{
    img: "../assets/images/slot/KM-SLOT-010.webp",
    name: "Gold Rush Bonanza",
    platForm: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-010",
    cateogry: "KINGMAKER",
    type: "SLOT",
  },
{
    img: "../assets/images/slot/KM-SLOT-008.webp",
    name: "Warriors Temple",
    platForm: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-008",
    cateogry: "KINGMAKER",
    type: "SLOT",
  },
 {
    img: "../assets/images/slot/KM-SLOT-002.webp",
    name: "Gems of Valhalla",
    platForm: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-002",
    cateogry: "KINGMAKER",
    type: "SLOT",
  },
 {
    img: "../assets/images/slot/KM-SLOT-006.webp",
    name: "GOld mine",
    platForm: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-006",
    cateogry: "KINGMAKER",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/KM-SLOT-003.webp",
    name: "Sugar Blast Frenzy",
    platForm: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-003",
    cateogry: "KINGMAKER",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/KM-TABLE-066.webp",
    name: "Coin Pusher",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-066",
    cateogry: "KINGMAKER",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/KM-SLOT-007.webp",
    name: "Almighty Greek",
    platForm: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-007",
    cateogry: "KINGMAKER",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/KM-SLOT-004.png",
    name: "Cleopatra's Treasure",
    platForm: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-004",
    cateogry: "KINGMAKER",
    type: "SLOT",
  },
 {
    img: "../assets/images/slot/KM-SLOT-005.webp",
    name: "Rooster Blitz",
    platForm: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-005",
    cateogry: "KINGMAKER",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/KM-SLOT-001.webp",
    name: "Sugar Blast",
    platForm: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-001",
    cateogry: "KINGMAKER",
    type: "SLOT",
  },
 
  // Slot End KINGMAKER (casino Done) -----

  // Slot Start DRAGOONSOFT (casino Done) -----

  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-001.webp",
    name: "Coin Cat",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-001",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-015.webp",
    name: "Egypt Oracle",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-015",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-018.webp",
    name: "Rich Lion",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-018",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-017.webp",
    name: "Candy Dynasty",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-017",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-007.webp",
    name: "Doggy Wealth",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-007",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-016.webp",
    name: "Caishen Coming",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-016",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-006.webp",
    name: "Chef Lady",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-006",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-009.webp",
    name: "Maya King",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-009",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-010.webp",
    name: "Pirate King",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-010",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-013.webp",
    name: "Great Lion",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-013",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-014.webp",
    name: "Ultra Treasure",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-014",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-019.webp",
    name: "Monkey King",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-019",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-075.webp",
    name: "Mahjong Win",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-075",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-076.webp",
    name: "Super Hoo Hey How",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-076",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  // Slot End DRAGOONSOFT (casino Done) -----

  // Slot Start SPADE (casino Done) -----
  // {
  //   img: "../assets/images/slot/SG-SLOT-106.webp",
  //   name: "Fiery Sevens Exclusive",
  //   platForm: "SPADE",
  //   gameType: "SLOT",
  //   casinoType: "SG-SLOT-106",
  //   cateogry: "SPADE",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/SG-SLOT-074.webp",
  //   name: "Mega7",
  //   platForm: "SPADE",
  //   gameType: "SLOT",
  //   casinoType: "SG-SLOT-074",
  //   cateogry: "SPADE",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/SG-SLOT-116.webp",
  //   name: "Legacy Of Kong Maxways",
  //   platForm: "SPADE",
  //   gameType: "SLOT",
  //   casinoType: "SG-SLOT-116",
  //   cateogry: "SPADE",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/SG-SLOT-069.webp",
  //   name: "888",
  //   platForm: "SPADE",
  //   gameType: "SLOT",
  //   casinoType: "SG-SLOT-069",
  //   cateogry: "SPADE",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/SG-SLOT-112.webp",
  //   name: "Fruits Mania",
  //   platForm: "SPADE",
  //   gameType: "SLOT",
  //   casinoType: "SG-SLOT-112",
  //   cateogry: "SPADE",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/SG-SLOT-076.webp",
  //   name: "DoubleFlame",
  //   platForm: "SPADE",
  //   gameType: "SLOT",
  //   casinoType: "SG-SLOT-076",
  //   cateogry: "SPADE",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/SG-SLOT-110.webp",
  //   name: "Space Conquest",
  //   platForm: "SPADE",
  //   gameType: "SLOT",
  //   casinoType: "SG-SLOT-110",
  //   cateogry: "SPADE",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/SG-SLOT-081.webp",
  //   name: "Triple Panda",
  //   platForm: "SPADE",
  //   gameType: "SLOT",
  //   casinoType: "SG-SLOT-081",
  //   cateogry: "SPADE",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/SG-SLOT-077.webp",
  //   name: "Book of Myth",
  //   platForm: "SPADE",
  //   gameType: "SLOT",
  //   casinoType: "SG-SLOT-077",
  //   cateogry: "SPADE",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/SG-SLOT-095.webp",
  //   name: "Poker Ways",
  //   platForm: "SPADE",
  //   gameType: "SLOT",
  //   casinoType: "SG-SLOT-095",
  //   cateogry: "SPADE",
  //   type: "SLOT",
  // },

  // {
  //   img: "../assets/images/slot/SG-SLOT-086.webp",
  //   name: "Mayan Gems",
  //   platForm: "SPADE",
  //   gameType: "SLOT",
  //   casinoType: "SG-SLOT-086",
  //   cateogry: "SPADE",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/SG-SLOT-075.webp",
  //   name: "JokersTreasure",
  //   platForm: "SPADE",
  //   gameType: "SLOT",
  //   casinoType: "SG-SLOT-075",
  //   cateogry: "SPADE",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/SG-SLOT-030.webp",
  //   name: "5FortuneSA",
  //   platForm: "SPADE",
  //   gameType: "SLOT",
  //   casinoType: "SG-SLOT-030",
  //   cateogry: "SPADE",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/SG-SLOT-103.webp",
  //   name: "Sexy Vegas",
  //   platForm: "SPADE",
  //   gameType: "SLOT",
  //   casinoType: "SG-SLOT-103",
  //   cateogry: "SPADE",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/SG-SLOT-107.webp",
  //   name: "Lucky Koi Exclusive",
  //   platForm: "SPADE",
  //   gameType: "SLOT",
  //   casinoType: "SG-SLOT-107",
  //   cateogry: "SPADE",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/SG-SLOT-082.webp",
  //   name: "Gold Panther",
  //   platForm: "SPADE",
  //   gameType: "SLOT",
  //   casinoType: "SG-SLOT-082",
  //   cateogry: "SPADE",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/SG-SLOT-032.webp",
  //   name: "Golden Lotus SE",
  //   platForm: "SPADE",
  //   gameType: "SLOT",
  //   casinoType: "SG-SLOT-032",
  //   cateogry: "SPADE",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/SG-SLOT-105.webp",
  //   name: "Royale House",
  //   platForm: "SPADE",
  //   gameType: "SLOT",
  //   casinoType: "SG-SLOT-105",
  //   cateogry: "SPADE",
  //   type: "SLOT",
  // },
  // Slot End SPADE (casino Done) -----

  // Slot Start PT (casino Done) -----
  {
    img: "../assets/images/slot/PT-SLOT-082.webp",
    name: "Football Rules",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-082",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-063.png",
    name: "Football Rules",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-063",
    cateogry: "PT",
    type: "SLOT",
  },
  // {
  //   img: "../assets/images/slot/PT-SLOT-064.png",
  //   name: "Football Rules",
  //   platForm: "PT",
  //   gameType: "SLOT",
  //   casinoType: "PT-SLOT-064",
  //   cateogry: "PT",
  //   type: "SLOT",
  // },
  {
    img: "../assets/images/slot/PT-SLOT-065.png",
    name: "Football Rules",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-065",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-066.png",
    name: "Football Rules",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-066",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-067.png",
    name: "Football Rules",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-067",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-068.png",
    name: "Football Rules",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-068",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-069.png",
    name: "Football Rules",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-069",
    cateogry: "PT",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/PT-SLOT-070.webp",
    name: "Heart of the Frontier",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-070",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-071.webp",
    name: "Thai Paradise",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-071",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-072.webp",
    name: "Legacy of the Wild",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-072",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-073.webp",
    name: "Archer",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-073",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-001.webp",
    name: "Triple Monkey",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-001",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-003.webp",
    name: "Buffalo Blitz",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-003",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-006.webp",
    name: "Great Blue",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-006",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-004.webp",
    name: "Captain Treasure",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-004",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-005.webp",
    name: "Long Long Long",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-005",
    cateogry: "PT",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/PT-SLOT-009.webp",
    name: "Golden Tour",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-009",
    cateogry: "PT",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/PT-SLOT-010.webp",
    name: "Funky Monkey",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-010",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-011.webp",
    name: "Highway Kings",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-011",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-014.webp",
    name: "Zhao Cai Tong Zi",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-014",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-012.webp",
    name: "Zhao Cai Jin Bao",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-012",
    cateogry: "PT",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/PT-SLOT-013.webp",
    name: "Jin Qian Wa",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-013",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-015.webp",
    name: "Ugga Bugga",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-015",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-016.webp",
    name: "Safari Heat",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-016",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-002.webp",
    name: "Arowanas Luck",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-002",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-019.webp",
    name: "Gem Queen",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-019",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-023.webp",
    name: "Chaoji 888",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-023",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-008.webp",
    name: "Blue Wizard",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-008",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-018.webp",
    name: "Bonus Bears",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-018",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-017.webp",
    name: "Buffalo Blitz II",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-017",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-007.webp",
    name: "Sky Queen",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-007",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-020.webp",
    name: "Feng Kuang Ma Jiang",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-020",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-021.webp",
    name: "Epic Ape",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-021",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-022.webp",
    name: "Ni Shu Shen Me",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-022",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-024.webp",
    name: "Vacation Station Deluxe",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-024",
    cateogry: "PT",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/PT-SLOT-025.webp",
    name: "Eternal Lady",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-025",
    cateogry: "PT",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/PT-SLOT-026.webp",
    name: "Golden Macaque",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-026",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-027.webp",
    name: "Fei Long Zai Tian",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-027",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-028.webp",
    name: "Yun Cong Long",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-028",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-029.webp",
    name: "Jinfu Long",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-029",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-030.webp",
    name: "Hot Gems",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-030",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-031.webp",
    name: "Lie Yan Zuan Shi",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-031",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-032.webp",
    name: "Dolphin Reef",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-032",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-033.webp",
    name: "Jinns Moon",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-033",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-034.webp",
    name: "Tiger, Turtle, Dragon, Phoenix",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-034",
    cateogry: "PT",
    type: "SLOT",
  },
  // {
  //   img: "../assets/images/slot/PT-SLOT-035.webp",
  //   name: "Heart of the Jungle",
  //   platForm: "PT",
  //   gameType: "SLOT",
  //   casinoType: "PT-SLOT-035",
  //   cateogry: "PT",
  //   type: "SLOT",
  // },
  {
    img: "../assets/images/slot/PT-SLOT-036.webp",
    name: "Heavenly Ruler",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-036",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-037.webp",
    name: "Ox Riches",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-037",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-038.webp",
    name: "Ice Cave",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-038",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-039.webp",
    name: "Queen of Wands",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-039",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-040.webp",
    name: "Si Xiang",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-040",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-041.webp",
    name: "Panther Moon",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-041",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-043.webp",
    name: "Asian Fantasy",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-043",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-044.webp",
    name: "Fortune Lions",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-044",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-045.webp",
    name: "Hot KTV",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-045",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-046.webp",
    name: "Fortune Day",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-046",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-047.webp",
    name: "Ri Ri Jin Cai",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-047",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-048.webp",
    name: "Sun WuKong",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-048",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-049.webp",
    name: "Ji Xiang 8",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-049",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-050.webp",
    name: "Jade Emperor Yu Huang Da Di",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-050",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-051.webp",
    name: "Halloween Fortune 2",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-051",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-060.webp",
    name: "Chinese Kitchen",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-060",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-061.webp",
    name: "Geisha Story",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-061",
    cateogry: "PT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-062.webp",
    name: "Fortunes of the Fox",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-062",
    cateogry: "PT",
    type: "SLOT",
  },
  // Slot End PT (casino Done) -----

  // Slot Start JDB (casino Done) -----
  {
    img: "../assets/images/slot/JDB-SLOT-108.webp",
    name: "Moneybags Man 2",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-108",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-106.webp",
    name: "FortuneNeko",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-106",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-107.webp",
    name: "Trump Card",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-107",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-105.webp",
    name: "BookOfMystery",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-105",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-117.png",
    name: "BigThreeDragons",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-117",
    cateogry: "JDB",
    type: "SLOT",
  },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-001.webp",
  //   name: "Burglar",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-001",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-003.webp",
  //   name: "Chef Doeuvre",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-003",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-004.webp",
  //   name: "Lucky Miner",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-004",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-005.webp",
  //   name: "Candy Land",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-005",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-006.webp",
  //   name: "Crazy Scientist",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-006",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-007.webp",
  //   name: "Super Dumpling",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-007",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-008.webp",
  //   name: "Cash Man",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-008",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  {
    img: "../assets/images/slot/JDB-SLOT-009.webp",
    name: "Wild Beauty",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-009",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-010.webp",
    name: "Flirting Scholar Tang",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-010",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-011.webp",
    name: "Winning Mask",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-011",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-012.webp",
    name: "Wu kong",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-012",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-013.webp",
    name: "Llama Adventure",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-013",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-014.webp",
    name: "Formosa Bear",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-014",
    cateogry: "JDB",
    type: "SLOT",
  },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-015.webp",
  //   name: "Lucky Qilin",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-015",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  {
    img: "../assets/images/slot/JDB-SLOT-016.webp",
    name: "New Year",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-016",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-017.webp",
    name: "Four Treasures",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-017",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-018.webp",
    name: "Open Sesame",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-018",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-019.webp",
    name: "Banana Saga",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-019",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-020.webp",
    name: "Olympian Temple",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-020",
    cateogry: "JDB",
    type: "SLOT",
  },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-021.webp",
  //   name: "Dancing Pa Pa",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-021",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-022.webp",
  //   name: "Dragon King",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-022",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-023.webp",
  //   name: "Magic Show",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-023",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-024.webp",
  //   name: "Cock Fight",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-024",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
   {
    img: "../assets/images/slot/JDB-SLOT-025.webp",
    name: "Dragon",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-025",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-026.webp",
    name: "Rooster In Love",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-026",
    cateogry: "JDB",
    type: "SLOT",
  },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-027.webp",
  //   name: "Monkey King",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-027",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  {
    img: "../assets/images/slot/JDB-SLOT-028.webp",
    name: "Moonlight Treasure",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-028",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-029.webp",
    name: "Mahjong",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-029",
    cateogry: "JDB",
    type: "SLOT",
  },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-030.webp",
  //   name: "Guan Gong",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-030",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  {
    img: "../assets/images/slot/JDB-SLOT-031.webp",
    name: "Billionaire",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-031",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-032.webp",
    name: "Dragon Warrior",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-032",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-033.webp",
    name: "Kingsman",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-033",
    cateogry: "JDB",
    type: "SLOT",
  },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-034.webp",
  //   name: "Curvy Magician",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-034",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-035.webp",
  //   name: "RollingIn Money",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-035",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-036.webp",
  //   name: "Chef Panda",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-036",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  {
    img: "../assets/images/slot/JDB-SLOT-045.webp",
    name: "Lucky Dragons",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-045",
    cateogry: "JDB",
    type: "SLOT",
  },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-046.webp",
  //   name: "Lucky Lion",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-046",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-047.webp",
  //   name: "Coffeeholics",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-047",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  {
    img: "../assets/images/slot/JDB-SLOT-048.webp",
    name: "Napoleon",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-048",
    cateogry: "JDB",
    type: "SLOT",
  },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-049.webp",
  //   name: "Lucky Phoenix",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-049",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  {
    img: "../assets/images/slot/JDB-SLOT-050.webp",
    name: "WinningMask II",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-050",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-051.webp",
    name: "Open Sesame II",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-051",
    cateogry: "JDB",
    type: "SLOT",
  },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-052.webp",
  //   name: "Flirting Scholar Tang II",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-052",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  {
    img: "../assets/images/slot/JDB-SLOT-053.webp",
    name: "Fortune Horse",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-053",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-054.webp",
    name: "Xi Yang Yang",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-054",
    cateogry: "JDB",
    type: "SLOT",
  },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-055.webp",
  //   name: "Panda Panda",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-055",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-056.webp",
  //   name: "Zelda",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-056",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-057.webp",
  //   name: "Mr Bao",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-057",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-058.webp",
  //   name: "One Punch Man",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-058",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-059.webp",
  //   name: "Guardians of The Galaxy",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-059",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-060.webp",
  //   name: "Street Fighter",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-060",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-061.webp",
  //   name: "Star Wars",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-061",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-062.webp",
  //   name: "War of Beauty",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-062",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-063.webp",
  //   name: "Daji",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-063",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-064.webp",
  //   name: "Poker King",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-064",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-065.webp",
  //   name: "Lucky Racing",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-065",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  {
    img: "../assets/images/slot/JDB-SLOT-066.webp",
    name: "Birds Party",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-066",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-067.webp",
    name: "Go Lai Fu",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-067",
    cateogry: "JDB",
    type: "SLOT",
  },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-068.webp",
  //   name: "Gems Gems",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-068",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  {
    img: "../assets/images/slot/JDB-SLOT-069.webp",
    name: "Dragons World",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-069",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-070.webp",
    name: "Super Niubi",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-070",
    cateogry: "JDB",
    type: "SLOT",
  },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-071.webp",
  //   name: "Egypt Treasure",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-071",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  {
    img: "../assets/images/slot/JDB-SLOT-072.webp",
    name: "Fortune Treasure",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-072",
    cateogry: "JDB",
    type: "SLOT",
  },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-073.webp",
  //   name: "Pirate Treasure",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-073",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  {
    img: "../assets/images/slot/JDB-SLOT-074.webp",
    name: "Mjoinir",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-074",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-075.webp",
    name: "Treasure Bowl",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-075",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-076.webp",
    name: "Funky King Kong",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-076",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-077.webp",
    name: "Super Niubi Deluxe",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-077",
    cateogry: "JDB",
    type: "SLOT",
  },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-078.webp",
  //   name: "Super Niubi",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-078",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-079.webp",
  //   name: "Lucky Fuwa",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-079",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-080.webp",
  //   name: "Inca Empire",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-080",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-081.webp",
  //   name: "Ninja Rush",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-081",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-082.webp",
  //   name: "Sun Archer",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-082",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-083.webp",
  //   name: "Mystery of Nine Tales",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-083",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  {
    img: "../assets/images/slot/JDB-SLOT-084.webp",
    name: "Golden Disco",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-084",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-085.webp",
    name: "Miner Babe",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-085",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-086.webp",
    name: "Moneybags Man",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-086",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-087.webp",
    name: "Double Wilds",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-087",
    cateogry: "JDB",
    type: "SLOT",
  },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-088.webp",
  //   name: "Pop Pop Fruity",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-088",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  {
    img: "../assets/images/slot/JDB-SLOT-089.webp",
    name: "Spindrift",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-089",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-090.webp",
    name: "Spindrift 2",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-090",
    cateogry: "JDB",
    type: "SLOT",
  },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-091.webp",
  //   name: "Jungle Jungle",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-091",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  {
    img: "../assets/images/slot/JDB-SLOT-092.webp",
    name: "Dragons Gate",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-092",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-093.webp",
    name: "Lucky Diamond",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-093",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-094.webp",
    name: "Kong",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-094",
    cateogry: "JDB",
    type: "SLOT",
  },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-095.webp",
  //   name: "NinjaX",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-095",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/JDB-SLOT-096.webp",
  //   name: "Rex Brothers",
  //   platForm: "JDB",
  //   gameType: "SLOT",
  //   casinoType: "JDB-SLOT-096",
  //   cateogry: "JDB",
  //   type: "SLOT",
  // },
  {
    img: "../assets/images/slot/JDB-SLOT-097.webp",
    name: "Wonder Elephant",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-097",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-098.webp",
    name: "MarvelousIV",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-098",
    cateogry: "JDB",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JDB-SLOT-099.webp",
    name: "Maya Gold Crazy",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-099",
    cateogry: "JDB",
    type: "SLOT",
  },
  // Slot End JDB (casino Done) -----

  // Slot Start FC (casino Done) -----

  // {
  //   img: "../assets/images/slot/FC-SLOT-025.webp",
  //   name: "SUGAR BANG BANG",
  //   platForm: "FC",
  //   gameType: "SLOT",
  //   casinoType: "FC-SLOT-025",
  //   cateogry: "FC",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/FC-SLOT-021.webp",
  //   name: "Lucky Fortunes",
  //   platForm: "FC",
  //   gameType: "SLOT",
  //   casinoType: "FC-SLOT-021",
  //   cateogry: "FC",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/FC-SLOT-020.webp",
  //   name: "Robin Hood",
  //   platForm: "FC",
  //   gameType: "SLOT",
  //   casinoType: "FC-SLOT-020",
  //   cateogry: "FC",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/FC-SLOT-019.webp",
  //   name: "GLORY OF ROME",
  //   platForm: "FC",
  //   gameType: "SLOT",
  //   casinoType: "FC-SLOT-019",
  //   cateogry: "FC",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/FC-SLOT-001.webp",
  //   name: "GOLDEN PANTHER",
  //   platForm: "FC",
  //   gameType: "SLOT",
  //   casinoType: "FC-SLOT-001",
  //   cateogry: "FC",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/FC-SLOT-002.webp",
  //   name: "THREE LITTLE PIGS",
  //   platForm: "FC",
  //   gameType: "SLOT",
  //   casinoType: "FC-SLOT-002",
  //   cateogry: "FC",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/FC-SLOT-003.webp",
  //   name: "HOT POT PARTY",
  //   platForm: "FC",
  //   gameType: "SLOT",
  //   casinoType: "FC-SLOT-003",
  //   cateogry: "FC",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/FC-SLOT-004.webp",
  //   name: "NIGHT MARKET",
  //   platForm: "FC",
  //   gameType: "SLOT",
  //   casinoType: "FC-SLOT-004",
  //   cateogry: "FC",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/FC-SLOT-005.webp",
  //   name: "PONG PONG HU",
  //   platForm: "FC",
  //   gameType: "SLOT",
  //   casinoType: "FC-SLOT-005",
  //   cateogry: "FC",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/FC-SLOT-006.webp",
  //   name: "PANDA DRAGON BOAT",
  //   platForm: "FC",
  //   gameType: "SLOT",
  //   casinoType: "FC-SLOT-006",
  //   cateogry: "FC",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/FC-SLOT-007.webp",
  //   name: "CHINESE NEW YEAR",
  //   platForm: "FC",
  //   gameType: "SLOT",
  //   casinoType: "FC-SLOT-007",
  //   cateogry: "FC",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/FC-SLOT-008.webp",
  //   name: "FORTUNE KOI",
  //   platForm: "FC",
  //   gameType: "SLOT",
  //   casinoType: "FC-SLOT-008",
  //   cateogry: "FC",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/FC-SLOT-009.webp",
  //   name: "HAPPY DUO BAO",
  //   platForm: "FC",
  //   gameType: "SLOT",
  //   casinoType: "FC-SLOT-009",
  //   cateogry: "FC",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/FC-SLOT-010.webp",
  //   name: "	DA LE MEN",
  //   platForm: "FC",
  //   gameType: "SLOT",
  //   casinoType: "FC-SLOT-010",
  //   cateogry: "FC",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/FC-SLOT-011.webp",
  //   name: "ANIMAL RACING",
  //   platForm: "FC",
  //   gameType: "SLOT",
  //   casinoType: "FC-SLOT-011",
  //   cateogry: "FC",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/FC-SLOT-012.webp",
  //   name: "LUXURY GOLDEN PANTHER",
  //   platForm: "FC",
  //   gameType: "SLOT",
  //   casinoType: "FC-SLOT-012",
  //   cateogry: "FC",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/FC-SLOT-013.webp",
  //   name: "MAGIC BEANS",
  //   platForm: "FC",
  //   gameType: "SLOT",
  //   casinoType: "FC-SLOT-013",
  //   cateogry: "FC",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/FC-SLOT-014.webp",
  //   name: "COWBOYS",
  //   platForm: "FC",
  //   gameType: "SLOT",
  //   casinoType: "FC-SLOT-014",
  //   cateogry: "FC",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/FC-SLOT-015.webp",
  //   name: "WAR OF THE UNIVERSE",
  //   platForm: "FC",
  //   gameType: "SLOT",
  //   casinoType: "FC-SLOT-015",
  //   cateogry: "FC",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/FC-SLOT-016.webp",
  //   name: "TREASURE CRUISE",
  //   platForm: "FC",
  //   gameType: "SLOT",
  //   casinoType: "FC-SLOT-016",
  //   cateogry: "FC",
  //   type: "SLOT",
  // },
  // Slot End FC (casino Done) -----

  // Slot Start JILI (casino Done) -----

  // Slot Start JILI (casino Done) -----

 {
    img: "../assets/images/slot/JILI-SLOT-023.webp",
    name: "Golden Bank",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-023",
    cateogry: "JILI",
    type: "SLOT",
  },
{
    img: "../assets/images/slot/JILI-SLOT-049.png",
    name: "Alibaba",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-049",
    cateogry: "JILI",
    type: "SLOT",
  },
{
    img: "../assets/images/slot/JILI-SLOT-137.png",
    name: "Joker Coin",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-137",
    cateogry: "JILI",
    type: "SLOT",
  },
{
    img: "../assets/images/slot/JILI-SLOT-110.png",
    name: "Shōgun",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-110",
    cateogry: "JILI",
    type: "SLOT",
  },
{
    img: "../assets/images/slot/JILI-SLOT-094.png",
    name: "Devil Fire 2",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-094",
    cateogry: "JILI",
    type: "SLOT",
  },
 {
    img: "../assets/images/slot/JILI-SLOT-022.webp",
    name: "Fengshen",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-022",
    cateogry: "JILI",
    type: "SLOT",
  },
{
    img: "../assets/images/slot/JILI-SLOT-121.png",
    name: "Poseidon's ",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-121",
    cateogry: "JILI",
    type: "SLOT",
  },
{
    img: "../assets/images/slot/JILI-SLOT-101.png",
    name: "3 Coin Treasures ",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-101",
    cateogry: "JILI",
    type: "SLOT",
  },
{
    img: "../assets/images/slot/JILI-SLOT-127.png",
    name: "Bikini Lady",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-127",
    cateogry: "JILI",
    type: "SLOT",
  },


{
    img: "../assets/images/slot/JILI-SLOT-050.png",
    name: "Samba",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-050",
    cateogry: "JILI",
    type: "SLOT",
  },
{
    img: "../assets/images/slot/JILI-SLOT-089.png",
    name: "Sin City",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-089",
    cateogry: "JILI",
    type: "SLOT",
  },

{
    img: "../assets/images/slot/JILI-SLOT-079.png",
    name: "Sweet Land",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-079",
    cateogry: "JILI",
    type: "SLOT",
  },
{
    img: "../assets/images/slot/JILI-SLOT-072.png",
    name: "Wild Racer",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-072",
    cateogry: "JILI",
    type: "SLOT",
  },

{
    img: "../assets/images/slot/JILI-SLOT-095.png",
    name: "Witches Night",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-095",
    cateogry: "JILI",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/JILI-SLOT-063.webp",
    name: "World Cup",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-063",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-058.png",
    name: "World Cup",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-058",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-086.png",
    name: "World Cup",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-086",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-056.webp",
    name: "Happy Taxi",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-056",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-057.webp",
    name: "Gold Rush",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-057",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-054.webp",
    name: "Crazy Pusher",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-054",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-053.webp",
    name: "Book of Gold",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-053",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-071.webp",
    name: "Neko Fortune",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-071",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-051.webp",
    name: "Mega Ace",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-051",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-052.webp",
    name: "Thor X",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-052",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-002.webp",
    name: "Hot Chilli",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-002",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-003.webp",
    name: "Chin Shi Huang",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-003",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-004.webp",
    name: "War Of Dragons",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-004",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-005.webp",
    name: "Fortune Tree",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-005",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-006.webp",
    name: "Lucky Ball",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-006",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-007.webp",
    name: "Hyper Burst",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-007",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-008.webp",
    name: "Shanghai Beauty",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-008",
    cateogry: "JILI",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/JILI-SLOT-009.webp",
    name: "Fa Fa Fa",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-009",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-010.webp",
    name: "God Of Martial",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-010",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-012.webp",
    name: "Hawaii Beauty",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-012",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-013.webp",
    name: "SevenSevenSeven",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-013",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-014.webp",
    name: "Crazy777",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-014",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-015.webp",
    name: "Bubble Beauty",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-015",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-016.webp",
    name: "Bao boon chin",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-016",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-017.webp",
    name: "Crazy FaFaFa",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-017",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-018.webp",
    name: "XiYangYang",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-018",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-019.webp",
    name: "FortunePig",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-019",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-020.webp",
    name: "Candy Baby",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-020",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-021.webp",
    name: "Diamond Party",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-021",
    cateogry: "JILI",
    type: "SLOT",
  },
 
 
  {
    img: "../assets/images/slot/JILI-SLOT-024.webp",
    name: "Lucky Goldbricks",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-024",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-025.webp",
    name: "Dragon Treasure",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-025",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-026.webp",
    name: "Charge Buffalo",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-026",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-027.webp",
    name: "Super Ace",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-027",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-028.webp",
    name: "Jungle King",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-028",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-029.webp",
    name: "Money Coming",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-029",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-030.webp",
    name: "Golden Queen",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-030",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-031.webp",
    name: "Boxing King",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-031",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-032.webp",
    name: "Matka India",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-032",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-037.webp",
    name: "Lucky Coming",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-037",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-038.webp",
    name: "Pharaoh Treasure",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-038",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-039.webp",
    name: "Secret Treasure",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-039",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-040.webp",
    name: "RomaX",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-040",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-041.webp",
    name: "Super Rich",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-041",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-042.webp",
    name: "Golden Empire",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-042",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-043.webp",
    name: "Fortune Gems",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-043",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-044.webp",
    name: "Party Night",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-044",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-045.webp",
    name: "Crazy Hunter",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-045",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-046.webp",
    name: "Magic Lamp",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-046",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-047.webp",
    name: "TWINWINS",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-047",
    cateogry: "JILI",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/JILI-SLOT-048.webp",
    name: "Agent Ace",
    platForm: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-048",
    cateogry: "JILI",
    type: "SLOT",
  },
  // Slot End JILI (casino Done) -----

  //slot spade start
  {
    img: "../assets/images/slot/SG-SLOT-106.png",
    name: "Fiery Sevens Exclusive",
    platForm: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-106",
    cateogry: "SPADE",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/SG-SLOT-074.png",
    name: "Mega7",
    platForm: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-074",
    cateogry: "SPADE",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/SG-SLOT-116.png",
    name: "Legacy Of Kong Maxways",
    platForm: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-116",
    cateogry: "SPADE",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/SG-SLOT-069.webp",
    name: "888",
    platForm: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-069",
    cateogry: "SPADE",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/SG-SLOT-112.webp",
    name: "Fruits Mania",
    platForm: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-112",
    cateogry: "SPADE",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/SG-SLOT-076.png",
    name: "DoubleFlame",
    platForm: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-076",
    cateogry: "SPADE",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/SG-SLOT-110.webp",
    name: "Space Conquest",
    platForm: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-110",
    cateogry: "SPADE",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/SG-SLOT-081.png",
    name: "TriplePanda",
    platForm: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-081",
    cateogry: "SPADE",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/SG-SLOT-077.png",
    name: "BookofMyth",
    platForm: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-077",
    cateogry: "SPADE",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/SG-SLOT-095.png",
    name: "Poker Ways",
    platForm: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-095",
    cateogry: "SPADE",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/SG-SLOT-086.png",
    name: "Mayan Gems",
    platForm: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-086",
    cateogry: "SPADE",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/SG-SLOT-075.png",
    name: "JokersTreasure",
    platForm: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-075",
    cateogry: "SPADE",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/SG-SLOT-030.png",
    name: "5FortuneSA",
    platForm: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-030",
    cateogry: "SPADE",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/SG-SLOT-103.webp",
    name: "Sexy Vegas",
    platForm: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-103",
    cateogry: "SPADE",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/SG-SLOT-107.png",
    name: "Lucky Koi Exclusive",
    platForm: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-107",
    cateogry: "SPADE",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/SG-SLOT-082.png",
    name: "GoldPanther",
    platForm: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-082",
    cateogry: "SPADE",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/SG-SLOT-032.webp",
    name: "GoldenLotusSE",
    platForm: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-032",
    cateogry: "SPADE",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/SG-SLOT-105.png",
    name: "Royale House",
    platForm: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-105",
    cateogry: "SPADE",
    type: "SLOT",
  },

  //slot spade end
  {
    img: "../assets/images/slot/FC-SLOT-038.webp",
    name: "Big Bang Boom",
    platForm: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-038",
    cateogry: "FC",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/FC-SLOT-025.png",
    name: "SUGAR BANG BANG",
    platForm: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-025",
    cateogry: "FC",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/FC-SLOT-023.png",
    name: "GRAND BLUE",
    platForm: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-023",
    cateogry: "FC",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/FC-SLOT-024.png",
    name: "TREASURE RAIDERS",
    platForm: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-024",
    cateogry: "FC",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/FC-SLOT-021.png",
    name: "Lucky Fortunes",
    platForm: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-021",
    cateogry: "FC",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/FC-SLOT-020.png",
    name: "Robin Hood",
    platForm: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-020",
    cateogry: "FC",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/FC-SLOT-019.png",
    name: "GLORY OF ROME",
    platForm: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-019",
    cateogry: "FC",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/FC-SLOT-001.png",
    name: "GOLDEN PANTHER",
    platForm: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-001",
    cateogry: "FC",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/FC-SLOT-002.png",
    name: "THREE LITTLE PIGS",
    platForm: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-002",
    cateogry: "FC",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/FC-SLOT-003.png",
    name: "HOT POT PARTY",
    platForm: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-003",
    cateogry: "FC",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/FC-SLOT-004.png",
    name: "NIGHT MARKET",
    platForm: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-004",
    cateogry: "FC",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/FC-SLOT-005.png",
    name: "PONG PONG HU",
    platForm: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-005",
    cateogry: "FC",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/FC-SLOT-006.png",
    name: "PANDA DRAGON BOAT",
    platForm: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-006",
    cateogry: "FC",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/FC-SLOT-007.png",
    name: "CHINESE NEW YEAR",
    platForm: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-007",
    cateogry: "FC",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/FC-SLOT-008.png",
    name: "FORTUNE KOI",
    platForm: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-008",
    cateogry: "FC",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/FC-SLOT-009.png",
    name: "HAPPY DUO BAO",
    platForm: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-009",
    cateogry: "FC",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/FC-SLOT-010.png",
    name: "DA LE MEN",
    platForm: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-010",
    cateogry: "FC",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/FC-SLOT-011.png",
    name: "ANIMAL RACING",
    platForm: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-011",
    cateogry: "FC",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/FC-SLOT-012.png",
    name: "LUXURY GOLDEN PANTHER",
    platForm: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-012",
    cateogry: "FC",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/FC-SLOT-013.png",
    name: "MAGIC BEANS",
    platForm: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-013",
    cateogry: "FC",
    type: "SLOT",
  },

  {
    img: "../assets/images/slot/FC-SLOT-014.png",
    name: "COWBOYS",
    platForm: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-014",
    cateogry: "FC",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/FC-SLOT-015.png",
    name: "WAR OF THE UNIVERSE",
    platForm: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-015",
    cateogry: "FC",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/FC-SLOT-016.png",
    name: "TREASURE CRUISE",
    platForm: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-016",
    cateogry: "FC",
    type: "SLOT",
  },

  //slot FC start

  //slot FC end

  // Fishing Start JILI (casino Done) -----
  {
    img: "../assets/images/Fishing/JDB-FISH-008.webp",
    name: "Royal Fishing",
    platForm: "FC",
    gameType: "FH",
    casinoType: "FC-FISH-001",
    cateogry: "JDB",
    type: "FISHING",
  },
  {
    img: "../assets/images/Fishing/JDB-FISH-009.webp",
    name: "Royal Fishing",
    platForm: "FC",
    gameType: "FH",
    casinoType: "FC-FISH-001",
    cateogry: "JDB",
    type: "FISHING",
  },
  {
    img: "../assets/images/Fishing/JDB-FISH-010.webp",
    name: "Fishing YiLuFa",
    platForm: "FC",
    gameType: "FH",
    casinoType: "FC-FISH-002",
    cateogry: "JDB",
    type: "FISHING",
  },
  {
    img: "../assets/images/Fishing/JDB-FISH-011.webp",
    name: "Dragon Master",
    platForm: "FC",
    gameType: "FH",
    casinoType: "FC-FISH-004",
    cateogry: "JDB",
    type: "FISHING",
  },
  {
    img: "../assets/images/Fishing/JDB-FISH-012.webp",
    name: "Royal Fishing",
    platForm: "FC",
    gameType: "FH",
    casinoType: "FC-FISH-001",
    cateogry: "JDB",
    type: "FISHING",
  },
  {
    img: "../assets/images/Fishing/JDB-FISH-013.webp",
    name: "Fishing Legend",
    platForm: "FC",
    gameType: "FH",
    casinoType: "FC-FISH-005",
    cateogry: "JDB",
    type: "FISHING",
  },

  // Fishing Start SPADE (casino Done) -----
  {
    img: "../assets/images/Fishing/SG-FISH-001.webp",
    name: "Fishing God",
    platForm: "SPADE",
    gameType: "FH",
    casinoType: "SG-FISH-001",
    cateogry: "SPADE",
    type: "FISHING",
  },
  {
    img: "../assets/images/Fishing/SG-FISH-002.webp",
    name: "Fishing War",
    platForm: "SPADE",
    gameType: "FH",
    casinoType: "SG-FISH-002",
    cateogry: "SPADE",
    type: "FISHING",
  },
  {
    img: "../assets/images/Fishing/SG-FISH-003.webp",
    name: "Alien Hunter",
    platForm: "SPADE",
    gameType: "FH",
    casinoType: "SG-FISH-003",
    cateogry: "SPADE",
    type: "FISHING",
  },
  {
    img: "../assets/images/Fishing/SG-FISH-004.webp",
    name: "Zombie Party",
    platForm: "SPADE",
    gameType: "FH",
    casinoType: "SG-FISH-004",
    cateogry: "SPADE",
    type: "FISHING",
  },
  // Fishing End SPADE (casino Done) -----
  // Fishing STart JILI (casino Done) -----
   {
    img: "../assets/images/Fishing/JILI-FISH-003.png",
    name: "Jackpot Fishing",
    platForm: "JILI",
    gameType: "FH",
    casinoType: "JILI-FISH-003",
    cateogry: "JILI",
    type: "FISHING",
  },
   {
    img: "../assets/images/Fishing/JILI-FISH-005.webp",
    name: "Happy Fishing",
    platForm: "JILI",
    gameType: "FH",
    casinoType: "JILI-FISH-005",
    cateogry: "JILI",
    type: "FISHING",
  },
  {
    img: "../assets/images/Fishing/JILI-FISH-007.webp",
    name: "Mega Fishing",
    platForm: "JILI",
    gameType: "FH",
    casinoType: "JILI-FISH-007",
    cateogry: "JILI",
    type: "FISHING",
  },
 {
    img: "../assets/images/Fishing/JILI-FISH-012.png",
    name: "Ocean King Jackpot",
    platForm: "JILI",
    gameType: "FH",
    casinoType: "JILI-FISH-012",
    cateogry: "JILI",
    type: "FISHING",
  },
 {
    img: "../assets/images/Fishing/JILI-FISH-002.webp",
    name: "Bombing Fishing",
    platForm: "JILI",
    gameType: "FH",
    casinoType: "JILI-FISH-002",
    cateogry: "JILI",
    type: "FISHING",
  },
{
    img: "../assets/images/Fishing/JILI-FISH-004.webp",
    name: "Dinosaur Tycoon",
    platForm: "JILI",
    gameType: "FH",
    casinoType: "JILI-FISH-004",
    cateogry: "JILI",
    type: "FISHING",
  },

{
    img: "../assets/images/Fishing/JILI-FISH-009.png",
    name: "All-star Fishing",
    platForm: "JILI",
    gameType: "FH",
    casinoType: "JILI-FISH-009",
    cateogry: "JILI",
    type: "FISHING",
  },
{
    img: "../assets/images/Fishing/JILI-FISH-014.png",
    name: "FORTUNE ZOMBIE",
    platForm: "JILI",
    gameType: "FH",
    casinoType: "JILI-FISH-014",
    cateogry: "JILI",
    type: "FISHING",
  },

{
    img: "../assets/images/Fishing/JILI-FISH-011.png",
    name: "Dinosaur Tycoon II",
    platForm: "JILI",
    gameType: "FH",
    casinoType: "JILI-FISH-011",
    cateogry: "JILI",
    type: "FISHING",
  },

{
    img: "../assets/images/Fishing/JILI-FISH-008.webp",
    name: "Boom Legend",
    platForm: "JILI",
    gameType: "FH",
    casinoType: "JILI-FISH-008",
    cateogry: "JILI",
    type: "FISHING",
  },
{
    img: "../assets/images/Fishing/JILI-FISH-006.webp",
    name: "Dragon Fortune",
    platForm: "JILI",
    gameType: "FH",
    casinoType: "JILI-FISH-006",
    cateogry: "JILI",
    type: "FISHING",
  },


  {
    img: "../assets/images/Fishing/JILI-FISH-001.webp",
    name: "Royal Fishing",
    platForm: "JILI",
    gameType: "FH",
    casinoType: "JILI-FISH-001",
    cateogry: "JILI",
    type: "FISHING",
  },

 
  

  // Fishing End JILI (casino Done) -----
  // EGAME SPRIBE
  {
    img: "../assets/images/Egame/22001.png",
    name: "Aviator",
    platForm: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-001",
    cateogry: "SPRIBE",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/22002.png",
    name: "Dice",
    platForm: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-003",
    cateogry: "SPRIBE",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/22008.png",
    name: "Mini Roulette",
    platForm: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-008",
    cateogry: "SPRIBE",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/22005.png",
    name: "Mines",
    platForm: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-005",
    cateogry: "SPRIBE",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/22006.png",
    name: "Spribe Hilo",
    platForm: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-006",
    cateogry: "SPRIBE",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/22004.png",
    name: "Plinko",
    platForm: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-004",
    cateogry: "SPRIBE",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/22003.png",
    name: "Goal",
    platForm: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-002",
    cateogry: "SPRIBE",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/22009.png",
    name: "Hotline",
    platForm: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-009",
    cateogry: "SPRIBE",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/22007.png",
    name: "Keno",
    platForm: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-007",
    cateogry: "SPRIBE",
    type: "EGAME",
  },

  // Egame Start JDB (casino Done) -----
  {
    img: "../assets/images/Egame/JDB-EGAME-017.webp",
    name: "Darts",
    platForm: "JDB",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-017",
    cateogry: "JDB",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/JDB-EGAME-012.webp",
    name: "Darts",
    platForm: "JDB",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-012",
    cateogry: "JDB",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/JDB-EGAME-013.webp",
    name: "Darts",
    platForm: "JDB",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-013",
    cateogry: "JDB",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/JDB-EGAME-014.webp",
    name: "Darts",
    platForm: "JDB",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-014",
    cateogry: "JDB",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/JDB-EGAME-015.webp",
    name: "Darts",
    platForm: "JDB",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-015",
    cateogry: "JDB",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/JDB-EGAME-016.webp",
    name: "Darts",
    platForm: "JDB",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-016",
    cateogry: "JDB",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/JDB-EGAME-002.webp",
    name: "Lucky Color Game",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-009",
    cateogry: "JDB",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/JDB-EGAME-006.webp",
    name: "King Of Football",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-010",
    cateogry: "JDB",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/JDB-EGAME-001.webp",
    name: "Crazy King Kong",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-011",
    cateogry: "JDB",
    type: "EGAME",
  },

  {
    img: "../assets/images/Egame/JDB-EGAME-007.webp",
    name: "Super Super Fruit",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-012",
    cateogry: "JDB",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/JDB-EGAME-011.webp",
    name: "Jogo Do Bicho",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-013",
    cateogry: "JDB",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/JDB-EGAME-010.webp",
    name: "Beer Tycoon",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-014",
    cateogry: "JDB",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/JDB-EGAME-005.webp",
    name: "CAISHEN PARTY",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-015",
    cateogry: "JDB",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/JDB-EGAME-003.webp",
    name: "Birds and Animals",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-016",
    cateogry: "JDB",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/JDB-EGAME-009.webp",
    name: "Classic Mario",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-017",
    cateogry: "JDB",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/JDB-EGAME-004.webp",
    name: "Happy New Year",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-018",
    cateogry: "JDB",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/JDB-EGAME-008.webp",
    name: "Huaguoshan Legends",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-019",
    cateogry: "JDB",
    type: "EGAME",
  },

  // Egame End JDB (casino Done) -----

  //PP EGAME START

  {
    img: "../assets/images/Egame/PP-EGAME-004.webp",
    name: "Fantastic League",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-001",
    cateogry: "PP",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/PP-EGAME-002.webp",
    name: "Penalty Shootout",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-002",
    cateogry: "PP",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/PP-EGAME-005.webp",
    name: "Greyhound Racing",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-005",
    cateogry: "PP",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/PP-EGAME-003.webp",
    name: "Horse Racing",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-003",
    cateogry: "PP",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/PP-EGAME-006.webp",
    name: "Force 1",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-006",
    cateogry: "PP",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/PP-EGAME-007.webp",
    name: "Darts",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-007",
    cateogry: "PP",
    type: "EGAME",
  },

  //PP EGAME END

  // AWC Start -----

  // AWC BG Start -----
  {
    img: "../assets/images/Awc/BG-LIVE-001.webp",
    name: "Live Casino BG",
    platForm: "BG",
    gameType: "LIVE",
    casinoType: "BG-LIVE-001",
    cateogry: "BG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BG-LIVE-002.webp",
    name: "Baccarat",
    platForm: "BG",
    gameType: "LIVE",
    casinoType: "BG-LIVE-002",
    cateogry: "BG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BG-LIVE-003.webp",
    name: "Roulette Awc",
    platForm: "BG",
    gameType: "LIVE",
    casinoType: "BG-LIVE-003",
    cateogry: "BG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BG-LIVE-004.webp",
    name: "Sicbo Awc",
    platForm: "BG",
    gameType: "LIVE",
    casinoType: "BG-LIVE-004",
    cateogry: "BG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BG-LIVE-005.webp",
    name: "Dragon tiger",
    platForm: "BG",
    gameType: "LIVE",
    casinoType: "BG-LIVE-005",
    cateogry: "BG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BG-LIVE-006.webp",
    name: "Speed Baccarat",
    platForm: "BG",
    gameType: "LIVE",
    casinoType: "BG-LIVE-006",
    cateogry: "BG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BG-LIVE-007.webp",
    name: "Mi Card Baccarat",
    platForm: "BG",
    gameType: "LIVE",
    casinoType: "BG-LIVE-007",
    cateogry: "BG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BG-LIVE-008.webp",
    name: "Full Color Baccarat",
    platForm: "BG",
    gameType: "LIVE",
    casinoType: "BG-LIVE-008",
    cateogry: "BG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BG-LIVE-009.webp",
    name: "BullBull",
    platForm: "BG",
    gameType: "LIVE",
    casinoType: "BG-LIVE-009",
    cateogry: "BG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BG-LIVE-010.webp",
    name: "Win Three Cards",
    platForm: "BG",
    gameType: "LIVE",
    casinoType: "BG-LIVE-010",
    cateogry: "BG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BG-LIVE-011.webp",
    name: "RedBlack",
    platForm: "BG",
    gameType: "LIVE",
    casinoType: "BG-LIVE-011",
    cateogry: "BG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BG-LIVE-012.webp",
    name: "SpeedSicBo",
    platForm: "BG",
    gameType: "LIVE",
    casinoType: "BG-LIVE-012",
    cateogry: "BG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BG-LIVE-013.webp",
    name: "SeDie",
    platForm: "BG",
    gameType: "LIVE",
    casinoType: "BG-LIVE-013",
    cateogry: "BG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BG-LIVE-014.webp",
    name: "CasinoWar",
    platForm: "BG",
    gameType: "LIVE",
    casinoType: "BG-LIVE-014",
    cateogry: "BG",
    type: "AWC",
  },
  // AWC BG END -----
  // AWC BTG START -----
  {
    img: "../assets/images/Awc/BTG-SLOT-001.webp",
    name: "Apollo Pays",
    platForm: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-001",
    cateogry: "BTG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BTG-SLOT-002.webp",
    name: "Castle of Terror",
    platForm: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-002",
    cateogry: "BTG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BTG-SLOT-003.webp",
    name: "Rasputin Megaways",
    platForm: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-003",
    cateogry: "BTG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BTG-SLOT-004.webp",
    name: "Bonanza",
    platForm: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-004",
    cateogry: "BTG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BTG-SLOT-005.webp",
    name: "Extra Chilli",
    platForm: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-005",
    cateogry: "BTG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BTG-SLOT-006.webp",
    name: "White Rabbit",
    platForm: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-006",
    cateogry: "BTG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BTG-SLOT-007.webp",
    name: "Millionaire",
    platForm: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-007",
    cateogry: "BTG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BTG-SLOT-008.webp",
    name: "Golden Catch",
    platForm: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-008",
    cateogry: "BTG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BTG-SLOT-009.webp",
    name: "Danger High Voltage",
    platForm: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-009",
    cateogry: "BTG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BTG-SLOT-010.webp",
    name: "Christmas Bonanza",
    platForm: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-010",
    cateogry: "BTG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BTG-SLOT-011.webp",
    name: "Christmas Bonanza",
    platForm: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-011",
    cateogry: "BTG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BTG-SLOT-012.webp",
    name: "Christmas Bonanza",
    platForm: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-012",
    cateogry: "BTG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BTG-SLOT-013.webp",
    name: "Christmas Bonanza",
    platForm: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-013",
    cateogry: "BTG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BTG-SLOT-014.webp",
    name: "Christmas Bonanza",
    platForm: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-014",
    cateogry: "BTG",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/BTG-SLOT-015.webp",
    name: "Christmas Bonanza",
    platForm: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-015",
    cateogry: "BTG",
    type: "AWC",
  },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-016.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-016",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-017.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-017",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-018.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-018",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-019.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-019",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-020.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-020",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-021.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-021",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-022.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-022",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-023.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-023",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-024.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-024",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-025.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-025",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-026.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-026",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-027.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-027",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-028.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-028",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-029.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-029",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-030.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-030",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-031.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-031",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-032.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-032",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-033.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-033",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-034.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-034",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-035.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-035",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-036.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-036",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },

  // {
  //   img: "../assets/images/Awc/BTG-SLOT-038.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-038",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-039.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-039",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-040.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-040",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-041.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-041",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-042.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-042",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-043.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-043",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-044.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-044",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-045.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-045",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-046.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-046",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-047.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-047",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-048.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-048",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-049.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-049",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-050.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-050",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-051.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-051",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-052.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-052",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-053.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-053",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-054.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-054",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/BTG-SLOT-055.webp",
  //   name: "Christmas Bonanza",
  //   platForm: "BTG",
  //   gameType: "SLOT",
  //   casinoType: "BTG-SLOT-055",
  //   cateogry: "BTG",
  //   type: "AWC",
  // },

  // // AWC BTG END -----
  // // AWC E1SPORT START -----
  // {
  //   img: "../assets/images/Awc/E1-ESPORTS-001.webp",
  //   name: "E1Sports",
  //   platForm: "E1SPORT",
  //   gameType: "ESPORTS",
  //   casinoType: "E1-ESPORTS-001",
  //   cateogry: "E1SPORT",
  //   type: "AWC",
  // },
  // AWC E1SPORT END -----

  // AWC NLC START -----
  {
    img: "../assets/images/Awc/NLC-SLOT-001.webp",
    name: "Das x Boot",
    platForm: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-001",
    cateogry: "NLC",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/NLC-SLOT-002.webp",
    name: "Mental",
    platForm: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-002",
    cateogry: "NLC",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/NLC-SLOT-003.webp",
    name: "Punk Toilet",
    platForm: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-003",
    cateogry: "NLC",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/NLC-SLOT-004.webp",
    name: "Serial",
    platForm: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-004",
    cateogry: "NLC",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/NLC-SLOT-005.webp",
    name: "Serial",
    platForm: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-005",
    cateogry: "NLC",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/NLC-SLOT-006.webp",
    name: "Serial",
    platForm: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-006",
    cateogry: "NLC",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/NLC-SLOT-007.webp",
    name: "Serial",
    platForm: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-007",
    cateogry: "NLC",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/NLC-SLOT-008.webp",
    name: "Serial",
    platForm: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-008",
    cateogry: "NLC",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/NLC-SLOT-009.webp",
    name: "Serial",
    platForm: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-009",
    cateogry: "NLC",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/NLC-SLOT-010.webp",
    name: "Serial",
    platForm: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-010",
    cateogry: "NLC",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/NLC-SLOT-011.webp",
    name: "Serial",
    platForm: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-011",
    cateogry: "NLC",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/NLC-SLOT-012.webp",
    name: "Serial",
    platForm: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-012",
    cateogry: "NLC",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/NLC-SLOT-013.webp",
    name: "Serial",
    platForm: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-013",
    cateogry: "NLC",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/NLC-SLOT-014.webp",
    name: "Serial",
    platForm: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-014",
    cateogry: "NLC",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/NLC-SLOT-015.webp",
    name: "Serial",
    platForm: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-015",
    cateogry: "NLC",
    type: "AWC",
  },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-016.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-016",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-017.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-017",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-018.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-018",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-019.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-019",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-020.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-020",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-021.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-021",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-022.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-022",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-023.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-023",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-024.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-024",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-025.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-025",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-026.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-026",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-027.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-027",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-028.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-028",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-029.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-029",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-030.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-030",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-031.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-031",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-032.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-032",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-033.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-033",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-034.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-034",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-035.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-035",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-036.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-036",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-037.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-037",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-038.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-038",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-039.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-039",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-040.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-040",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-041.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-041",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-042.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-042",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-043.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-043",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-044.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-044",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-045.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-045",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-046.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-046",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-047.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-047",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-048.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-048",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-049.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-049",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-050.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-050",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-051.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-051",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-052.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-052",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-053.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-053",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-054.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-054",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-055.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-055",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-056.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-056",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-057.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-057",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-058.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-058",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-059.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-059",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-060.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-060",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-061.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-061",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-062.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-062",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-063.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-063",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-064.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-064",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-065.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-065",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-066.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-066",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-067.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-067",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-068.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-068",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-069.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-069",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-070.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-070",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-071.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-071",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-072.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-072",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-073.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-073",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-074.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-074",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-075.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-075",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-076.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-076",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-077.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-077",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-078.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-078",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-079.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-079",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-080.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-080",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-081.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-081",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-082.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-082",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-083.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-083",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-084.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-084",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-085.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-085",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-086.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-086",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-087.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-087",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-088.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-088",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-089.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-089",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-090.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-090",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-091.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-091",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-092.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-092",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-093.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-093",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-094.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-094",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // {
  //   img: "../assets/images/Awc/NLC-SLOT-095.webp",
  //   name: "Serial",
  //   platForm: "NLC",
  //   gameType: "SLOT",
  //   casinoType: "NLC-SLOT-095",
  //   cateogry: "NLC",
  //   type: "AWC",
  // },
  // AWC NLC END -----
  // AWC RT START -----
  {
    img: "../assets/images/Awc/RT-SLOT-001.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-001",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-002.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-002",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-003.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-003",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-004.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-004",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-005.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-005",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-006.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-006",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-007.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-007",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-008.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-008",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-009.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-009",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-010.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-010",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-011.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-011",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-012.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-012",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-013.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-013",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-014.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-014",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-015.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-015",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-016.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-016",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-017.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-017",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-018.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-018",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-019.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-019",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-020.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-020",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-021.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-021",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-022.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-022",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-023.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-023",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-024.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-024",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-025.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-025",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-026.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-026",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-027.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-027",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-028.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-028",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-029.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-029",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-030.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-030",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-031.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-031",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-032.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-032",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-033.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-033",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-034.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-034",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-035.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-035",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-036.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-036",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-037.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-037",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-038.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-038",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-039.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-039",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-040.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-040",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-041.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-041",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-042.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-042",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-043.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-043",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-044.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-044",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-045.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-045",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-046.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-046",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-047.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-047",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-048.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-048",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-049.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-049",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-050.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-050",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-051.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-051",
    cateogry: "RT",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/RT-SLOT-052.webp",
    name: "Ancient Script",
    platForm: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-052",
    cateogry: "RT",
    type: "AWC",
  },
  // AWC RT END -----
  // AWC SV388 START -----

  {
    img: "../assets/images/Awc/SV-LIVE-001.webp",
    name: "SV388",
    platForm: "SV388",
    gameType: "LIVE",
    casinoType: "SV-LIVE-001",
    cateogry: "SV388",
    type: "AWC",
  },
  // AWC SV388 END -----
  // AWC YESBINGO START -----
  {
    img: "../assets/images/Awc/YesBingo-BINGO-001.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "BINGO",
    casinoType: "YesBingo-BINGO-001",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-BINGO-002.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "BINGO",
    casinoType: "YesBingo-BINGO-002",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-BINGO-003.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "BINGO",
    casinoType: "YesBingo-BINGO-003",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-BINGO-004.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "BINGO",
    casinoType: "YesBingo-BINGO-004",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-BINGO-005.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "BINGO",
    casinoType: "YesBingo-BINGO-005",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-BINGO-006.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "BINGO",
    casinoType: "YesBingo-BINGO-006",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-BINGO-007.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "BINGO",
    casinoType: "YesBingo-BINGO-007",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-BINGO-008.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "BINGO",
    casinoType: "YesBingo-BINGO-008",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-BINGO-009.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "BINGO",
    casinoType: "YesBingo-BINGO-009",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-BINGO-010.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "BINGO",
    casinoType: "YesBingo-BINGO-010",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-BINGO-011.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "BINGO",
    casinoType: "YesBingo-BINGO-011",
    cateogry: "YesBingo",
    type: "AWC",
  },

  {
    img: "../assets/images/Awc/YesBingo-FH-001.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "FH",
    casinoType: "YesBingo-FH-001",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-001.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-001",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-002.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-002",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-003.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-003",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-004.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-004",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-005.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-005",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-006.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-006",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-007.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-007",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-008.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-008",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-009.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-009",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-010.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-010",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-011.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-011",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-012.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-012",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-013.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-013",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-014.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-014",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-015.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-015",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-016.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-016",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-017.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-017",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-018.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-018",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-019.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-019",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-020.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-020",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-021.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-021",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-022.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-022",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-023.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-023",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-024.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-024",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-025.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-025",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-026.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-026",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-027.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-027",
    cateogry: "YesBingo",
    type: "AWC",
  },

  {
    img: "../assets/images/Awc/YesBingo-SLOT-029.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-029",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-030.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-030",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-SLOT-031.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-031",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-EGAME-001.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "EGAME",
    casinoType: "YesBingo-EGAME-001",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-EGAME-002.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "EGAME",
    casinoType: "YesBingo-EGAME-002",
    cateogry: "YesBingo",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YesBingo-EGAME-003.webp",
    name: "YesBingo",
    platForm: "YESBINGO",
    gameType: "EGAME",
    casinoType: "YesBingo-EGAME-003",
    cateogry: "YesBingo",
    type: "AWC",
  },
  // AWC YESBINGO END -----
  // AWC YL START -----
  {
    img: "../assets/images/Awc/YL-EGAME-001.webp",
    name: "YL",
    platForm: "YL",
    gameType: "EGAME",
    casinoType: "YL-EGAME-001",
    cateogry: "YL",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YL-EGAME-002.webp",
    name: "YL",
    platForm: "YL",
    gameType: "EGAME",
    casinoType: "YL-EGAME-002",
    cateogry: "YL",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YL-EGAME-003.webp",
    name: "YL",
    platForm: "YL",
    gameType: "EGAME",
    casinoType: "YL-EGAME-003",
    cateogry: "YL",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YL-EGAME-004.webp",
    name: "YL",
    platForm: "YL",
    gameType: "EGAME",
    casinoType: "YL-EGAME-004",
    cateogry: "YL",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YL-EGAME-005.webp",
    name: "YL",
    platForm: "YL",
    gameType: "EGAME",
    casinoType: "YL-EGAME-005",
    cateogry: "YL",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YL-EGAME-006.webp",
    name: "YL",
    platForm: "YL",
    gameType: "EGAME",
    casinoType: "YL-EGAME-006",
    cateogry: "YL",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YL-EGAME-007.webp",
    name: "YL",
    platForm: "YL",
    gameType: "EGAME",
    casinoType: "YL-EGAME-007",
    cateogry: "YL",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YL-EGAME-008.webp",
    name: "YL",
    platForm: "YL",
    gameType: "EGAME",
    casinoType: "YL-EGAME-008",
    cateogry: "YL",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YL-EGAME-009.webp",
    name: "YL",
    platForm: "YL",
    gameType: "EGAME",
    casinoType: "YL-EGAME-009",
    cateogry: "YL",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YL-EGAME-010.webp",
    name: "YL",
    platForm: "YL",
    gameType: "EGAME",
    casinoType: "YL-EGAME-010",
    cateogry: "YL",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YL-EGAME-011.webp",
    name: "YL",
    platForm: "YL",
    gameType: "EGAME",
    casinoType: "YL-EGAME-011",
    cateogry: "YL",
    type: "AWC",
  },
  {
    img: "../assets/images/Awc/YL-EGAME-012.webp",
    name: "YL",
    platForm: "YL",
    gameType: "EGAME",
    casinoType: "YL-EGAME-012",
    cateogry: "YL",
    type: "AWC",
  },
  // AWC YL END -----
  // AWC End -----
];

export const homeFavouriteCasino = [
  {
    img: "../assets/images/JILI/JILI-TABLE-021.webp",
    name: "Ludo Quick",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-021",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/KM-TABLE-074.webp",
    name: "Ludo Quick",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-074",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/TABLE-2.webp",
    name: "Cash Rocket",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-041",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-058.webp",
    name: "Ludo Quick",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-058",
    cateogry: "JILI",
    type: "TABLE",
  },

  {
    img: "../assets/images/Table/KM-TABLE-066.webp",
    name: "Coin Pusher",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-066",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/TABLE-4.webp",
    name: "7 Up 7 Down",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-028",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/TABLE-5.webp",
    name: "sicbo",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-015",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },

  {
    img: "../assets/images/Table/TABLE-6.webp",
    name: "Coin Toss",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-036",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/KM-TABLE-073.webp",
    name: "Video Poker",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-073",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  // {
  //   img: "../assets/images/Table/TABLE-7.webp",
  //   name: "Cards Hi Lo",
  //   platForm: "KINGMAKER",
  //   gameType: "TABLE",
  //   casinoType: "KM-TABLE-037",
  //   cateogry: "KINGMAKER",
  //   type: "TABLE",
  // },
  {
    img: "../assets/images/Table/TABLE-3.webp",
    name: "Ludo",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-060",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },

  {
    img: "../assets/images/Table/TABLE-9.webp",
    name: "Card Matka",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-022",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/KM-TABLE-021.webp",
    name: "Number Matka",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-021",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/KM-TABLE-032.webp",
    name: "Andar Bahar",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-032",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/TABLE-12.webp",
    name: "Bonus Dice",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-043",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/TABLE-13.webp",
    name: "32 Cards",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-039",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/KM-TABLE-040.webp",
    name: "Plinko",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-040",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/KM-TABLE-067.webp",
    name: "Cockfighting Arena",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-067",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/TABLE-16.webp",
    name: "Colour Game",
    platForm: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-050",
    cateogry: "KINGMAKER",
    type: "TABLE",
  },

  {
    img: "../assets/images/Table/JILI-TABLE-047.png",
    name: "Crash Bonus",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-047",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/Table/JILI-TABLE-042.png",
    name: "Mini Flush",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-042",
    cateogry: "JILI",
    type: "TABLE",
  },
  {
    img: "../assets/images/JILI/JILI-TABLE-012.webp",
    name: "Dragon & Tiger",
    platForm: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-012",
    cateogry: "JILI",
    type: "TABLE",
  },
  // {
  //   img: "../assets/images/Table/JILI-TABLE-033.png",
  //   name: "Mines",
  //   platForm: "JILI",
  //   gameType: "TABLE",
  //   casinoType: "JILI-TABLE-033",
  //   cateogry: "JILI",
  //   type: "TABLE",
  // },
  // {
  //   img: "../assets/images/slot/KM-SLOT-005.webp",
  //   name: "Rooster",
  //   platForm: "KINGMAKER",
  //   gameType: "SLOT",
  //   casinoType: "KM-SLOT-005",
  //   cateogry: "KINGMAKER",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/NETENT-SLOT-008.png",
  //   name: "Starburst™",
  //   platForm: "NETENT",
  //   gameType: "SLOT",
  //   casinoType: "NETENT-SLOT-008",
  //   cateogry: "NETENT",
  //   type: "SLOT",
  // },
  {
    img: "../assets/images/slot/NETENT-SLOT-017.png",
    name: "Starburst™ XXXtreme",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-017",
    cateogry: "NETENT",
    type: "SLOT",
  },
  // {
  //   img: "../assets/images/slot/NETENT-SLOT-009.png",
  //   name: "Gonzo's Quest™",
  //   platForm: "NETENT",
  //   gameType: "SLOT",
  //   casinoType: "NETENT-SLOT-009",
  //   cateogry: "NETENT",
  //   type: "SLOT",
  // },

  {
    img: "../assets/images/slot/NETENT-SLOT-014.png",
    name: "Divine Fortune™ Megaways™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-014",
    cateogry: "NETENT",
    type: "SLOT",
  },
  // {
  //   img: "../assets/images/slot/NETENT-SLOT-013.png",
  //   name: "Divine Fortune™ Megaways™",
  //   platForm: "NETENT",
  //   gameType: "SLOT",
  //   casinoType: "NETENT-SLOT-013",
  //   cateogry: "NETENT",
  //   type: "SLOT",
  // },

  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-076.webp",
    name: "Super Hoo Hey How",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-076",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/KM-SLOT-002.webp",
    name: "Rooster",
    platForm: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-002",
    cateogry: "KINGMAKER",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/KM-SLOT-006.webp",
    name: "Rooster",
    platForm: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-006",
    cateogry: "KINGMAKER",
    type: "SLOT",
  },

  // {
  //   img: "../assets/images/slot/NETENT-SLOT-010.png",
  //   name: "Finn's Golden Tavern™",
  //   platForm: "NETENT",
  //   gameType: "SLOT",
  //   casinoType: "NETENT-SLOT-010",
  //   cateogry: "NETENT",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/NETENT-SLOT-018.png",
  //   name: "Twin Spin™",
  //   platForm: "NETENT",
  //   gameType: "SLOT",
  //   casinoType: "NETENT-SLOT-018",
  //   cateogry: "NETENT",
  //   type: "SLOT",
  // },
  // {
  //   img: "../assets/images/slot/NETENT-SLOT-025.png",
  //   name: "Jimi Hendrix Online Slot™",
  //   platForm: "NETENT",
  //   gameType: "SLOT",
  //   casinoType: "NETENT-SLOT-025",
  //   cateogry: "NETENT",
  //   type: "SLOT",
  // },

  {
    img: "../assets/images/slot/NETENT-SLOT-006.png",
    name: "Parthenon: Quest for Immortality™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-006",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-177.webp",
    name: "101 Candies",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-177",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-178.webp",
    name: "Big Bang Boom",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-178",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PP-SLOT-450.webp",
    name: "Big Bang Boom",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-450",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/FC-SLOT-038.webp",
    name: "Big Bang Boom",
    platForm: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-038",
    cateogry: "FC",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-180.webp",
    name: "Jack and the Beanstalk Remastered",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-180",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/NETENT-SLOT-181.webp",
    name: "Thrill to Grill™",
    platForm: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-181",
    cateogry: "NETENT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/PT-SLOT-082.webp",
    name: "Football Rules",
    platForm: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-082",
    cateogry: "PP",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-003.webp",
    name: "777",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-003",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-012.webp",
    name: "Over Dragon's Gate",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-012",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-004.webp",
    name: "Get Money",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-004",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-002.webp",
    name: "Phoenix",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-002",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-011.webp",
    name: "Diamond Mogul",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-011",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-005.webp",
    name: "Rich Now",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-005",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/slot/DRAGOONSOFT-SLOT-008.webp",
    name: "Dracula",
    platForm: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-008",
    cateogry: "DRAGOONSOFT",
    type: "SLOT",
  },
  {
    img: "../assets/images/Egame/22001.png",
    name: "Aviator",
    platForm: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-001",
    cateogry: "SPRIBE",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/22005.png",
    name: "Mines",
    platForm: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-005",
    cateogry: "SPRIBE",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/22004.png",
    name: "Plinko",
    platForm: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-004",
    cateogry: "SPRIBE",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/22006.png",
    name: "Spribe Hilo",
    platForm: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-006",
    cateogry: "SPRIBE",
    type: "EGAME",
  },

  {
    img: "../assets/images/Egame/22008.png",
    name: "Mini Roulette",
    platForm: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-008",
    cateogry: "SPRIBE",
    type: "EGAME",
  },

  // Egame Start JDB (casino Done) -----
  {
    img: "../assets/images/Egame/JDB-EGAME-002.webp",
    name: "Lucky Color Game",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-009",
    cateogry: "JDB",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/JDB-EGAME-006.webp",
    name: "King Of Football",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-010",
    cateogry: "JDB",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/JDB-EGAME-001.webp",
    name: "Crazy King Kong",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-011",
    cateogry: "JDB",
    type: "EGAME",
  },

  {
    img: "../assets/images/Egame/JDB-EGAME-007.webp",
    name: "Super Super Fruit",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-012",
    cateogry: "JDB",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/JDB-EGAME-011.webp",
    name: "Jogo Do Bicho",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-013",
    cateogry: "JDB",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/JDB-EGAME-010.webp",
    name: "Beer Tycoon",
    platForm: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-014",
    cateogry: "JDB",
    type: "EGAME",
  },

  {
    img: "../assets/images/Egame/PP-EGAME-004.webp",
    name: "Fantastic League",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-001",
    cateogry: "PP",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/PP-EGAME-002.webp",
    name: "Penalty Shootout",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-002",
    cateogry: "PP",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/PP-EGAME-005.webp",
    name: "Greyhound Racing",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-005",
    cateogry: "PP",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/PP-EGAME-003.webp",
    name: "Horse Racing",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-003",
    cateogry: "PP",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/PP-EGAME-006.webp",
    name: "Force 1",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-006",
    cateogry: "PP",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/PP-EGAME-007.webp",
    name: "Darts",
    platForm: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-007",
    cateogry: "PP",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/JDB-EGAME-017.webp",
    name: "Darts",
    platForm: "JDB",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-017",
    cateogry: "JDB",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/JDB-EGAME-012.webp",
    name: "Darts",
    platForm: "JDB",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-012",
    cateogry: "JDB",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/JDB-EGAME-013.webp",
    name: "Darts",
    platForm: "JDB",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-013",
    cateogry: "JDB",
    type: "EGAME",
  },
  {
    img: "../assets/images/Egame/JDB-EGAME-014.webp",
    name: "Darts",
    platForm: "JDB",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-014",
    cateogry: "JDB",
    type: "EGAME",
  },
];
export const bannerSlider = [
  { id: 1, img: banner1, cateogry: "live", type: "EVO" },
  { id: 2, img: banner2, cateogry: "live", type: "" },
  {
    id: 3,
    img: banner3,
    cateogry: "slot",
    type: "NETENT",
  },
  // {
  //   id: 4,
  //   img: banner4,
  //   cateogry: "egame",
  //   type: "SPRIBE",
  // },
  {
    id: 5,
    img: banner5,
    cateogry: "egame",
    type: "JDB",
  },
  {
    id: 5,
    img: banner6,
    cateogry: "live",
    type: "HOTROAD",
  },
   {
    id: 5,
    img: banner7,
    cateogry: "live",
    type: "SMARTSOFT",
  },
];

export const showMenuUsingPath = [{ path: "/change-password" }, { path: "" }];

export const Dummy = [
  {
    timestamp: "2025-03-06T02:45:00.000Z",
    runners: [
      {
        selectionId: "41690968",
        backOdds: [
          {
            price: 1.61,
            size: 1.79,
            _id: "67c90c2c09eb8986556deeb6",
          },
          {
            price: 1.6,
            size: 4.19,
            _id: "67c90c2c09eb8986556deeb7",
          },
          {
            price: 1.57,
            size: 16.76,
            _id: "67c90c2c09eb8986556deeb8",
          },
        ],
        layOdds: [
          {
            price: 2.28,
            size: 12.67,
            _id: "67c90c2c09eb8986556deeb9",
          },
          {
            price: 2.3,
            size: 2.93,
            _id: "67c90c2c09eb8986556deeba",
          },
          {
            price: 2.42,
            size: 1.02,
            _id: "67c90c2c09eb8986556deebb",
          },
        ],
        _id: "67c90c2c09eb8986556deeb5",
      },
      {
        selectionId: "8928550",
        backOdds: [
          {
            price: 2.3,
            size: 41.72,
            _id: "67c90c2c09eb8986556deebd",
          },
          {
            price: 2.2,
            size: 4.19,
            _id: "67c90c2c09eb8986556deebe",
          },
          {
            price: 2.08,
            size: 15.56,
            _id: "67c90c2c09eb8986556deebf",
          },
        ],
        layOdds: [
          {
            price: 3.9,
            size: 1.98,
            _id: "67c90c2c09eb8986556deec0",
          },
          {
            price: 4,
            size: 19.93,
            _id: "67c90c2c09eb8986556deec1",
          },
          {
            price: 7.8,
            size: 1.32,
            _id: "67c90c2c09eb8986556deec2",
          },
        ],
        _id: "67c90c2c09eb8986556deebc",
      },
      {
        selectionId: "60443",
        backOdds: [
          {
            price: 4.1,
            size: 2.46,
            _id: "67c90c2c09eb8986556deec4",
          },
          {
            price: 3.5,
            size: 2.51,
            _id: "67c90c2c09eb8986556deec5",
          },
          {
            price: 3.25,
            size: 2.35,
            _id: "67c90c2c09eb8986556deec6",
          },
        ],
        layOdds: [
          {
            price: 12,
            size: 1.97,
            _id: "67c90c2c09eb8986556deec7",
          },
          {
            price: 18.5,
            size: 1.04,
            _id: "67c90c2c09eb8986556deec8",
          },
          {
            price: 21,
            size: 1.17,
            _id: "67c90c2c09eb8986556deec9",
          },
        ],
        _id: "67c90c2c09eb8986556deec3",
      },
    ],
    _id: "67c90c2c09eb8986556deeb4",
  },
  {
    timestamp: "2025-03-06T02:45:01.000Z",
    runners: [
      {
        selectionId: "41690968",
        backOdds: [
          {
            price: 1.61,
            size: 1.79,
            _id: "67c90c2d09eb8986556defbd",
          },
          {
            price: 1.6,
            size: 4.19,
            _id: "67c90c2d09eb8986556defbe",
          },
          {
            price: 1.57,
            size: 16.76,
            _id: "67c90c2d09eb8986556defbf",
          },
        ],
        layOdds: [
          {
            price: 2.28,
            size: 12.67,
            _id: "67c90c2d09eb8986556defc0",
          },
          {
            price: 2.3,
            size: 2.93,
            _id: "67c90c2d09eb8986556defc1",
          },
          {
            price: 2.42,
            size: 1.02,
            _id: "67c90c2d09eb8986556defc2",
          },
        ],
        _id: "67c90c2d09eb8986556defbc",
      },
      {
        selectionId: "8928550",
        backOdds: [
          {
            price: 2.3,
            size: 41.72,
            _id: "67c90c2d09eb8986556defc4",
          },
          {
            price: 2.2,
            size: 4.19,
            _id: "67c90c2d09eb8986556defc5",
          },
          {
            price: 2.08,
            size: 15.56,
            _id: "67c90c2d09eb8986556defc6",
          },
        ],
        layOdds: [
          {
            price: 3.9,
            size: 1.98,
            _id: "67c90c2d09eb8986556defc7",
          },
          {
            price: 4,
            size: 19.93,
            _id: "67c90c2d09eb8986556defc8",
          },
          {
            price: 7.8,
            size: 1.32,
            _id: "67c90c2d09eb8986556defc9",
          },
        ],
        _id: "67c90c2d09eb8986556defc3",
      },
      {
        selectionId: "60443",
        backOdds: [
          {
            price: 4.1,
            size: 2.46,
            _id: "67c90c2d09eb8986556defcb",
          },
          {
            price: 3.5,
            size: 2.51,
            _id: "67c90c2d09eb8986556defcc",
          },
          {
            price: 3.25,
            size: 2.35,
            _id: "67c90c2d09eb8986556defcd",
          },
        ],
        layOdds: [
          {
            price: 12,
            size: 1.97,
            _id: "67c90c2d09eb8986556defce",
          },
          {
            price: 18.5,
            size: 1.04,
            _id: "67c90c2d09eb8986556defcf",
          },
          {
            price: 21,
            size: 1.17,
            _id: "67c90c2d09eb8986556defd0",
          },
        ],
        _id: "67c90c2d09eb8986556defca",
      },
    ],
    _id: "67c90c2d09eb8986556defbb",
  },
  {
    timestamp: "2025-03-06T02:45:02.000Z",
    runners: [
      {
        selectionId: "41690968",
        backOdds: [
          {
            price: 1.61,
            size: 1.79,
            _id: "67c90c2e09eb8986556df08d",
          },
          {
            price: 1.6,
            size: 4.19,
            _id: "67c90c2e09eb8986556df08e",
          },
          {
            price: 1.57,
            size: 16.76,
            _id: "67c90c2e09eb8986556df08f",
          },
        ],
        layOdds: [
          {
            price: 2.28,
            size: 12.67,
            _id: "67c90c2e09eb8986556df090",
          },
          {
            price: 2.3,
            size: 2.93,
            _id: "67c90c2e09eb8986556df091",
          },
          {
            price: 2.42,
            size: 1.02,
            _id: "67c90c2e09eb8986556df092",
          },
        ],
        _id: "67c90c2e09eb8986556df08c",
      },
      {
        selectionId: "8928550",
        backOdds: [
          {
            price: 2.3,
            size: 41.72,
            _id: "67c90c2e09eb8986556df094",
          },
          {
            price: 2.2,
            size: 4.19,
            _id: "67c90c2e09eb8986556df095",
          },
          {
            price: 2.08,
            size: 15.56,
            _id: "67c90c2e09eb8986556df096",
          },
        ],
        layOdds: [
          {
            price: 3.9,
            size: 1.98,
            _id: "67c90c2e09eb8986556df097",
          },
          {
            price: 4,
            size: 19.93,
            _id: "67c90c2e09eb8986556df098",
          },
          {
            price: 7.8,
            size: 1.32,
            _id: "67c90c2e09eb8986556df099",
          },
        ],
        _id: "67c90c2e09eb8986556df093",
      },
      {
        selectionId: "60443",
        backOdds: [
          {
            price: 4.1,
            size: 2.46,
            _id: "67c90c2e09eb8986556df09b",
          },
          {
            price: 3.5,
            size: 2.51,
            _id: "67c90c2e09eb8986556df09c",
          },
          {
            price: 3.25,
            size: 2.35,
            _id: "67c90c2e09eb8986556df09d",
          },
        ],
        layOdds: [
          {
            price: 12,
            size: 1.97,
            _id: "67c90c2e09eb8986556df09e",
          },
          {
            price: 18.5,
            size: 1.04,
            _id: "67c90c2e09eb8986556df09f",
          },
          {
            price: 21,
            size: 1.17,
            _id: "67c90c2e09eb8986556df0a0",
          },
        ],
        _id: "67c90c2e09eb8986556df09a",
      },
    ],
    _id: "67c90c2e09eb8986556df08b",
  },
  {
    timestamp: "2025-03-06T02:45:03.000Z",
    runners: [
      {
        selectionId: "41690968",
        backOdds: [
          {
            price: 1.61,
            size: 1.79,
            _id: "67c90c2f09eb8986556df18d",
          },
          {
            price: 1.6,
            size: 4.19,
            _id: "67c90c2f09eb8986556df18e",
          },
          {
            price: 1.57,
            size: 16.76,
            _id: "67c90c2f09eb8986556df18f",
          },
        ],
        layOdds: [
          {
            price: 2.28,
            size: 12.67,
            _id: "67c90c2f09eb8986556df190",
          },
          {
            price: 2.3,
            size: 2.93,
            _id: "67c90c2f09eb8986556df191",
          },
          {
            price: 2.42,
            size: 1.02,
            _id: "67c90c2f09eb8986556df192",
          },
        ],
        _id: "67c90c2f09eb8986556df18c",
      },
      {
        selectionId: "8928550",
        backOdds: [
          {
            price: 2.3,
            size: 41.72,
            _id: "67c90c2f09eb8986556df194",
          },
          {
            price: 2.2,
            size: 4.19,
            _id: "67c90c2f09eb8986556df195",
          },
          {
            price: 2.08,
            size: 15.56,
            _id: "67c90c2f09eb8986556df196",
          },
        ],
        layOdds: [
          {
            price: 3.9,
            size: 1.98,
            _id: "67c90c2f09eb8986556df197",
          },
          {
            price: 4,
            size: 19.93,
            _id: "67c90c2f09eb8986556df198",
          },
          {
            price: 7.8,
            size: 1.32,
            _id: "67c90c2f09eb8986556df199",
          },
        ],
        _id: "67c90c2f09eb8986556df193",
      },
      {
        selectionId: "60443",
        backOdds: [
          {
            price: 4.1,
            size: 2.46,
            _id: "67c90c2f09eb8986556df19b",
          },
          {
            price: 3.5,
            size: 2.51,
            _id: "67c90c2f09eb8986556df19c",
          },
          {
            price: 3.25,
            size: 2.35,
            _id: "67c90c2f09eb8986556df19d",
          },
        ],
        layOdds: [
          {
            price: 12,
            size: 1.97,
            _id: "67c90c2f09eb8986556df19e",
          },
          {
            price: 18.5,
            size: 1.04,
            _id: "67c90c2f09eb8986556df19f",
          },
          {
            price: 21,
            size: 1.17,
            _id: "67c90c2f09eb8986556df1a0",
          },
        ],
        _id: "67c90c2f09eb8986556df19a",
      },
    ],
    _id: "67c90c2f09eb8986556df18b",
  },
  {
    timestamp: "2025-03-06T02:45:04.000Z",
    runners: [
      {
        selectionId: "41690968",
        backOdds: [
          {
            price: 1.61,
            size: 1.79,
            _id: "67c90c3009eb8986556df2d2",
          },
          {
            price: 1.6,
            size: 4.19,
            _id: "67c90c3009eb8986556df2d3",
          },
          {
            price: 1.57,
            size: 16.76,
            _id: "67c90c3009eb8986556df2d4",
          },
        ],
        layOdds: [
          {
            price: 2.28,
            size: 12.67,
            _id: "67c90c3009eb8986556df2d5",
          },
          {
            price: 2.3,
            size: 2.93,
            _id: "67c90c3009eb8986556df2d6",
          },
          {
            price: 2.42,
            size: 1.02,
            _id: "67c90c3009eb8986556df2d7",
          },
        ],
        _id: "67c90c3009eb8986556df2d1",
      },
      {
        selectionId: "8928550",
        backOdds: [
          {
            price: 2.3,
            size: 41.72,
            _id: "67c90c3009eb8986556df2d9",
          },
          {
            price: 2.2,
            size: 4.19,
            _id: "67c90c3009eb8986556df2da",
          },
          {
            price: 2.08,
            size: 15.56,
            _id: "67c90c3009eb8986556df2db",
          },
        ],
        layOdds: [
          {
            price: 3.9,
            size: 1.98,
            _id: "67c90c3009eb8986556df2dc",
          },
          {
            price: 4,
            size: 19.93,
            _id: "67c90c3009eb8986556df2dd",
          },
          {
            price: 7.8,
            size: 1.32,
            _id: "67c90c3009eb8986556df2de",
          },
        ],
        _id: "67c90c3009eb8986556df2d8",
      },
      {
        selectionId: "60443",
        backOdds: [
          {
            price: 4.1,
            size: 2.46,
            _id: "67c90c3009eb8986556df2e0",
          },
          {
            price: 3.5,
            size: 2.51,
            _id: "67c90c3009eb8986556df2e1",
          },
          {
            price: 3.25,
            size: 2.35,
            _id: "67c90c3009eb8986556df2e2",
          },
        ],
        layOdds: [
          {
            price: 12,
            size: 1.97,
            _id: "67c90c3009eb8986556df2e3",
          },
          {
            price: 18.5,
            size: 1.04,
            _id: "67c90c3009eb8986556df2e4",
          },
          {
            price: 21,
            size: 1.17,
            _id: "67c90c3009eb8986556df2e5",
          },
        ],
        _id: "67c90c3009eb8986556df2df",
      },
    ],
    _id: "67c90c3009eb8986556df2d0",
  },
  {
    timestamp: "2025-03-06T02:45:05.000Z",
    runners: [
      {
        selectionId: "41690968",
        backOdds: [
          {
            price: 1.61,
            size: 1.79,
            _id: "67c90c3109eb8986556df3c2",
          },
          {
            price: 1.6,
            size: 4.19,
            _id: "67c90c3109eb8986556df3c3",
          },
          {
            price: 1.57,
            size: 16.76,
            _id: "67c90c3109eb8986556df3c4",
          },
        ],
        layOdds: [
          {
            price: 2.28,
            size: 12.67,
            _id: "67c90c3109eb8986556df3c5",
          },
          {
            price: 2.3,
            size: 2.93,
            _id: "67c90c3109eb8986556df3c6",
          },
          {
            price: 2.42,
            size: 1.02,
            _id: "67c90c3109eb8986556df3c7",
          },
        ],
        _id: "67c90c3109eb8986556df3c1",
      },
      {
        selectionId: "8928550",
        backOdds: [
          {
            price: 2.3,
            size: 41.72,
            _id: "67c90c3109eb8986556df3c9",
          },
          {
            price: 2.2,
            size: 4.19,
            _id: "67c90c3109eb8986556df3ca",
          },
          {
            price: 2.08,
            size: 15.56,
            _id: "67c90c3109eb8986556df3cb",
          },
        ],
        layOdds: [
          {
            price: 3.9,
            size: 1.98,
            _id: "67c90c3109eb8986556df3cc",
          },
          {
            price: 4,
            size: 19.93,
            _id: "67c90c3109eb8986556df3cd",
          },
          {
            price: 7.8,
            size: 1.32,
            _id: "67c90c3109eb8986556df3ce",
          },
        ],
        _id: "67c90c3109eb8986556df3c8",
      },
      {
        selectionId: "60443",
        backOdds: [
          {
            price: 4.1,
            size: 2.46,
            _id: "67c90c3109eb8986556df3d0",
          },
          {
            price: 3.5,
            size: 2.51,
            _id: "67c90c3109eb8986556df3d1",
          },
          {
            price: 3.25,
            size: 2.35,
            _id: "67c90c3109eb8986556df3d2",
          },
        ],
        layOdds: [
          {
            price: 12,
            size: 1.97,
            _id: "67c90c3109eb8986556df3d3",
          },
          {
            price: 18.5,
            size: 1.04,
            _id: "67c90c3109eb8986556df3d4",
          },
          {
            price: 21,
            size: 1.17,
            _id: "67c90c3109eb8986556df3d5",
          },
        ],
        _id: "67c90c3109eb8986556df3cf",
      },
    ],
    _id: "67c90c3109eb8986556df3c0",
  },
  {
    timestamp: "2025-03-06T02:45:06.000Z",
    runners: [
      {
        selectionId: "41690968",
        backOdds: [
          {
            price: 1.61,
            size: 1.79,
            _id: "67c90c3209eb8986556df4e0",
          },
          {
            price: 1.6,
            size: 4.19,
            _id: "67c90c3209eb8986556df4e1",
          },
          {
            price: 1.57,
            size: 16.76,
            _id: "67c90c3209eb8986556df4e2",
          },
        ],
        layOdds: [
          {
            price: 2.28,
            size: 12.67,
            _id: "67c90c3209eb8986556df4e3",
          },
          {
            price: 2.3,
            size: 2.93,
            _id: "67c90c3209eb8986556df4e4",
          },
          {
            price: 2.42,
            size: 1.02,
            _id: "67c90c3209eb8986556df4e5",
          },
        ],
        _id: "67c90c3209eb8986556df4df",
      },
      {
        selectionId: "8928550",
        backOdds: [
          {
            price: 2.3,
            size: 41.72,
            _id: "67c90c3209eb8986556df4e7",
          },
          {
            price: 2.2,
            size: 4.19,
            _id: "67c90c3209eb8986556df4e8",
          },
          {
            price: 2.08,
            size: 15.56,
            _id: "67c90c3209eb8986556df4e9",
          },
        ],
        layOdds: [
          {
            price: 3.9,
            size: 1.98,
            _id: "67c90c3209eb8986556df4ea",
          },
          {
            price: 4,
            size: 19.93,
            _id: "67c90c3209eb8986556df4eb",
          },
          {
            price: 7.8,
            size: 1.32,
            _id: "67c90c3209eb8986556df4ec",
          },
        ],
        _id: "67c90c3209eb8986556df4e6",
      },
      {
        selectionId: "60443",
        backOdds: [
          {
            price: 4.1,
            size: 2.46,
            _id: "67c90c3209eb8986556df4ee",
          },
          {
            price: 3.5,
            size: 2.51,
            _id: "67c90c3209eb8986556df4ef",
          },
          {
            price: 3.25,
            size: 2.35,
            _id: "67c90c3209eb8986556df4f0",
          },
        ],
        layOdds: [
          {
            price: 12,
            size: 1.97,
            _id: "67c90c3209eb8986556df4f1",
          },
          {
            price: 18.5,
            size: 1.04,
            _id: "67c90c3209eb8986556df4f2",
          },
          {
            price: 21,
            size: 1.17,
            _id: "67c90c3209eb8986556df4f3",
          },
        ],
        _id: "67c90c3209eb8986556df4ed",
      },
    ],
    _id: "67c90c3209eb8986556df4de",
  },
  {
    timestamp: "2025-03-06T02:45:07.000Z",
    runners: [
      {
        selectionId: "41690968",
        backOdds: [
          {
            price: 1.61,
            size: 1.79,
            _id: "67c90c3309eb8986556df5d7",
          },
          {
            price: 1.6,
            size: 4.19,
            _id: "67c90c3309eb8986556df5d8",
          },
          {
            price: 1.57,
            size: 16.76,
            _id: "67c90c3309eb8986556df5d9",
          },
        ],
        layOdds: [
          {
            price: 2.28,
            size: 12.67,
            _id: "67c90c3309eb8986556df5da",
          },
          {
            price: 2.3,
            size: 2.93,
            _id: "67c90c3309eb8986556df5db",
          },
          {
            price: 2.42,
            size: 1.02,
            _id: "67c90c3309eb8986556df5dc",
          },
        ],
        _id: "67c90c3309eb8986556df5d6",
      },
      {
        selectionId: "8928550",
        backOdds: [
          {
            price: 2.3,
            size: 41.72,
            _id: "67c90c3309eb8986556df5de",
          },
          {
            price: 2.2,
            size: 4.19,
            _id: "67c90c3309eb8986556df5df",
          },
          {
            price: 2.08,
            size: 15.56,
            _id: "67c90c3309eb8986556df5e0",
          },
        ],
        layOdds: [
          {
            price: 3.9,
            size: 1.98,
            _id: "67c90c3309eb8986556df5e1",
          },
          {
            price: 4,
            size: 19.93,
            _id: "67c90c3309eb8986556df5e2",
          },
          {
            price: 7.8,
            size: 1.32,
            _id: "67c90c3309eb8986556df5e3",
          },
        ],
        _id: "67c90c3309eb8986556df5dd",
      },
      {
        selectionId: "60443",
        backOdds: [
          {
            price: 4.1,
            size: 2.46,
            _id: "67c90c3309eb8986556df5e5",
          },
          {
            price: 3.5,
            size: 2.51,
            _id: "67c90c3309eb8986556df5e6",
          },
          {
            price: 3.25,
            size: 2.35,
            _id: "67c90c3309eb8986556df5e7",
          },
        ],
        layOdds: [
          {
            price: 12,
            size: 1.97,
            _id: "67c90c3309eb8986556df5e8",
          },
          {
            price: 18.5,
            size: 1.04,
            _id: "67c90c3309eb8986556df5e9",
          },
          {
            price: 21,
            size: 1.17,
            _id: "67c90c3309eb8986556df5ea",
          },
        ],
        _id: "67c90c3309eb8986556df5e4",
      },
    ],
    _id: "67c90c3309eb8986556df5d5",
  },
  {
    timestamp: "2025-03-06T02:45:08.000Z",
    runners: [
      {
        selectionId: "41690968",
        backOdds: [
          {
            price: 1.61,
            size: 1.79,
            _id: "67c90c3409eb8986556df6a0",
          },
          {
            price: 1.6,
            size: 4.19,
            _id: "67c90c3409eb8986556df6a1",
          },
          {
            price: 1.57,
            size: 16.76,
            _id: "67c90c3409eb8986556df6a2",
          },
        ],
        layOdds: [
          {
            price: 2.28,
            size: 12.67,
            _id: "67c90c3409eb8986556df6a3",
          },
          {
            price: 2.3,
            size: 2.93,
            _id: "67c90c3409eb8986556df6a4",
          },
          {
            price: 2.42,
            size: 1.02,
            _id: "67c90c3409eb8986556df6a5",
          },
        ],
        _id: "67c90c3409eb8986556df69f",
      },
      {
        selectionId: "8928550",
        backOdds: [
          {
            price: 2.3,
            size: 41.72,
            _id: "67c90c3409eb8986556df6a7",
          },
          {
            price: 2.2,
            size: 4.19,
            _id: "67c90c3409eb8986556df6a8",
          },
          {
            price: 2.08,
            size: 15.56,
            _id: "67c90c3409eb8986556df6a9",
          },
        ],
        layOdds: [
          {
            price: 3.9,
            size: 1.98,
            _id: "67c90c3409eb8986556df6aa",
          },
          {
            price: 4,
            size: 19.93,
            _id: "67c90c3409eb8986556df6ab",
          },
          {
            price: 7.8,
            size: 1.32,
            _id: "67c90c3409eb8986556df6ac",
          },
        ],
        _id: "67c90c3409eb8986556df6a6",
      },
      {
        selectionId: "60443",
        backOdds: [
          {
            price: 4.1,
            size: 2.46,
            _id: "67c90c3409eb8986556df6ae",
          },
          {
            price: 3.5,
            size: 2.51,
            _id: "67c90c3409eb8986556df6af",
          },
          {
            price: 3.25,
            size: 2.35,
            _id: "67c90c3409eb8986556df6b0",
          },
        ],
        layOdds: [
          {
            price: 12,
            size: 1.97,
            _id: "67c90c3409eb8986556df6b1",
          },
          {
            price: 18.5,
            size: 1.04,
            _id: "67c90c3409eb8986556df6b2",
          },
          {
            price: 21,
            size: 1.17,
            _id: "67c90c3409eb8986556df6b3",
          },
        ],
        _id: "67c90c3409eb8986556df6ad",
      },
    ],
    _id: "67c90c3409eb8986556df69e",
  },
  {
    timestamp: "2025-03-06T02:45:09.000Z",
    runners: [
      {
        selectionId: "41690968",
        backOdds: [
          {
            price: 1.61,
            size: 1.79,
            _id: "67c90c3509eb8986556df7c7",
          },
          {
            price: 1.6,
            size: 4.19,
            _id: "67c90c3509eb8986556df7c8",
          },
          {
            price: 1.57,
            size: 16.76,
            _id: "67c90c3509eb8986556df7c9",
          },
        ],
        layOdds: [
          {
            price: 2.28,
            size: 12.67,
            _id: "67c90c3509eb8986556df7ca",
          },
          {
            price: 2.3,
            size: 2.93,
            _id: "67c90c3509eb8986556df7cb",
          },
          {
            price: 2.42,
            size: 1.02,
            _id: "67c90c3509eb8986556df7cc",
          },
        ],
        _id: "67c90c3509eb8986556df7c6",
      },
      {
        selectionId: "8928550",
        backOdds: [
          {
            price: 2.3,
            size: 41.72,
            _id: "67c90c3509eb8986556df7ce",
          },
          {
            price: 2.2,
            size: 4.19,
            _id: "67c90c3509eb8986556df7cf",
          },
          {
            price: 2.08,
            size: 15.56,
            _id: "67c90c3509eb8986556df7d0",
          },
        ],
        layOdds: [
          {
            price: 3.9,
            size: 1.98,
            _id: "67c90c3509eb8986556df7d1",
          },
          {
            price: 4,
            size: 19.93,
            _id: "67c90c3509eb8986556df7d2",
          },
          {
            price: 7.8,
            size: 1.32,
            _id: "67c90c3509eb8986556df7d3",
          },
        ],
        _id: "67c90c3509eb8986556df7cd",
      },
      {
        selectionId: "60443",
        backOdds: [
          {
            price: 4.1,
            size: 2.46,
            _id: "67c90c3509eb8986556df7d5",
          },
          {
            price: 3.5,
            size: 2.51,
            _id: "67c90c3509eb8986556df7d6",
          },
          {
            price: 3.25,
            size: 2.35,
            _id: "67c90c3509eb8986556df7d7",
          },
        ],
        layOdds: [
          {
            price: 12,
            size: 1.97,
            _id: "67c90c3509eb8986556df7d8",
          },
          {
            price: 18.5,
            size: 1.04,
            _id: "67c90c3509eb8986556df7d9",
          },
          {
            price: 21,
            size: 1.17,
            _id: "67c90c3509eb8986556df7da",
          },
        ],
        _id: "67c90c3509eb8986556df7d4",
      },
    ],
    _id: "67c90c3509eb8986556df7c5",
  },
  {
    timestamp: "2025-03-06T02:45:10.000Z",
    runners: [
      {
        selectionId: "41690968",
        backOdds: [
          {
            price: 1.61,
            size: 1.79,
            _id: "67c90c3609eb8986556df8a0",
          },
          {
            price: 1.6,
            size: 4.19,
            _id: "67c90c3609eb8986556df8a1",
          },
          {
            price: 1.57,
            size: 16.76,
            _id: "67c90c3609eb8986556df8a2",
          },
        ],
        layOdds: [
          {
            price: 2.28,
            size: 12.67,
            _id: "67c90c3609eb8986556df8a3",
          },
          {
            price: 2.3,
            size: 2.93,
            _id: "67c90c3609eb8986556df8a4",
          },
          {
            price: 2.42,
            size: 1.02,
            _id: "67c90c3609eb8986556df8a5",
          },
        ],
        _id: "67c90c3609eb8986556df89f",
      },
      {
        selectionId: "8928550",
        backOdds: [
          {
            price: 2.3,
            size: 41.72,
            _id: "67c90c3609eb8986556df8a7",
          },
          {
            price: 2.2,
            size: 4.19,
            _id: "67c90c3609eb8986556df8a8",
          },
          {
            price: 2.08,
            size: 15.56,
            _id: "67c90c3609eb8986556df8a9",
          },
        ],
        layOdds: [
          {
            price: 3.9,
            size: 1.98,
            _id: "67c90c3609eb8986556df8aa",
          },
          {
            price: 4,
            size: 19.93,
            _id: "67c90c3609eb8986556df8ab",
          },
          {
            price: 7.8,
            size: 1.32,
            _id: "67c90c3609eb8986556df8ac",
          },
        ],
        _id: "67c90c3609eb8986556df8a6",
      },
      {
        selectionId: "60443",
        backOdds: [
          {
            price: 4.1,
            size: 2.46,
            _id: "67c90c3609eb8986556df8ae",
          },
          {
            price: 3.5,
            size: 2.51,
            _id: "67c90c3609eb8986556df8af",
          },
          {
            price: 3.25,
            size: 2.35,
            _id: "67c90c3609eb8986556df8b0",
          },
        ],
        layOdds: [
          {
            price: 12,
            size: 1.97,
            _id: "67c90c3609eb8986556df8b1",
          },
          {
            price: 18.5,
            size: 1.04,
            _id: "67c90c3609eb8986556df8b2",
          },
          {
            price: 21,
            size: 1.17,
            _id: "67c90c3609eb8986556df8b3",
          },
        ],
        _id: "67c90c3609eb8986556df8ad",
      },
    ],
    _id: "67c90c3609eb8986556df89e",
  },
];
